var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// ../../node_modules/.pnpm/ajv@8.20.0/node_modules/ajv/dist/runtime/ucs2length.js
var require_ucs2length = __commonJS({
  "../../node_modules/.pnpm/ajv@8.20.0/node_modules/ajv/dist/runtime/ucs2length.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function ucs2length(str) {
      const len = str.length;
      let length = 0;
      let pos = 0;
      let value;
      while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 55296 && value <= 56319 && pos < len) {
          value = str.charCodeAt(pos);
          if ((value & 64512) === 56320)
            pos++;
        }
      }
      return length;
    }
    exports.default = ucs2length;
    ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
  }
});

// ../../node_modules/.pnpm/ajv-formats@3.0.1_ajv@8.20.0/node_modules/ajv-formats/dist/formats.js
var require_formats = __commonJS({
  "../../node_modules/.pnpm/ajv-formats@3.0.1_ajv@8.20.0/node_modules/ajv-formats/dist/formats.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.formatNames = exports.fastFormats = exports.fullFormats = void 0;
    function fmtDef(validate, compare) {
      return { validate, compare };
    }
    exports.fullFormats = {
      // date: http://tools.ietf.org/html/rfc3339#section-5.6
      date: fmtDef(date, compareDate),
      // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
      time: fmtDef(getTime(true), compareTime),
      "date-time": fmtDef(getDateTime(true), compareDateTime),
      "iso-time": fmtDef(getTime(), compareIsoTime),
      "iso-date-time": fmtDef(getDateTime(), compareIsoDateTime),
      // duration: https://tools.ietf.org/html/rfc3339#appendix-A
      duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
      uri,
      "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
      // uri-template: https://tools.ietf.org/html/rfc6570
      "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
      // For the source: https://gist.github.com/dperini/729294
      // For test cases: https://mathiasbynens.be/demo/url-regex
      url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
      email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
      hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
      // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
      ipv4: /^(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/,
      ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
      regex,
      // uuid: http://tools.ietf.org/html/rfc4122
      uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
      // JSON-pointer: https://tools.ietf.org/html/rfc6901
      // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
      "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
      "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
      // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
      "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
      // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
      // byte: https://github.com/miguelmota/is-base64
      byte,
      // signed 32 bit integer
      int32: { type: "number", validate: validateInt32 },
      // signed 64 bit integer
      int64: { type: "number", validate: validateInt64 },
      // C-type float
      float: { type: "number", validate: validateNumber },
      // C-type double
      double: { type: "number", validate: validateNumber },
      // hint to the UI to hide input strings
      password: true,
      // unchecked string payload
      binary: true
    };
    exports.fastFormats = {
      ...exports.fullFormats,
      date: fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, compareDate),
      time: fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, compareTime),
      "date-time": fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\dt(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, compareDateTime),
      "iso-time": fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, compareIsoTime),
      "iso-date-time": fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, compareIsoDateTime),
      // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
      uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
      "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
      // email (sources from jsen validator):
      // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
      // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
      email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
    };
    exports.formatNames = Object.keys(exports.fullFormats);
    function isLeapYear(year) {
      return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    }
    var DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
    var DAYS = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    function date(str) {
      const matches = DATE.exec(str);
      if (!matches)
        return false;
      const year = +matches[1];
      const month = +matches[2];
      const day = +matches[3];
      return month >= 1 && month <= 12 && day >= 1 && day <= (month === 2 && isLeapYear(year) ? 29 : DAYS[month]);
    }
    function compareDate(d1, d2) {
      if (!(d1 && d2))
        return void 0;
      if (d1 > d2)
        return 1;
      if (d1 < d2)
        return -1;
      return 0;
    }
    var TIME = /^(\d\d):(\d\d):(\d\d(?:\.\d+)?)(z|([+-])(\d\d)(?::?(\d\d))?)?$/i;
    function getTime(strictTimeZone) {
      return function time(str) {
        const matches = TIME.exec(str);
        if (!matches)
          return false;
        const hr = +matches[1];
        const min = +matches[2];
        const sec = +matches[3];
        const tz = matches[4];
        const tzSign = matches[5] === "-" ? -1 : 1;
        const tzH = +(matches[6] || 0);
        const tzM = +(matches[7] || 0);
        if (tzH > 23 || tzM > 59 || strictTimeZone && !tz)
          return false;
        if (hr <= 23 && min <= 59 && sec < 60)
          return true;
        const utcMin = min - tzM * tzSign;
        const utcHr = hr - tzH * tzSign - (utcMin < 0 ? 1 : 0);
        return (utcHr === 23 || utcHr === -1) && (utcMin === 59 || utcMin === -1) && sec < 61;
      };
    }
    function compareTime(s1, s2) {
      if (!(s1 && s2))
        return void 0;
      const t1 = (/* @__PURE__ */ new Date("2020-01-01T" + s1)).valueOf();
      const t2 = (/* @__PURE__ */ new Date("2020-01-01T" + s2)).valueOf();
      if (!(t1 && t2))
        return void 0;
      return t1 - t2;
    }
    function compareIsoTime(t1, t2) {
      if (!(t1 && t2))
        return void 0;
      const a1 = TIME.exec(t1);
      const a2 = TIME.exec(t2);
      if (!(a1 && a2))
        return void 0;
      t1 = a1[1] + a1[2] + a1[3];
      t2 = a2[1] + a2[2] + a2[3];
      if (t1 > t2)
        return 1;
      if (t1 < t2)
        return -1;
      return 0;
    }
    var DATE_TIME_SEPARATOR = /t|\s/i;
    function getDateTime(strictTimeZone) {
      const time = getTime(strictTimeZone);
      return function date_time(str) {
        const dateTime = str.split(DATE_TIME_SEPARATOR);
        return dateTime.length === 2 && date(dateTime[0]) && time(dateTime[1]);
      };
    }
    function compareDateTime(dt1, dt2) {
      if (!(dt1 && dt2))
        return void 0;
      const d1 = new Date(dt1).valueOf();
      const d2 = new Date(dt2).valueOf();
      if (!(d1 && d2))
        return void 0;
      return d1 - d2;
    }
    function compareIsoDateTime(dt1, dt2) {
      if (!(dt1 && dt2))
        return void 0;
      const [d1, t1] = dt1.split(DATE_TIME_SEPARATOR);
      const [d2, t2] = dt2.split(DATE_TIME_SEPARATOR);
      const res = compareDate(d1, d2);
      if (res === void 0)
        return void 0;
      return res || compareTime(t1, t2);
    }
    var NOT_URI_FRAGMENT = /\/|:/;
    var URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
    function uri(str) {
      return NOT_URI_FRAGMENT.test(str) && URI.test(str);
    }
    var BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
    function byte(str) {
      BYTE.lastIndex = 0;
      return BYTE.test(str);
    }
    var MIN_INT32 = -(2 ** 31);
    var MAX_INT32 = 2 ** 31 - 1;
    function validateInt32(value) {
      return Number.isInteger(value) && value <= MAX_INT32 && value >= MIN_INT32;
    }
    function validateInt64(value) {
      return Number.isInteger(value);
    }
    function validateNumber() {
      return true;
    }
    var Z_ANCHOR = /[^\\]\\Z/;
    function regex(str) {
      if (Z_ANCHOR.test(str))
        return false;
      try {
        new RegExp(str);
        return true;
      } catch (e) {
        return false;
      }
    }
  }
});

// validators.js
var validateInput0 = validate10;
var func2 = require_ucs2length().default;
function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.path === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "path" || key0 === "ifRevision")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.path !== void 0) {
      let data0 = data.path;
      if (typeof data0 === "string") {
        if (func2(data0) > 1024) {
          const err2 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/maxLength", keyword: "maxLength", params: { limit: 1024 }, message: "must NOT have more than 1024 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (func2(data0) < 1) {
          const err3 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      } else {
        const err4 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.ifRevision !== void 0) {
      let data1 = data.ifRevision;
      if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)) && isFinite(data1))) {
        const err5 = { instancePath: instancePath + "/ifRevision", schemaPath: "#/properties/ifRevision/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if (typeof data1 == "number" && isFinite(data1)) {
        if (data1 > 9007199254740991 || isNaN(data1)) {
          const err6 = { instancePath: instancePath + "/ifRevision", schemaPath: "#/properties/ifRevision/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
        if (data1 <= 0 || isNaN(data1)) {
          const err7 = { instancePath: instancePath + "/ifRevision", schemaPath: "#/properties/ifRevision/exclusiveMinimum", keyword: "exclusiveMinimum", params: { comparison: ">", limit: 0 }, message: "must be > 0" };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      }
    }
  } else {
    const err8 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
  }
  validate10.errors = vErrors;
  return errors === 0;
}
var validateOutput0 = validate11;
function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.path === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.deleted === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "deleted" }, message: "must have required property 'deleted'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "path" || key0 === "deleted")) {
        const err3 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err4 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if ("file" !== data0) {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "file" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.path !== void 0) {
      if (typeof data.path !== "string") {
        const err6 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.deleted !== void 0) {
      let data2 = data.deleted;
      if (typeof data2 !== "boolean") {
        const err7 = { instancePath: instancePath + "/deleted", schemaPath: "#/properties/deleted/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if (true !== data2) {
        const err8 = { instancePath: instancePath + "/deleted", schemaPath: "#/properties/deleted/const", keyword: "const", params: { allowedValue: true }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
  } else {
    const err9 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err9];
    } else {
      vErrors.push(err9);
    }
    errors++;
  }
  validate11.errors = vErrors;
  return errors === 0;
}
var validateInput1 = validate12;
function validate12(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      if (!(key0 === "limit")) {
        const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.limit !== void 0) {
      let data0 = data.limit;
      if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)) && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (typeof data0 == "number" && isFinite(data0)) {
        if (data0 > 100 || isNaN(data0)) {
          const err2 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 100 }, message: "must be <= 100" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (data0 < 1 || isNaN(data0)) {
          const err3 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate12.errors = vErrors;
  return errors === 0;
}
var validateOutput1 = validate13;
var schema14 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "object": { "type": "string", "const": "list" }, "data": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "agent_run" }, "userId": { "type": "string" }, "prompt": { "type": "string" }, "status": { "type": "string", "enum": ["queued", "running", "completed", "failed", "cancelled"] }, "output": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "error": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "completedAt": { "anyOf": [{ "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, { "type": "null" }] } }, "required": ["id", "object", "userId", "prompt", "status", "output", "error", "createdAt", "completedAt"], "additionalProperties": false } }, "has_more": { "type": "boolean" }, "url": { "type": "string" } }, "required": ["object", "data", "has_more", "url"], "additionalProperties": false };
var func4 = Object.prototype.hasOwnProperty;
var formats0 = require_formats().fullFormats["date-time"];
var pattern0 = new RegExp("^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$", "u");
function validate13(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.data === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property 'data'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.has_more === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "has_more" }, message: "must have required property 'has_more'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.url === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "data" || key0 === "has_more" || key0 === "url")) {
        const err4 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if ("list" !== data0) {
        const err6 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "list" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.data !== void 0) {
      let data1 = data.data;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.id === void 0) {
              const err7 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            if (data2.object === void 0) {
              const err8 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (data2.userId === void 0) {
              const err9 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            if (data2.prompt === void 0) {
              const err10 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if (data2.status === void 0) {
              const err11 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if (data2.output === void 0) {
              const err12 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "output" }, message: "must have required property 'output'" };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if (data2.error === void 0) {
              const err13 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "error" }, message: "must have required property 'error'" };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
            }
            if (data2.createdAt === void 0) {
              const err14 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
              if (vErrors === null) {
                vErrors = [err14];
              } else {
                vErrors.push(err14);
              }
              errors++;
            }
            if (data2.completedAt === void 0) {
              const err15 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "completedAt" }, message: "must have required property 'completedAt'" };
              if (vErrors === null) {
                vErrors = [err15];
              } else {
                vErrors.push(err15);
              }
              errors++;
            }
            for (const key1 in data2) {
              if (!func4.call(schema14.properties.data.items.properties, key1)) {
                const err16 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
            }
            if (data2.id !== void 0) {
              if (typeof data2.id !== "string") {
                const err17 = { instancePath: instancePath + "/data/" + i0 + "/id", schemaPath: "#/properties/data/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
            }
            if (data2.object !== void 0) {
              let data4 = data2.object;
              if (typeof data4 !== "string") {
                const err18 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/properties/data/items/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
              if ("agent_run" !== data4) {
                const err19 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/properties/data/items/properties/object/const", keyword: "const", params: { allowedValue: "agent_run" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
            }
            if (data2.userId !== void 0) {
              if (typeof data2.userId !== "string") {
                const err20 = { instancePath: instancePath + "/data/" + i0 + "/userId", schemaPath: "#/properties/data/items/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
            }
            if (data2.prompt !== void 0) {
              if (typeof data2.prompt !== "string") {
                const err21 = { instancePath: instancePath + "/data/" + i0 + "/prompt", schemaPath: "#/properties/data/items/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err21];
                } else {
                  vErrors.push(err21);
                }
                errors++;
              }
            }
            if (data2.status !== void 0) {
              let data7 = data2.status;
              if (typeof data7 !== "string") {
                const err22 = { instancePath: instancePath + "/data/" + i0 + "/status", schemaPath: "#/properties/data/items/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
              if (!(data7 === "queued" || data7 === "running" || data7 === "completed" || data7 === "failed" || data7 === "cancelled")) {
                const err23 = { instancePath: instancePath + "/data/" + i0 + "/status", schemaPath: "#/properties/data/items/properties/status/enum", keyword: "enum", params: { allowedValues: schema14.properties.data.items.properties.status.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
            if (data2.output !== void 0) {
              let data8 = data2.output;
              const _errs20 = errors;
              let valid4 = false;
              const _errs21 = errors;
              if (typeof data8 !== "string") {
                const err24 = { instancePath: instancePath + "/data/" + i0 + "/output", schemaPath: "#/properties/data/items/properties/output/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err24];
                } else {
                  vErrors.push(err24);
                }
                errors++;
              }
              var _valid0 = _errs21 === errors;
              valid4 = valid4 || _valid0;
              if (!valid4) {
                const _errs23 = errors;
                if (data8 !== null) {
                  const err25 = { instancePath: instancePath + "/data/" + i0 + "/output", schemaPath: "#/properties/data/items/properties/output/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err25];
                  } else {
                    vErrors.push(err25);
                  }
                  errors++;
                }
                var _valid0 = _errs23 === errors;
                valid4 = valid4 || _valid0;
              }
              if (!valid4) {
                const err26 = { instancePath: instancePath + "/data/" + i0 + "/output", schemaPath: "#/properties/data/items/properties/output/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err26];
                } else {
                  vErrors.push(err26);
                }
                errors++;
              } else {
                errors = _errs20;
                if (vErrors !== null) {
                  if (_errs20) {
                    vErrors.length = _errs20;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data2.error !== void 0) {
              let data9 = data2.error;
              const _errs26 = errors;
              let valid5 = false;
              const _errs27 = errors;
              if (typeof data9 !== "string") {
                const err27 = { instancePath: instancePath + "/data/" + i0 + "/error", schemaPath: "#/properties/data/items/properties/error/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
              var _valid1 = _errs27 === errors;
              valid5 = valid5 || _valid1;
              if (!valid5) {
                const _errs29 = errors;
                if (data9 !== null) {
                  const err28 = { instancePath: instancePath + "/data/" + i0 + "/error", schemaPath: "#/properties/data/items/properties/error/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err28];
                  } else {
                    vErrors.push(err28);
                  }
                  errors++;
                }
                var _valid1 = _errs29 === errors;
                valid5 = valid5 || _valid1;
              }
              if (!valid5) {
                const err29 = { instancePath: instancePath + "/data/" + i0 + "/error", schemaPath: "#/properties/data/items/properties/error/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err29];
                } else {
                  vErrors.push(err29);
                }
                errors++;
              } else {
                errors = _errs26;
                if (vErrors !== null) {
                  if (_errs26) {
                    vErrors.length = _errs26;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data2.createdAt !== void 0) {
              let data10 = data2.createdAt;
              if (typeof data10 === "string") {
                if (!pattern0.test(data10)) {
                  const err30 = { instancePath: instancePath + "/data/" + i0 + "/createdAt", schemaPath: "#/properties/data/items/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err30];
                  } else {
                    vErrors.push(err30);
                  }
                  errors++;
                }
                if (!formats0.validate(data10)) {
                  const err31 = { instancePath: instancePath + "/data/" + i0 + "/createdAt", schemaPath: "#/properties/data/items/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err31];
                  } else {
                    vErrors.push(err31);
                  }
                  errors++;
                }
              } else {
                const err32 = { instancePath: instancePath + "/data/" + i0 + "/createdAt", schemaPath: "#/properties/data/items/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err32];
                } else {
                  vErrors.push(err32);
                }
                errors++;
              }
            }
            if (data2.completedAt !== void 0) {
              let data11 = data2.completedAt;
              const _errs34 = errors;
              let valid6 = false;
              const _errs35 = errors;
              if (typeof data11 === "string") {
                if (!pattern0.test(data11)) {
                  const err33 = { instancePath: instancePath + "/data/" + i0 + "/completedAt", schemaPath: "#/properties/data/items/properties/completedAt/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err33];
                  } else {
                    vErrors.push(err33);
                  }
                  errors++;
                }
                if (!formats0.validate(data11)) {
                  const err34 = { instancePath: instancePath + "/data/" + i0 + "/completedAt", schemaPath: "#/properties/data/items/properties/completedAt/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err34];
                  } else {
                    vErrors.push(err34);
                  }
                  errors++;
                }
              } else {
                const err35 = { instancePath: instancePath + "/data/" + i0 + "/completedAt", schemaPath: "#/properties/data/items/properties/completedAt/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err35];
                } else {
                  vErrors.push(err35);
                }
                errors++;
              }
              var _valid2 = _errs35 === errors;
              valid6 = valid6 || _valid2;
              if (!valid6) {
                const _errs37 = errors;
                if (data11 !== null) {
                  const err36 = { instancePath: instancePath + "/data/" + i0 + "/completedAt", schemaPath: "#/properties/data/items/properties/completedAt/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err36];
                  } else {
                    vErrors.push(err36);
                  }
                  errors++;
                }
                var _valid2 = _errs37 === errors;
                valid6 = valid6 || _valid2;
              }
              if (!valid6) {
                const err37 = { instancePath: instancePath + "/data/" + i0 + "/completedAt", schemaPath: "#/properties/data/items/properties/completedAt/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err37];
                } else {
                  vErrors.push(err37);
                }
                errors++;
              } else {
                errors = _errs34;
                if (vErrors !== null) {
                  if (_errs34) {
                    vErrors.length = _errs34;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
          } else {
            const err38 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err38];
            } else {
              vErrors.push(err38);
            }
            errors++;
          }
        }
      } else {
        const err39 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err39];
        } else {
          vErrors.push(err39);
        }
        errors++;
      }
    }
    if (data.has_more !== void 0) {
      if (typeof data.has_more !== "boolean") {
        const err40 = { instancePath: instancePath + "/has_more", schemaPath: "#/properties/has_more/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err40];
        } else {
          vErrors.push(err40);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      if (typeof data.url !== "string") {
        const err41 = { instancePath: instancePath + "/url", schemaPath: "#/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err41];
        } else {
          vErrors.push(err41);
        }
        errors++;
      }
    }
  } else {
    const err42 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err42];
    } else {
      vErrors.push(err42);
    }
    errors++;
  }
  validate13.errors = vErrors;
  return errors === 0;
}
var validateInput2 = validate14;
function validate14(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      let data0 = data.id;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err2 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate14.errors = vErrors;
  return errors === 0;
}
var validateOutput2 = validate15;
var schema16 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "agent_run" }, "userId": { "type": "string" }, "prompt": { "type": "string" }, "status": { "type": "string", "enum": ["queued", "running", "completed", "failed", "cancelled"] }, "output": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "error": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "completedAt": { "anyOf": [{ "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, { "type": "null" }] } }, "required": ["id", "object", "userId", "prompt", "status", "output", "error", "createdAt", "completedAt"], "additionalProperties": false };
function validate15(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.object === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.userId === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.prompt === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.status === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.output === void 0) {
      const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "output" }, message: "must have required property 'output'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.error === void 0) {
      const err6 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "error" }, message: "must have required property 'error'" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.createdAt === void 0) {
      const err7 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.completedAt === void 0) {
      const err8 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "completedAt" }, message: "must have required property 'completedAt'" };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!func4.call(schema16.properties, key0)) {
        const err9 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err10 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data1 = data.object;
      if (typeof data1 !== "string") {
        const err11 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if ("agent_run" !== data1) {
        const err12 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "agent_run" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err13 = { instancePath: instancePath + "/userId", schemaPath: "#/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.prompt !== void 0) {
      if (typeof data.prompt !== "string") {
        const err14 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.status !== void 0) {
      let data4 = data.status;
      if (typeof data4 !== "string") {
        const err15 = { instancePath: instancePath + "/status", schemaPath: "#/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
      if (!(data4 === "queued" || data4 === "running" || data4 === "completed" || data4 === "failed" || data4 === "cancelled")) {
        const err16 = { instancePath: instancePath + "/status", schemaPath: "#/properties/status/enum", keyword: "enum", params: { allowedValues: schema16.properties.status.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.output !== void 0) {
      let data5 = data.output;
      const _errs13 = errors;
      let valid1 = false;
      const _errs14 = errors;
      if (typeof data5 !== "string") {
        const err17 = { instancePath: instancePath + "/output", schemaPath: "#/properties/output/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
      var _valid0 = _errs14 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs16 = errors;
        if (data5 !== null) {
          const err18 = { instancePath: instancePath + "/output", schemaPath: "#/properties/output/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        var _valid0 = _errs16 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err19 = { instancePath: instancePath + "/output", schemaPath: "#/properties/output/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      } else {
        errors = _errs13;
        if (vErrors !== null) {
          if (_errs13) {
            vErrors.length = _errs13;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.error !== void 0) {
      let data6 = data.error;
      const _errs19 = errors;
      let valid2 = false;
      const _errs20 = errors;
      if (typeof data6 !== "string") {
        const err20 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
      var _valid1 = _errs20 === errors;
      valid2 = valid2 || _valid1;
      if (!valid2) {
        const _errs22 = errors;
        if (data6 !== null) {
          const err21 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        var _valid1 = _errs22 === errors;
        valid2 = valid2 || _valid1;
      }
      if (!valid2) {
        const err22 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err22];
        } else {
          vErrors.push(err22);
        }
        errors++;
      } else {
        errors = _errs19;
        if (vErrors !== null) {
          if (_errs19) {
            vErrors.length = _errs19;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.createdAt !== void 0) {
      let data7 = data.createdAt;
      if (typeof data7 === "string") {
        if (!pattern0.test(data7)) {
          const err23 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err23];
          } else {
            vErrors.push(err23);
          }
          errors++;
        }
        if (!formats0.validate(data7)) {
          const err24 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err24];
          } else {
            vErrors.push(err24);
          }
          errors++;
        }
      } else {
        const err25 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
    }
    if (data.completedAt !== void 0) {
      let data8 = data.completedAt;
      const _errs27 = errors;
      let valid3 = false;
      const _errs28 = errors;
      if (typeof data8 === "string") {
        if (!pattern0.test(data8)) {
          const err26 = { instancePath: instancePath + "/completedAt", schemaPath: "#/properties/completedAt/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err26];
          } else {
            vErrors.push(err26);
          }
          errors++;
        }
        if (!formats0.validate(data8)) {
          const err27 = { instancePath: instancePath + "/completedAt", schemaPath: "#/properties/completedAt/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err27];
          } else {
            vErrors.push(err27);
          }
          errors++;
        }
      } else {
        const err28 = { instancePath: instancePath + "/completedAt", schemaPath: "#/properties/completedAt/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
      var _valid2 = _errs28 === errors;
      valid3 = valid3 || _valid2;
      if (!valid3) {
        const _errs30 = errors;
        if (data8 !== null) {
          const err29 = { instancePath: instancePath + "/completedAt", schemaPath: "#/properties/completedAt/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err29];
          } else {
            vErrors.push(err29);
          }
          errors++;
        }
        var _valid2 = _errs30 === errors;
        valid3 = valid3 || _valid2;
      }
      if (!valid3) {
        const err30 = { instancePath: instancePath + "/completedAt", schemaPath: "#/properties/completedAt/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err30];
        } else {
          vErrors.push(err30);
        }
        errors++;
      } else {
        errors = _errs27;
        if (vErrors !== null) {
          if (_errs27) {
            vErrors.length = _errs27;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err31 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err31];
    } else {
      vErrors.push(err31);
    }
    errors++;
  }
  validate15.errors = vErrors;
  return errors === 0;
}
var validateInput3 = validate16;
function validate16(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      if (!(key0 === "limit")) {
        const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.limit !== void 0) {
      let data0 = data.limit;
      if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)) && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (typeof data0 == "number" && isFinite(data0)) {
        if (data0 > 100 || isNaN(data0)) {
          const err2 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 100 }, message: "must be <= 100" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (data0 < 1 || isNaN(data0)) {
          const err3 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate16.errors = vErrors;
  return errors === 0;
}
var validateOutput3 = validate17;
function validate17(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.data === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property 'data'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.has_more === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "has_more" }, message: "must have required property 'has_more'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.url === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "data" || key0 === "has_more" || key0 === "url")) {
        const err4 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if ("list" !== data0) {
        const err6 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "list" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.data !== void 0) {
      let data1 = data.data;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.id === void 0) {
              const err7 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            if (data2.object === void 0) {
              const err8 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (data2.userId === void 0) {
              const err9 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            if (data2.title === void 0) {
              const err10 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if (data2.configuration === void 0) {
              const err11 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "configuration" }, message: "must have required property 'configuration'" };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if (data2.createdAt === void 0) {
              const err12 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if (data2.updatedAt === void 0) {
              const err13 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "updatedAt" }, message: "must have required property 'updatedAt'" };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
            }
            for (const key1 in data2) {
              if (!(key1 === "id" || key1 === "object" || key1 === "userId" || key1 === "title" || key1 === "configuration" || key1 === "createdAt" || key1 === "updatedAt")) {
                const err14 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
            if (data2.id !== void 0) {
              if (typeof data2.id !== "string") {
                const err15 = { instancePath: instancePath + "/data/" + i0 + "/id", schemaPath: "#/properties/data/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
            }
            if (data2.object !== void 0) {
              let data4 = data2.object;
              if (typeof data4 !== "string") {
                const err16 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/properties/data/items/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
              if ("conversation" !== data4) {
                const err17 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/properties/data/items/properties/object/const", keyword: "const", params: { allowedValue: "conversation" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
            }
            if (data2.userId !== void 0) {
              if (typeof data2.userId !== "string") {
                const err18 = { instancePath: instancePath + "/data/" + i0 + "/userId", schemaPath: "#/properties/data/items/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
            }
            if (data2.title !== void 0) {
              if (typeof data2.title !== "string") {
                const err19 = { instancePath: instancePath + "/data/" + i0 + "/title", schemaPath: "#/properties/data/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
            }
            if (data2.configuration !== void 0) {
              if (typeof data2.configuration !== "string") {
                const err20 = { instancePath: instancePath + "/data/" + i0 + "/configuration", schemaPath: "#/properties/data/items/properties/configuration/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
            }
            if (data2.createdAt !== void 0) {
              let data8 = data2.createdAt;
              if (typeof data8 === "string") {
                if (!pattern0.test(data8)) {
                  const err21 = { instancePath: instancePath + "/data/" + i0 + "/createdAt", schemaPath: "#/properties/data/items/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err21];
                  } else {
                    vErrors.push(err21);
                  }
                  errors++;
                }
                if (!formats0.validate(data8)) {
                  const err22 = { instancePath: instancePath + "/data/" + i0 + "/createdAt", schemaPath: "#/properties/data/items/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err22];
                  } else {
                    vErrors.push(err22);
                  }
                  errors++;
                }
              } else {
                const err23 = { instancePath: instancePath + "/data/" + i0 + "/createdAt", schemaPath: "#/properties/data/items/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
            if (data2.updatedAt !== void 0) {
              let data9 = data2.updatedAt;
              if (typeof data9 === "string") {
                if (!pattern0.test(data9)) {
                  const err24 = { instancePath: instancePath + "/data/" + i0 + "/updatedAt", schemaPath: "#/properties/data/items/properties/updatedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err24];
                  } else {
                    vErrors.push(err24);
                  }
                  errors++;
                }
                if (!formats0.validate(data9)) {
                  const err25 = { instancePath: instancePath + "/data/" + i0 + "/updatedAt", schemaPath: "#/properties/data/items/properties/updatedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err25];
                  } else {
                    vErrors.push(err25);
                  }
                  errors++;
                }
              } else {
                const err26 = { instancePath: instancePath + "/data/" + i0 + "/updatedAt", schemaPath: "#/properties/data/items/properties/updatedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err26];
                } else {
                  vErrors.push(err26);
                }
                errors++;
              }
            }
          } else {
            const err27 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          }
        }
      } else {
        const err28 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
    }
    if (data.has_more !== void 0) {
      if (typeof data.has_more !== "boolean") {
        const err29 = { instancePath: instancePath + "/has_more", schemaPath: "#/properties/has_more/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err29];
        } else {
          vErrors.push(err29);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      if (typeof data.url !== "string") {
        const err30 = { instancePath: instancePath + "/url", schemaPath: "#/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err30];
        } else {
          vErrors.push(err30);
        }
        errors++;
      }
    }
  } else {
    const err31 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err31];
    } else {
      vErrors.push(err31);
    }
    errors++;
  }
  validate17.errors = vErrors;
  return errors === 0;
}
var validateInput4 = validate18;
function validate18(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      let data0 = data.id;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err2 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate18.errors = vErrors;
  return errors === 0;
}
var validateOutput4 = validate19;
var schema20 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "conversation" }, "userId": { "type": "string" }, "title": { "type": "string" }, "configuration": { "type": "string" }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "updatedAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "runs": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "agent_run" }, "userId": { "type": "string" }, "prompt": { "type": "string" }, "status": { "type": "string", "enum": ["queued", "running", "completed", "failed", "cancelled"] }, "output": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "error": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "completedAt": { "anyOf": [{ "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, { "type": "null" }] }, "conversationId": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "turnNumber": { "anyOf": [{ "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, { "type": "null" }] }, "historyBoundary": { "anyOf": [{ "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, { "type": "null" }] } }, "required": ["id", "object", "userId", "prompt", "status", "output", "error", "createdAt", "completedAt", "conversationId", "turnNumber", "historyBoundary"], "additionalProperties": false } }, "messages": { "type": "array", "items": { "type": "object", "properties": { "runId": { "type": "string" }, "messageIndex": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "payload": { "oneOf": [{ "type": "object", "properties": { "role": { "type": "string", "const": "user" }, "content": { "type": "string" } }, "required": ["role", "content"], "additionalProperties": false }, { "type": "object", "properties": { "role": { "type": "string", "const": "assistant" }, "content": { "type": "string" }, "toolCalls": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string" }, "thought": { "type": "string" }, "source": { "type": "string" } }, "required": ["id", "thought", "source"], "additionalProperties": false } } }, "required": ["role", "content", "toolCalls"], "additionalProperties": false }, { "type": "object", "properties": { "role": { "type": "string", "const": "tool" }, "toolCallId": { "type": "string" }, "content": { "type": "string" }, "isError": { "type": "boolean" }, "resources": { "type": "array", "items": { "type": "object", "properties": { "path": { "type": "string" } }, "required": ["path"], "additionalProperties": false } } }, "required": ["role", "toolCallId", "content"], "additionalProperties": false }] } }, "required": ["runId", "messageIndex", "payload"], "additionalProperties": false } }, "submittedPlans": { "type": "array", "items": { "type": "object", "properties": { "path": { "type": "string" }, "runId": { "type": "string" }, "plan": { "type": "object", "properties": { "id": { "type": "string", "minLength": 1 }, "kind": { "type": "string", "const": "treatment-plan" }, "draft": { "type": "boolean" }, "title": { "type": "string" }, "planDate": { "type": "string" }, "status": { "type": "string", "enum": ["draft", "reviewed", "final"] }, "patientName": { "type": "string" }, "patientBirthDate": { "type": "string" }, "planNumber": { "type": "string" }, "patientAddress": { "type": "string" }, "consumablesEstimate": { "type": "number", "minimum": 0 }, "labCostsEstimate": { "type": "number", "minimum": 0 }, "rows": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string", "minLength": 1 }, "gozNumber": { "type": "string", "description": "The four-digit GOZ number." }, "description": { "type": "string" }, "toothOrRegion": { "type": "string", "description": "The teeth the row covers, comma-separated (14,13,12), or a region such as OK." }, "quantity": { "type": "number", "exclusiveMinimum": 0, "description": "Billable units, as a number: one per tooth, jaw or session billed." }, "factor": { "type": "number", "description": "The GOZ factor; 2.3 is the threshold, and above it needs a justification." }, "amount": { "type": "number", "minimum": 0, "description": "The row's total in euros: the position's amount at `factor`, times `quantity`." }, "justification": { "type": "string" }, "analogReference": { "type": "string" }, "materials": { "type": "string" }, "notes": { "type": "string" } }, "required": ["id", "gozNumber", "description", "toothOrRegion", "quantity", "factor", "amount", "justification", "analogReference", "materials", "notes"], "additionalProperties": false } } }, "required": ["id", "kind", "title", "planDate", "status", "rows"], "additionalProperties": false }, "findings": { "type": "array", "items": { "type": "object", "properties": { "severity": { "type": "string", "enum": ["warning", "review"] }, "ruleId": { "type": "string", "description": "`goz:rule:paragraph-<n>` or `goz:rule:section-<letter>-general`. The finding's ruleTitle and citation usually suffice; retrieve the rule only for its legal text." }, "message": { "type": "string" }, "rowIds": { "type": "array", "items": { "type": "string" } }, "citation": { "type": "object", "properties": { "page": { "type": "number" }, "section": { "type": "string" }, "lineText": { "type": "string" } }, "required": ["page"], "additionalProperties": false } }, "required": ["severity", "ruleId", "message", "rowIds", "citation"], "additionalProperties": false } } }, "required": ["path", "runId", "plan", "findings"], "additionalProperties": false } }, "canContinue": { "type": "boolean" } }, "required": ["id", "object", "userId", "title", "configuration", "createdAt", "updatedAt", "runs", "messages", "submittedPlans", "canContinue"], "additionalProperties": false };
function validate19(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.object === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.userId === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.title === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.configuration === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "configuration" }, message: "must have required property 'configuration'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.createdAt === void 0) {
      const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.updatedAt === void 0) {
      const err6 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "updatedAt" }, message: "must have required property 'updatedAt'" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.runs === void 0) {
      const err7 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "runs" }, message: "must have required property 'runs'" };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.messages === void 0) {
      const err8 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "messages" }, message: "must have required property 'messages'" };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.submittedPlans === void 0) {
      const err9 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "submittedPlans" }, message: "must have required property 'submittedPlans'" };
      if (vErrors === null) {
        vErrors = [err9];
      } else {
        vErrors.push(err9);
      }
      errors++;
    }
    if (data.canContinue === void 0) {
      const err10 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "canContinue" }, message: "must have required property 'canContinue'" };
      if (vErrors === null) {
        vErrors = [err10];
      } else {
        vErrors.push(err10);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!func4.call(schema20.properties, key0)) {
        const err11 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err12 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data1 = data.object;
      if (typeof data1 !== "string") {
        const err13 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
      if ("conversation" !== data1) {
        const err14 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "conversation" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err15 = { instancePath: instancePath + "/userId", schemaPath: "#/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
    if (data.title !== void 0) {
      if (typeof data.title !== "string") {
        const err16 = { instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.configuration !== void 0) {
      if (typeof data.configuration !== "string") {
        const err17 = { instancePath: instancePath + "/configuration", schemaPath: "#/properties/configuration/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.createdAt !== void 0) {
      let data5 = data.createdAt;
      if (typeof data5 === "string") {
        if (!pattern0.test(data5)) {
          const err18 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        if (!formats0.validate(data5)) {
          const err19 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
      } else {
        const err20 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
    if (data.updatedAt !== void 0) {
      let data6 = data.updatedAt;
      if (typeof data6 === "string") {
        if (!pattern0.test(data6)) {
          const err21 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        if (!formats0.validate(data6)) {
          const err22 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
      } else {
        const err23 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err23];
        } else {
          vErrors.push(err23);
        }
        errors++;
      }
    }
    if (data.runs !== void 0) {
      let data7 = data.runs;
      if (Array.isArray(data7)) {
        const len0 = data7.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data8 = data7[i0];
          if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
            if (data8.id === void 0) {
              const err24 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
              if (vErrors === null) {
                vErrors = [err24];
              } else {
                vErrors.push(err24);
              }
              errors++;
            }
            if (data8.object === void 0) {
              const err25 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
              if (vErrors === null) {
                vErrors = [err25];
              } else {
                vErrors.push(err25);
              }
              errors++;
            }
            if (data8.userId === void 0) {
              const err26 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
              if (vErrors === null) {
                vErrors = [err26];
              } else {
                vErrors.push(err26);
              }
              errors++;
            }
            if (data8.prompt === void 0) {
              const err27 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
              if (vErrors === null) {
                vErrors = [err27];
              } else {
                vErrors.push(err27);
              }
              errors++;
            }
            if (data8.status === void 0) {
              const err28 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
              if (vErrors === null) {
                vErrors = [err28];
              } else {
                vErrors.push(err28);
              }
              errors++;
            }
            if (data8.output === void 0) {
              const err29 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "output" }, message: "must have required property 'output'" };
              if (vErrors === null) {
                vErrors = [err29];
              } else {
                vErrors.push(err29);
              }
              errors++;
            }
            if (data8.error === void 0) {
              const err30 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "error" }, message: "must have required property 'error'" };
              if (vErrors === null) {
                vErrors = [err30];
              } else {
                vErrors.push(err30);
              }
              errors++;
            }
            if (data8.createdAt === void 0) {
              const err31 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
              if (vErrors === null) {
                vErrors = [err31];
              } else {
                vErrors.push(err31);
              }
              errors++;
            }
            if (data8.completedAt === void 0) {
              const err32 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "completedAt" }, message: "must have required property 'completedAt'" };
              if (vErrors === null) {
                vErrors = [err32];
              } else {
                vErrors.push(err32);
              }
              errors++;
            }
            if (data8.conversationId === void 0) {
              const err33 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
              if (vErrors === null) {
                vErrors = [err33];
              } else {
                vErrors.push(err33);
              }
              errors++;
            }
            if (data8.turnNumber === void 0) {
              const err34 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "turnNumber" }, message: "must have required property 'turnNumber'" };
              if (vErrors === null) {
                vErrors = [err34];
              } else {
                vErrors.push(err34);
              }
              errors++;
            }
            if (data8.historyBoundary === void 0) {
              const err35 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "historyBoundary" }, message: "must have required property 'historyBoundary'" };
              if (vErrors === null) {
                vErrors = [err35];
              } else {
                vErrors.push(err35);
              }
              errors++;
            }
            for (const key1 in data8) {
              if (!func4.call(schema20.properties.runs.items.properties, key1)) {
                const err36 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err36];
                } else {
                  vErrors.push(err36);
                }
                errors++;
              }
            }
            if (data8.id !== void 0) {
              if (typeof data8.id !== "string") {
                const err37 = { instancePath: instancePath + "/runs/" + i0 + "/id", schemaPath: "#/properties/runs/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err37];
                } else {
                  vErrors.push(err37);
                }
                errors++;
              }
            }
            if (data8.object !== void 0) {
              let data10 = data8.object;
              if (typeof data10 !== "string") {
                const err38 = { instancePath: instancePath + "/runs/" + i0 + "/object", schemaPath: "#/properties/runs/items/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err38];
                } else {
                  vErrors.push(err38);
                }
                errors++;
              }
              if ("agent_run" !== data10) {
                const err39 = { instancePath: instancePath + "/runs/" + i0 + "/object", schemaPath: "#/properties/runs/items/properties/object/const", keyword: "const", params: { allowedValue: "agent_run" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err39];
                } else {
                  vErrors.push(err39);
                }
                errors++;
              }
            }
            if (data8.userId !== void 0) {
              if (typeof data8.userId !== "string") {
                const err40 = { instancePath: instancePath + "/runs/" + i0 + "/userId", schemaPath: "#/properties/runs/items/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err40];
                } else {
                  vErrors.push(err40);
                }
                errors++;
              }
            }
            if (data8.prompt !== void 0) {
              if (typeof data8.prompt !== "string") {
                const err41 = { instancePath: instancePath + "/runs/" + i0 + "/prompt", schemaPath: "#/properties/runs/items/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err41];
                } else {
                  vErrors.push(err41);
                }
                errors++;
              }
            }
            if (data8.status !== void 0) {
              let data13 = data8.status;
              if (typeof data13 !== "string") {
                const err42 = { instancePath: instancePath + "/runs/" + i0 + "/status", schemaPath: "#/properties/runs/items/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err42];
                } else {
                  vErrors.push(err42);
                }
                errors++;
              }
              if (!(data13 === "queued" || data13 === "running" || data13 === "completed" || data13 === "failed" || data13 === "cancelled")) {
                const err43 = { instancePath: instancePath + "/runs/" + i0 + "/status", schemaPath: "#/properties/runs/items/properties/status/enum", keyword: "enum", params: { allowedValues: schema20.properties.runs.items.properties.status.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err43];
                } else {
                  vErrors.push(err43);
                }
                errors++;
              }
            }
            if (data8.output !== void 0) {
              let data14 = data8.output;
              const _errs32 = errors;
              let valid4 = false;
              const _errs33 = errors;
              if (typeof data14 !== "string") {
                const err44 = { instancePath: instancePath + "/runs/" + i0 + "/output", schemaPath: "#/properties/runs/items/properties/output/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err44];
                } else {
                  vErrors.push(err44);
                }
                errors++;
              }
              var _valid0 = _errs33 === errors;
              valid4 = valid4 || _valid0;
              if (!valid4) {
                const _errs35 = errors;
                if (data14 !== null) {
                  const err45 = { instancePath: instancePath + "/runs/" + i0 + "/output", schemaPath: "#/properties/runs/items/properties/output/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err45];
                  } else {
                    vErrors.push(err45);
                  }
                  errors++;
                }
                var _valid0 = _errs35 === errors;
                valid4 = valid4 || _valid0;
              }
              if (!valid4) {
                const err46 = { instancePath: instancePath + "/runs/" + i0 + "/output", schemaPath: "#/properties/runs/items/properties/output/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err46];
                } else {
                  vErrors.push(err46);
                }
                errors++;
              } else {
                errors = _errs32;
                if (vErrors !== null) {
                  if (_errs32) {
                    vErrors.length = _errs32;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data8.error !== void 0) {
              let data15 = data8.error;
              const _errs38 = errors;
              let valid5 = false;
              const _errs39 = errors;
              if (typeof data15 !== "string") {
                const err47 = { instancePath: instancePath + "/runs/" + i0 + "/error", schemaPath: "#/properties/runs/items/properties/error/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err47];
                } else {
                  vErrors.push(err47);
                }
                errors++;
              }
              var _valid1 = _errs39 === errors;
              valid5 = valid5 || _valid1;
              if (!valid5) {
                const _errs41 = errors;
                if (data15 !== null) {
                  const err48 = { instancePath: instancePath + "/runs/" + i0 + "/error", schemaPath: "#/properties/runs/items/properties/error/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err48];
                  } else {
                    vErrors.push(err48);
                  }
                  errors++;
                }
                var _valid1 = _errs41 === errors;
                valid5 = valid5 || _valid1;
              }
              if (!valid5) {
                const err49 = { instancePath: instancePath + "/runs/" + i0 + "/error", schemaPath: "#/properties/runs/items/properties/error/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err49];
                } else {
                  vErrors.push(err49);
                }
                errors++;
              } else {
                errors = _errs38;
                if (vErrors !== null) {
                  if (_errs38) {
                    vErrors.length = _errs38;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data8.createdAt !== void 0) {
              let data16 = data8.createdAt;
              if (typeof data16 === "string") {
                if (!pattern0.test(data16)) {
                  const err50 = { instancePath: instancePath + "/runs/" + i0 + "/createdAt", schemaPath: "#/properties/runs/items/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err50];
                  } else {
                    vErrors.push(err50);
                  }
                  errors++;
                }
                if (!formats0.validate(data16)) {
                  const err51 = { instancePath: instancePath + "/runs/" + i0 + "/createdAt", schemaPath: "#/properties/runs/items/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err51];
                  } else {
                    vErrors.push(err51);
                  }
                  errors++;
                }
              } else {
                const err52 = { instancePath: instancePath + "/runs/" + i0 + "/createdAt", schemaPath: "#/properties/runs/items/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err52];
                } else {
                  vErrors.push(err52);
                }
                errors++;
              }
            }
            if (data8.completedAt !== void 0) {
              let data17 = data8.completedAt;
              const _errs46 = errors;
              let valid6 = false;
              const _errs47 = errors;
              if (typeof data17 === "string") {
                if (!pattern0.test(data17)) {
                  const err53 = { instancePath: instancePath + "/runs/" + i0 + "/completedAt", schemaPath: "#/properties/runs/items/properties/completedAt/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err53];
                  } else {
                    vErrors.push(err53);
                  }
                  errors++;
                }
                if (!formats0.validate(data17)) {
                  const err54 = { instancePath: instancePath + "/runs/" + i0 + "/completedAt", schemaPath: "#/properties/runs/items/properties/completedAt/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err54];
                  } else {
                    vErrors.push(err54);
                  }
                  errors++;
                }
              } else {
                const err55 = { instancePath: instancePath + "/runs/" + i0 + "/completedAt", schemaPath: "#/properties/runs/items/properties/completedAt/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err55];
                } else {
                  vErrors.push(err55);
                }
                errors++;
              }
              var _valid2 = _errs47 === errors;
              valid6 = valid6 || _valid2;
              if (!valid6) {
                const _errs49 = errors;
                if (data17 !== null) {
                  const err56 = { instancePath: instancePath + "/runs/" + i0 + "/completedAt", schemaPath: "#/properties/runs/items/properties/completedAt/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err56];
                  } else {
                    vErrors.push(err56);
                  }
                  errors++;
                }
                var _valid2 = _errs49 === errors;
                valid6 = valid6 || _valid2;
              }
              if (!valid6) {
                const err57 = { instancePath: instancePath + "/runs/" + i0 + "/completedAt", schemaPath: "#/properties/runs/items/properties/completedAt/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err57];
                } else {
                  vErrors.push(err57);
                }
                errors++;
              } else {
                errors = _errs46;
                if (vErrors !== null) {
                  if (_errs46) {
                    vErrors.length = _errs46;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data8.conversationId !== void 0) {
              let data18 = data8.conversationId;
              const _errs52 = errors;
              let valid7 = false;
              const _errs53 = errors;
              if (typeof data18 !== "string") {
                const err58 = { instancePath: instancePath + "/runs/" + i0 + "/conversationId", schemaPath: "#/properties/runs/items/properties/conversationId/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err58];
                } else {
                  vErrors.push(err58);
                }
                errors++;
              }
              var _valid3 = _errs53 === errors;
              valid7 = valid7 || _valid3;
              if (!valid7) {
                const _errs55 = errors;
                if (data18 !== null) {
                  const err59 = { instancePath: instancePath + "/runs/" + i0 + "/conversationId", schemaPath: "#/properties/runs/items/properties/conversationId/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err59];
                  } else {
                    vErrors.push(err59);
                  }
                  errors++;
                }
                var _valid3 = _errs55 === errors;
                valid7 = valid7 || _valid3;
              }
              if (!valid7) {
                const err60 = { instancePath: instancePath + "/runs/" + i0 + "/conversationId", schemaPath: "#/properties/runs/items/properties/conversationId/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err60];
                } else {
                  vErrors.push(err60);
                }
                errors++;
              } else {
                errors = _errs52;
                if (vErrors !== null) {
                  if (_errs52) {
                    vErrors.length = _errs52;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data8.turnNumber !== void 0) {
              let data19 = data8.turnNumber;
              const _errs58 = errors;
              let valid8 = false;
              const _errs59 = errors;
              if (!(typeof data19 == "number" && (!(data19 % 1) && !isNaN(data19)) && isFinite(data19))) {
                const err61 = { instancePath: instancePath + "/runs/" + i0 + "/turnNumber", schemaPath: "#/properties/runs/items/properties/turnNumber/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err61];
                } else {
                  vErrors.push(err61);
                }
                errors++;
              }
              if (typeof data19 == "number" && isFinite(data19)) {
                if (data19 > 9007199254740991 || isNaN(data19)) {
                  const err62 = { instancePath: instancePath + "/runs/" + i0 + "/turnNumber", schemaPath: "#/properties/runs/items/properties/turnNumber/anyOf/0/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err62];
                  } else {
                    vErrors.push(err62);
                  }
                  errors++;
                }
                if (data19 < -9007199254740991 || isNaN(data19)) {
                  const err63 = { instancePath: instancePath + "/runs/" + i0 + "/turnNumber", schemaPath: "#/properties/runs/items/properties/turnNumber/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err63];
                  } else {
                    vErrors.push(err63);
                  }
                  errors++;
                }
              }
              var _valid4 = _errs59 === errors;
              valid8 = valid8 || _valid4;
              if (!valid8) {
                const _errs61 = errors;
                if (data19 !== null) {
                  const err64 = { instancePath: instancePath + "/runs/" + i0 + "/turnNumber", schemaPath: "#/properties/runs/items/properties/turnNumber/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err64];
                  } else {
                    vErrors.push(err64);
                  }
                  errors++;
                }
                var _valid4 = _errs61 === errors;
                valid8 = valid8 || _valid4;
              }
              if (!valid8) {
                const err65 = { instancePath: instancePath + "/runs/" + i0 + "/turnNumber", schemaPath: "#/properties/runs/items/properties/turnNumber/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err65];
                } else {
                  vErrors.push(err65);
                }
                errors++;
              } else {
                errors = _errs58;
                if (vErrors !== null) {
                  if (_errs58) {
                    vErrors.length = _errs58;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data8.historyBoundary !== void 0) {
              let data20 = data8.historyBoundary;
              const _errs64 = errors;
              let valid9 = false;
              const _errs65 = errors;
              if (!(typeof data20 == "number" && (!(data20 % 1) && !isNaN(data20)) && isFinite(data20))) {
                const err66 = { instancePath: instancePath + "/runs/" + i0 + "/historyBoundary", schemaPath: "#/properties/runs/items/properties/historyBoundary/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err66];
                } else {
                  vErrors.push(err66);
                }
                errors++;
              }
              if (typeof data20 == "number" && isFinite(data20)) {
                if (data20 > 9007199254740991 || isNaN(data20)) {
                  const err67 = { instancePath: instancePath + "/runs/" + i0 + "/historyBoundary", schemaPath: "#/properties/runs/items/properties/historyBoundary/anyOf/0/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err67];
                  } else {
                    vErrors.push(err67);
                  }
                  errors++;
                }
                if (data20 < -9007199254740991 || isNaN(data20)) {
                  const err68 = { instancePath: instancePath + "/runs/" + i0 + "/historyBoundary", schemaPath: "#/properties/runs/items/properties/historyBoundary/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err68];
                  } else {
                    vErrors.push(err68);
                  }
                  errors++;
                }
              }
              var _valid5 = _errs65 === errors;
              valid9 = valid9 || _valid5;
              if (!valid9) {
                const _errs67 = errors;
                if (data20 !== null) {
                  const err69 = { instancePath: instancePath + "/runs/" + i0 + "/historyBoundary", schemaPath: "#/properties/runs/items/properties/historyBoundary/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err69];
                  } else {
                    vErrors.push(err69);
                  }
                  errors++;
                }
                var _valid5 = _errs67 === errors;
                valid9 = valid9 || _valid5;
              }
              if (!valid9) {
                const err70 = { instancePath: instancePath + "/runs/" + i0 + "/historyBoundary", schemaPath: "#/properties/runs/items/properties/historyBoundary/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err70];
                } else {
                  vErrors.push(err70);
                }
                errors++;
              } else {
                errors = _errs64;
                if (vErrors !== null) {
                  if (_errs64) {
                    vErrors.length = _errs64;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
          } else {
            const err71 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err71];
            } else {
              vErrors.push(err71);
            }
            errors++;
          }
        }
      } else {
        const err72 = { instancePath: instancePath + "/runs", schemaPath: "#/properties/runs/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err72];
        } else {
          vErrors.push(err72);
        }
        errors++;
      }
    }
    if (data.messages !== void 0) {
      let data21 = data.messages;
      if (Array.isArray(data21)) {
        const len1 = data21.length;
        for (let i1 = 0; i1 < len1; i1++) {
          let data22 = data21[i1];
          if (data22 && typeof data22 == "object" && !Array.isArray(data22)) {
            if (data22.runId === void 0) {
              const err73 = { instancePath: instancePath + "/messages/" + i1, schemaPath: "#/properties/messages/items/required", keyword: "required", params: { missingProperty: "runId" }, message: "must have required property 'runId'" };
              if (vErrors === null) {
                vErrors = [err73];
              } else {
                vErrors.push(err73);
              }
              errors++;
            }
            if (data22.messageIndex === void 0) {
              const err74 = { instancePath: instancePath + "/messages/" + i1, schemaPath: "#/properties/messages/items/required", keyword: "required", params: { missingProperty: "messageIndex" }, message: "must have required property 'messageIndex'" };
              if (vErrors === null) {
                vErrors = [err74];
              } else {
                vErrors.push(err74);
              }
              errors++;
            }
            if (data22.payload === void 0) {
              const err75 = { instancePath: instancePath + "/messages/" + i1, schemaPath: "#/properties/messages/items/required", keyword: "required", params: { missingProperty: "payload" }, message: "must have required property 'payload'" };
              if (vErrors === null) {
                vErrors = [err75];
              } else {
                vErrors.push(err75);
              }
              errors++;
            }
            for (const key2 in data22) {
              if (!(key2 === "runId" || key2 === "messageIndex" || key2 === "payload")) {
                const err76 = { instancePath: instancePath + "/messages/" + i1, schemaPath: "#/properties/messages/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err76];
                } else {
                  vErrors.push(err76);
                }
                errors++;
              }
            }
            if (data22.runId !== void 0) {
              if (typeof data22.runId !== "string") {
                const err77 = { instancePath: instancePath + "/messages/" + i1 + "/runId", schemaPath: "#/properties/messages/items/properties/runId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err77];
                } else {
                  vErrors.push(err77);
                }
                errors++;
              }
            }
            if (data22.messageIndex !== void 0) {
              let data24 = data22.messageIndex;
              if (!(typeof data24 == "number" && (!(data24 % 1) && !isNaN(data24)) && isFinite(data24))) {
                const err78 = { instancePath: instancePath + "/messages/" + i1 + "/messageIndex", schemaPath: "#/properties/messages/items/properties/messageIndex/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err78];
                } else {
                  vErrors.push(err78);
                }
                errors++;
              }
              if (typeof data24 == "number" && isFinite(data24)) {
                if (data24 > 9007199254740991 || isNaN(data24)) {
                  const err79 = { instancePath: instancePath + "/messages/" + i1 + "/messageIndex", schemaPath: "#/properties/messages/items/properties/messageIndex/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err79];
                  } else {
                    vErrors.push(err79);
                  }
                  errors++;
                }
                if (data24 < -9007199254740991 || isNaN(data24)) {
                  const err80 = { instancePath: instancePath + "/messages/" + i1 + "/messageIndex", schemaPath: "#/properties/messages/items/properties/messageIndex/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err80];
                  } else {
                    vErrors.push(err80);
                  }
                  errors++;
                }
              }
            }
            if (data22.payload !== void 0) {
              let data25 = data22.payload;
              const _errs79 = errors;
              let valid13 = false;
              let passing0 = null;
              const _errs80 = errors;
              if (data25 && typeof data25 == "object" && !Array.isArray(data25)) {
                if (data25.role === void 0) {
                  const err81 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/required", keyword: "required", params: { missingProperty: "role" }, message: "must have required property 'role'" };
                  if (vErrors === null) {
                    vErrors = [err81];
                  } else {
                    vErrors.push(err81);
                  }
                  errors++;
                }
                if (data25.content === void 0) {
                  const err82 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/required", keyword: "required", params: { missingProperty: "content" }, message: "must have required property 'content'" };
                  if (vErrors === null) {
                    vErrors = [err82];
                  } else {
                    vErrors.push(err82);
                  }
                  errors++;
                }
                for (const key3 in data25) {
                  if (!(key3 === "role" || key3 === "content")) {
                    const err83 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err83];
                    } else {
                      vErrors.push(err83);
                    }
                    errors++;
                  }
                }
                if (data25.role !== void 0) {
                  let data26 = data25.role;
                  if (typeof data26 !== "string") {
                    const err84 = { instancePath: instancePath + "/messages/" + i1 + "/payload/role", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/properties/role/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err84];
                    } else {
                      vErrors.push(err84);
                    }
                    errors++;
                  }
                  if ("user" !== data26) {
                    const err85 = { instancePath: instancePath + "/messages/" + i1 + "/payload/role", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/properties/role/const", keyword: "const", params: { allowedValue: "user" }, message: "must be equal to constant" };
                    if (vErrors === null) {
                      vErrors = [err85];
                    } else {
                      vErrors.push(err85);
                    }
                    errors++;
                  }
                }
                if (data25.content !== void 0) {
                  if (typeof data25.content !== "string") {
                    const err86 = { instancePath: instancePath + "/messages/" + i1 + "/payload/content", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err86];
                    } else {
                      vErrors.push(err86);
                    }
                    errors++;
                  }
                }
              } else {
                const err87 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err87];
                } else {
                  vErrors.push(err87);
                }
                errors++;
              }
              var _valid6 = _errs80 === errors;
              if (_valid6) {
                valid13 = true;
                passing0 = 0;
              }
              const _errs87 = errors;
              if (data25 && typeof data25 == "object" && !Array.isArray(data25)) {
                if (data25.role === void 0) {
                  const err88 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/required", keyword: "required", params: { missingProperty: "role" }, message: "must have required property 'role'" };
                  if (vErrors === null) {
                    vErrors = [err88];
                  } else {
                    vErrors.push(err88);
                  }
                  errors++;
                }
                if (data25.content === void 0) {
                  const err89 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/required", keyword: "required", params: { missingProperty: "content" }, message: "must have required property 'content'" };
                  if (vErrors === null) {
                    vErrors = [err89];
                  } else {
                    vErrors.push(err89);
                  }
                  errors++;
                }
                if (data25.toolCalls === void 0) {
                  const err90 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/required", keyword: "required", params: { missingProperty: "toolCalls" }, message: "must have required property 'toolCalls'" };
                  if (vErrors === null) {
                    vErrors = [err90];
                  } else {
                    vErrors.push(err90);
                  }
                  errors++;
                }
                for (const key4 in data25) {
                  if (!(key4 === "role" || key4 === "content" || key4 === "toolCalls")) {
                    const err91 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err91];
                    } else {
                      vErrors.push(err91);
                    }
                    errors++;
                  }
                }
                if (data25.role !== void 0) {
                  let data28 = data25.role;
                  if (typeof data28 !== "string") {
                    const err92 = { instancePath: instancePath + "/messages/" + i1 + "/payload/role", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/role/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err92];
                    } else {
                      vErrors.push(err92);
                    }
                    errors++;
                  }
                  if ("assistant" !== data28) {
                    const err93 = { instancePath: instancePath + "/messages/" + i1 + "/payload/role", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/role/const", keyword: "const", params: { allowedValue: "assistant" }, message: "must be equal to constant" };
                    if (vErrors === null) {
                      vErrors = [err93];
                    } else {
                      vErrors.push(err93);
                    }
                    errors++;
                  }
                }
                if (data25.content !== void 0) {
                  if (typeof data25.content !== "string") {
                    const err94 = { instancePath: instancePath + "/messages/" + i1 + "/payload/content", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err94];
                    } else {
                      vErrors.push(err94);
                    }
                    errors++;
                  }
                }
                if (data25.toolCalls !== void 0) {
                  let data30 = data25.toolCalls;
                  if (Array.isArray(data30)) {
                    const len2 = data30.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                      let data31 = data30[i2];
                      if (data31 && typeof data31 == "object" && !Array.isArray(data31)) {
                        if (data31.id === void 0) {
                          const err95 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2, schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                          if (vErrors === null) {
                            vErrors = [err95];
                          } else {
                            vErrors.push(err95);
                          }
                          errors++;
                        }
                        if (data31.thought === void 0) {
                          const err96 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2, schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/required", keyword: "required", params: { missingProperty: "thought" }, message: "must have required property 'thought'" };
                          if (vErrors === null) {
                            vErrors = [err96];
                          } else {
                            vErrors.push(err96);
                          }
                          errors++;
                        }
                        if (data31.source === void 0) {
                          const err97 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2, schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/required", keyword: "required", params: { missingProperty: "source" }, message: "must have required property 'source'" };
                          if (vErrors === null) {
                            vErrors = [err97];
                          } else {
                            vErrors.push(err97);
                          }
                          errors++;
                        }
                        for (const key5 in data31) {
                          if (!(key5 === "id" || key5 === "thought" || key5 === "source")) {
                            const err98 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2, schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err98];
                            } else {
                              vErrors.push(err98);
                            }
                            errors++;
                          }
                        }
                        if (data31.id !== void 0) {
                          if (typeof data31.id !== "string") {
                            const err99 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2 + "/id", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err99];
                            } else {
                              vErrors.push(err99);
                            }
                            errors++;
                          }
                        }
                        if (data31.thought !== void 0) {
                          if (typeof data31.thought !== "string") {
                            const err100 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2 + "/thought", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/properties/thought/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err100];
                            } else {
                              vErrors.push(err100);
                            }
                            errors++;
                          }
                        }
                        if (data31.source !== void 0) {
                          if (typeof data31.source !== "string") {
                            const err101 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2 + "/source", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/properties/source/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err101];
                            } else {
                              vErrors.push(err101);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err102 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2, schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err102];
                        } else {
                          vErrors.push(err102);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err103 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err103];
                    } else {
                      vErrors.push(err103);
                    }
                    errors++;
                  }
                }
              } else {
                const err104 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err104];
                } else {
                  vErrors.push(err104);
                }
                errors++;
              }
              var _valid6 = _errs87 === errors;
              if (_valid6 && valid13) {
                valid13 = false;
                passing0 = [passing0, 1];
              } else {
                if (_valid6) {
                  valid13 = true;
                  passing0 = 1;
                }
                const _errs105 = errors;
                if (data25 && typeof data25 == "object" && !Array.isArray(data25)) {
                  if (data25.role === void 0) {
                    const err105 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/required", keyword: "required", params: { missingProperty: "role" }, message: "must have required property 'role'" };
                    if (vErrors === null) {
                      vErrors = [err105];
                    } else {
                      vErrors.push(err105);
                    }
                    errors++;
                  }
                  if (data25.toolCallId === void 0) {
                    const err106 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/required", keyword: "required", params: { missingProperty: "toolCallId" }, message: "must have required property 'toolCallId'" };
                    if (vErrors === null) {
                      vErrors = [err106];
                    } else {
                      vErrors.push(err106);
                    }
                    errors++;
                  }
                  if (data25.content === void 0) {
                    const err107 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/required", keyword: "required", params: { missingProperty: "content" }, message: "must have required property 'content'" };
                    if (vErrors === null) {
                      vErrors = [err107];
                    } else {
                      vErrors.push(err107);
                    }
                    errors++;
                  }
                  for (const key6 in data25) {
                    if (!(key6 === "role" || key6 === "toolCallId" || key6 === "content" || key6 === "isError" || key6 === "resources")) {
                      const err108 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key6 }, message: "must NOT have additional properties" };
                      if (vErrors === null) {
                        vErrors = [err108];
                      } else {
                        vErrors.push(err108);
                      }
                      errors++;
                    }
                  }
                  if (data25.role !== void 0) {
                    let data35 = data25.role;
                    if (typeof data35 !== "string") {
                      const err109 = { instancePath: instancePath + "/messages/" + i1 + "/payload/role", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/role/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err109];
                      } else {
                        vErrors.push(err109);
                      }
                      errors++;
                    }
                    if ("tool" !== data35) {
                      const err110 = { instancePath: instancePath + "/messages/" + i1 + "/payload/role", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/role/const", keyword: "const", params: { allowedValue: "tool" }, message: "must be equal to constant" };
                      if (vErrors === null) {
                        vErrors = [err110];
                      } else {
                        vErrors.push(err110);
                      }
                      errors++;
                    }
                  }
                  if (data25.toolCallId !== void 0) {
                    if (typeof data25.toolCallId !== "string") {
                      const err111 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCallId", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/toolCallId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err111];
                      } else {
                        vErrors.push(err111);
                      }
                      errors++;
                    }
                  }
                  if (data25.content !== void 0) {
                    if (typeof data25.content !== "string") {
                      const err112 = { instancePath: instancePath + "/messages/" + i1 + "/payload/content", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err112];
                      } else {
                        vErrors.push(err112);
                      }
                      errors++;
                    }
                  }
                  if (data25.isError !== void 0) {
                    if (typeof data25.isError !== "boolean") {
                      const err113 = { instancePath: instancePath + "/messages/" + i1 + "/payload/isError", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/isError/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                      if (vErrors === null) {
                        vErrors = [err113];
                      } else {
                        vErrors.push(err113);
                      }
                      errors++;
                    }
                  }
                  if (data25.resources !== void 0) {
                    let data39 = data25.resources;
                    if (Array.isArray(data39)) {
                      const len3 = data39.length;
                      for (let i3 = 0; i3 < len3; i3++) {
                        let data40 = data39[i3];
                        if (data40 && typeof data40 == "object" && !Array.isArray(data40)) {
                          if (data40.path === void 0) {
                            const err114 = { instancePath: instancePath + "/messages/" + i1 + "/payload/resources/" + i3, schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/resources/items/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
                            if (vErrors === null) {
                              vErrors = [err114];
                            } else {
                              vErrors.push(err114);
                            }
                            errors++;
                          }
                          for (const key7 in data40) {
                            if (!(key7 === "path")) {
                              const err115 = { instancePath: instancePath + "/messages/" + i1 + "/payload/resources/" + i3, schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/resources/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key7 }, message: "must NOT have additional properties" };
                              if (vErrors === null) {
                                vErrors = [err115];
                              } else {
                                vErrors.push(err115);
                              }
                              errors++;
                            }
                          }
                          if (data40.path !== void 0) {
                            if (typeof data40.path !== "string") {
                              const err116 = { instancePath: instancePath + "/messages/" + i1 + "/payload/resources/" + i3 + "/path", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/resources/items/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err116];
                              } else {
                                vErrors.push(err116);
                              }
                              errors++;
                            }
                          }
                        } else {
                          const err117 = { instancePath: instancePath + "/messages/" + i1 + "/payload/resources/" + i3, schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/resources/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                          if (vErrors === null) {
                            vErrors = [err117];
                          } else {
                            vErrors.push(err117);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err118 = { instancePath: instancePath + "/messages/" + i1 + "/payload/resources", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/resources/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                      if (vErrors === null) {
                        vErrors = [err118];
                      } else {
                        vErrors.push(err118);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err119 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                  if (vErrors === null) {
                    vErrors = [err119];
                  } else {
                    vErrors.push(err119);
                  }
                  errors++;
                }
                var _valid6 = _errs105 === errors;
                if (_valid6 && valid13) {
                  valid13 = false;
                  passing0 = [passing0, 2];
                } else {
                  if (_valid6) {
                    valid13 = true;
                    passing0 = 2;
                  }
                }
              }
              if (!valid13) {
                const err120 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
                if (vErrors === null) {
                  vErrors = [err120];
                } else {
                  vErrors.push(err120);
                }
                errors++;
              } else {
                errors = _errs79;
                if (vErrors !== null) {
                  if (_errs79) {
                    vErrors.length = _errs79;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
          } else {
            const err121 = { instancePath: instancePath + "/messages/" + i1, schemaPath: "#/properties/messages/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err121];
            } else {
              vErrors.push(err121);
            }
            errors++;
          }
        }
      } else {
        const err122 = { instancePath: instancePath + "/messages", schemaPath: "#/properties/messages/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err122];
        } else {
          vErrors.push(err122);
        }
        errors++;
      }
    }
    if (data.submittedPlans !== void 0) {
      let data42 = data.submittedPlans;
      if (Array.isArray(data42)) {
        const len4 = data42.length;
        for (let i4 = 0; i4 < len4; i4++) {
          let data43 = data42[i4];
          if (data43 && typeof data43 == "object" && !Array.isArray(data43)) {
            if (data43.path === void 0) {
              const err123 = { instancePath: instancePath + "/submittedPlans/" + i4, schemaPath: "#/properties/submittedPlans/items/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
              if (vErrors === null) {
                vErrors = [err123];
              } else {
                vErrors.push(err123);
              }
              errors++;
            }
            if (data43.runId === void 0) {
              const err124 = { instancePath: instancePath + "/submittedPlans/" + i4, schemaPath: "#/properties/submittedPlans/items/required", keyword: "required", params: { missingProperty: "runId" }, message: "must have required property 'runId'" };
              if (vErrors === null) {
                vErrors = [err124];
              } else {
                vErrors.push(err124);
              }
              errors++;
            }
            if (data43.plan === void 0) {
              const err125 = { instancePath: instancePath + "/submittedPlans/" + i4, schemaPath: "#/properties/submittedPlans/items/required", keyword: "required", params: { missingProperty: "plan" }, message: "must have required property 'plan'" };
              if (vErrors === null) {
                vErrors = [err125];
              } else {
                vErrors.push(err125);
              }
              errors++;
            }
            if (data43.findings === void 0) {
              const err126 = { instancePath: instancePath + "/submittedPlans/" + i4, schemaPath: "#/properties/submittedPlans/items/required", keyword: "required", params: { missingProperty: "findings" }, message: "must have required property 'findings'" };
              if (vErrors === null) {
                vErrors = [err126];
              } else {
                vErrors.push(err126);
              }
              errors++;
            }
            for (const key8 in data43) {
              if (!(key8 === "path" || key8 === "runId" || key8 === "plan" || key8 === "findings")) {
                const err127 = { instancePath: instancePath + "/submittedPlans/" + i4, schemaPath: "#/properties/submittedPlans/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key8 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err127];
                } else {
                  vErrors.push(err127);
                }
                errors++;
              }
            }
            if (data43.path !== void 0) {
              if (typeof data43.path !== "string") {
                const err128 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/path", schemaPath: "#/properties/submittedPlans/items/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err128];
                } else {
                  vErrors.push(err128);
                }
                errors++;
              }
            }
            if (data43.runId !== void 0) {
              if (typeof data43.runId !== "string") {
                const err129 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/runId", schemaPath: "#/properties/submittedPlans/items/properties/runId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err129];
                } else {
                  vErrors.push(err129);
                }
                errors++;
              }
            }
            if (data43.plan !== void 0) {
              let data46 = data43.plan;
              if (data46 && typeof data46 == "object" && !Array.isArray(data46)) {
                if (data46.id === void 0) {
                  const err130 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan", schemaPath: "#/properties/submittedPlans/items/properties/plan/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                  if (vErrors === null) {
                    vErrors = [err130];
                  } else {
                    vErrors.push(err130);
                  }
                  errors++;
                }
                if (data46.kind === void 0) {
                  const err131 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan", schemaPath: "#/properties/submittedPlans/items/properties/plan/required", keyword: "required", params: { missingProperty: "kind" }, message: "must have required property 'kind'" };
                  if (vErrors === null) {
                    vErrors = [err131];
                  } else {
                    vErrors.push(err131);
                  }
                  errors++;
                }
                if (data46.title === void 0) {
                  const err132 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan", schemaPath: "#/properties/submittedPlans/items/properties/plan/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err132];
                  } else {
                    vErrors.push(err132);
                  }
                  errors++;
                }
                if (data46.planDate === void 0) {
                  const err133 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan", schemaPath: "#/properties/submittedPlans/items/properties/plan/required", keyword: "required", params: { missingProperty: "planDate" }, message: "must have required property 'planDate'" };
                  if (vErrors === null) {
                    vErrors = [err133];
                  } else {
                    vErrors.push(err133);
                  }
                  errors++;
                }
                if (data46.status === void 0) {
                  const err134 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan", schemaPath: "#/properties/submittedPlans/items/properties/plan/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
                  if (vErrors === null) {
                    vErrors = [err134];
                  } else {
                    vErrors.push(err134);
                  }
                  errors++;
                }
                if (data46.rows === void 0) {
                  const err135 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan", schemaPath: "#/properties/submittedPlans/items/properties/plan/required", keyword: "required", params: { missingProperty: "rows" }, message: "must have required property 'rows'" };
                  if (vErrors === null) {
                    vErrors = [err135];
                  } else {
                    vErrors.push(err135);
                  }
                  errors++;
                }
                for (const key9 in data46) {
                  if (!func4.call(schema20.properties.submittedPlans.items.properties.plan.properties, key9)) {
                    const err136 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan", schemaPath: "#/properties/submittedPlans/items/properties/plan/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key9 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err136];
                    } else {
                      vErrors.push(err136);
                    }
                    errors++;
                  }
                }
                if (data46.id !== void 0) {
                  let data47 = data46.id;
                  if (typeof data47 === "string") {
                    if (func2(data47) < 1) {
                      const err137 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/id", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                      if (vErrors === null) {
                        vErrors = [err137];
                      } else {
                        vErrors.push(err137);
                      }
                      errors++;
                    }
                  } else {
                    const err138 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/id", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err138];
                    } else {
                      vErrors.push(err138);
                    }
                    errors++;
                  }
                }
                if (data46.kind !== void 0) {
                  let data48 = data46.kind;
                  if (typeof data48 !== "string") {
                    const err139 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/kind", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err139];
                    } else {
                      vErrors.push(err139);
                    }
                    errors++;
                  }
                  if ("treatment-plan" !== data48) {
                    const err140 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/kind", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/kind/const", keyword: "const", params: { allowedValue: "treatment-plan" }, message: "must be equal to constant" };
                    if (vErrors === null) {
                      vErrors = [err140];
                    } else {
                      vErrors.push(err140);
                    }
                    errors++;
                  }
                }
                if (data46.draft !== void 0) {
                  if (typeof data46.draft !== "boolean") {
                    const err141 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/draft", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/draft/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                      vErrors = [err141];
                    } else {
                      vErrors.push(err141);
                    }
                    errors++;
                  }
                }
                if (data46.title !== void 0) {
                  if (typeof data46.title !== "string") {
                    const err142 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/title", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err142];
                    } else {
                      vErrors.push(err142);
                    }
                    errors++;
                  }
                }
                if (data46.planDate !== void 0) {
                  if (typeof data46.planDate !== "string") {
                    const err143 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/planDate", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/planDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err143];
                    } else {
                      vErrors.push(err143);
                    }
                    errors++;
                  }
                }
                if (data46.status !== void 0) {
                  let data52 = data46.status;
                  if (typeof data52 !== "string") {
                    const err144 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/status", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err144];
                    } else {
                      vErrors.push(err144);
                    }
                    errors++;
                  }
                  if (!(data52 === "draft" || data52 === "reviewed" || data52 === "final")) {
                    const err145 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/status", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/status/enum", keyword: "enum", params: { allowedValues: schema20.properties.submittedPlans.items.properties.plan.properties.status.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err145];
                    } else {
                      vErrors.push(err145);
                    }
                    errors++;
                  }
                }
                if (data46.patientName !== void 0) {
                  if (typeof data46.patientName !== "string") {
                    const err146 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/patientName", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/patientName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err146];
                    } else {
                      vErrors.push(err146);
                    }
                    errors++;
                  }
                }
                if (data46.patientBirthDate !== void 0) {
                  if (typeof data46.patientBirthDate !== "string") {
                    const err147 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/patientBirthDate", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/patientBirthDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err147];
                    } else {
                      vErrors.push(err147);
                    }
                    errors++;
                  }
                }
                if (data46.planNumber !== void 0) {
                  if (typeof data46.planNumber !== "string") {
                    const err148 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/planNumber", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/planNumber/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err148];
                    } else {
                      vErrors.push(err148);
                    }
                    errors++;
                  }
                }
                if (data46.patientAddress !== void 0) {
                  if (typeof data46.patientAddress !== "string") {
                    const err149 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/patientAddress", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/patientAddress/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err149];
                    } else {
                      vErrors.push(err149);
                    }
                    errors++;
                  }
                }
                if (data46.consumablesEstimate !== void 0) {
                  let data57 = data46.consumablesEstimate;
                  if (typeof data57 == "number" && isFinite(data57)) {
                    if (data57 < 0 || isNaN(data57)) {
                      const err150 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/consumablesEstimate", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/consumablesEstimate/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                      if (vErrors === null) {
                        vErrors = [err150];
                      } else {
                        vErrors.push(err150);
                      }
                      errors++;
                    }
                  } else {
                    const err151 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/consumablesEstimate", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/consumablesEstimate/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                    if (vErrors === null) {
                      vErrors = [err151];
                    } else {
                      vErrors.push(err151);
                    }
                    errors++;
                  }
                }
                if (data46.labCostsEstimate !== void 0) {
                  let data58 = data46.labCostsEstimate;
                  if (typeof data58 == "number" && isFinite(data58)) {
                    if (data58 < 0 || isNaN(data58)) {
                      const err152 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/labCostsEstimate", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/labCostsEstimate/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                      if (vErrors === null) {
                        vErrors = [err152];
                      } else {
                        vErrors.push(err152);
                      }
                      errors++;
                    }
                  } else {
                    const err153 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/labCostsEstimate", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/labCostsEstimate/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                    if (vErrors === null) {
                      vErrors = [err153];
                    } else {
                      vErrors.push(err153);
                    }
                    errors++;
                  }
                }
                if (data46.rows !== void 0) {
                  let data59 = data46.rows;
                  if (Array.isArray(data59)) {
                    const len5 = data59.length;
                    for (let i5 = 0; i5 < len5; i5++) {
                      let data60 = data59[i5];
                      if (data60 && typeof data60 == "object" && !Array.isArray(data60)) {
                        if (data60.id === void 0) {
                          const err154 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                          if (vErrors === null) {
                            vErrors = [err154];
                          } else {
                            vErrors.push(err154);
                          }
                          errors++;
                        }
                        if (data60.gozNumber === void 0) {
                          const err155 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/required", keyword: "required", params: { missingProperty: "gozNumber" }, message: "must have required property 'gozNumber'" };
                          if (vErrors === null) {
                            vErrors = [err155];
                          } else {
                            vErrors.push(err155);
                          }
                          errors++;
                        }
                        if (data60.description === void 0) {
                          const err156 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property 'description'" };
                          if (vErrors === null) {
                            vErrors = [err156];
                          } else {
                            vErrors.push(err156);
                          }
                          errors++;
                        }
                        if (data60.toothOrRegion === void 0) {
                          const err157 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/required", keyword: "required", params: { missingProperty: "toothOrRegion" }, message: "must have required property 'toothOrRegion'" };
                          if (vErrors === null) {
                            vErrors = [err157];
                          } else {
                            vErrors.push(err157);
                          }
                          errors++;
                        }
                        if (data60.quantity === void 0) {
                          const err158 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err158];
                          } else {
                            vErrors.push(err158);
                          }
                          errors++;
                        }
                        if (data60.factor === void 0) {
                          const err159 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/required", keyword: "required", params: { missingProperty: "factor" }, message: "must have required property 'factor'" };
                          if (vErrors === null) {
                            vErrors = [err159];
                          } else {
                            vErrors.push(err159);
                          }
                          errors++;
                        }
                        if (data60.amount === void 0) {
                          const err160 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/required", keyword: "required", params: { missingProperty: "amount" }, message: "must have required property 'amount'" };
                          if (vErrors === null) {
                            vErrors = [err160];
                          } else {
                            vErrors.push(err160);
                          }
                          errors++;
                        }
                        if (data60.justification === void 0) {
                          const err161 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/required", keyword: "required", params: { missingProperty: "justification" }, message: "must have required property 'justification'" };
                          if (vErrors === null) {
                            vErrors = [err161];
                          } else {
                            vErrors.push(err161);
                          }
                          errors++;
                        }
                        if (data60.analogReference === void 0) {
                          const err162 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/required", keyword: "required", params: { missingProperty: "analogReference" }, message: "must have required property 'analogReference'" };
                          if (vErrors === null) {
                            vErrors = [err162];
                          } else {
                            vErrors.push(err162);
                          }
                          errors++;
                        }
                        if (data60.materials === void 0) {
                          const err163 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/required", keyword: "required", params: { missingProperty: "materials" }, message: "must have required property 'materials'" };
                          if (vErrors === null) {
                            vErrors = [err163];
                          } else {
                            vErrors.push(err163);
                          }
                          errors++;
                        }
                        if (data60.notes === void 0) {
                          const err164 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/required", keyword: "required", params: { missingProperty: "notes" }, message: "must have required property 'notes'" };
                          if (vErrors === null) {
                            vErrors = [err164];
                          } else {
                            vErrors.push(err164);
                          }
                          errors++;
                        }
                        for (const key10 in data60) {
                          if (!func4.call(schema20.properties.submittedPlans.items.properties.plan.properties.rows.items.properties, key10)) {
                            const err165 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key10 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err165];
                            } else {
                              vErrors.push(err165);
                            }
                            errors++;
                          }
                        }
                        if (data60.id !== void 0) {
                          let data61 = data60.id;
                          if (typeof data61 === "string") {
                            if (func2(data61) < 1) {
                              const err166 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/id", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                              if (vErrors === null) {
                                vErrors = [err166];
                              } else {
                                vErrors.push(err166);
                              }
                              errors++;
                            }
                          } else {
                            const err167 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/id", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err167];
                            } else {
                              vErrors.push(err167);
                            }
                            errors++;
                          }
                        }
                        if (data60.gozNumber !== void 0) {
                          if (typeof data60.gozNumber !== "string") {
                            const err168 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/gozNumber", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/gozNumber/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err168];
                            } else {
                              vErrors.push(err168);
                            }
                            errors++;
                          }
                        }
                        if (data60.description !== void 0) {
                          if (typeof data60.description !== "string") {
                            const err169 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/description", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err169];
                            } else {
                              vErrors.push(err169);
                            }
                            errors++;
                          }
                        }
                        if (data60.toothOrRegion !== void 0) {
                          if (typeof data60.toothOrRegion !== "string") {
                            const err170 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/toothOrRegion", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/toothOrRegion/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err170];
                            } else {
                              vErrors.push(err170);
                            }
                            errors++;
                          }
                        }
                        if (data60.quantity !== void 0) {
                          let data65 = data60.quantity;
                          if (typeof data65 == "number" && isFinite(data65)) {
                            if (data65 <= 0 || isNaN(data65)) {
                              const err171 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/quantity", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/quantity/exclusiveMinimum", keyword: "exclusiveMinimum", params: { comparison: ">", limit: 0 }, message: "must be > 0" };
                              if (vErrors === null) {
                                vErrors = [err171];
                              } else {
                                vErrors.push(err171);
                              }
                              errors++;
                            }
                          } else {
                            const err172 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/quantity", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/quantity/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                            if (vErrors === null) {
                              vErrors = [err172];
                            } else {
                              vErrors.push(err172);
                            }
                            errors++;
                          }
                        }
                        if (data60.factor !== void 0) {
                          let data66 = data60.factor;
                          if (!(typeof data66 == "number" && isFinite(data66))) {
                            const err173 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/factor", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/factor/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                            if (vErrors === null) {
                              vErrors = [err173];
                            } else {
                              vErrors.push(err173);
                            }
                            errors++;
                          }
                        }
                        if (data60.amount !== void 0) {
                          let data67 = data60.amount;
                          if (typeof data67 == "number" && isFinite(data67)) {
                            if (data67 < 0 || isNaN(data67)) {
                              const err174 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/amount", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/amount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                              if (vErrors === null) {
                                vErrors = [err174];
                              } else {
                                vErrors.push(err174);
                              }
                              errors++;
                            }
                          } else {
                            const err175 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/amount", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/amount/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                            if (vErrors === null) {
                              vErrors = [err175];
                            } else {
                              vErrors.push(err175);
                            }
                            errors++;
                          }
                        }
                        if (data60.justification !== void 0) {
                          if (typeof data60.justification !== "string") {
                            const err176 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/justification", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/justification/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err176];
                            } else {
                              vErrors.push(err176);
                            }
                            errors++;
                          }
                        }
                        if (data60.analogReference !== void 0) {
                          if (typeof data60.analogReference !== "string") {
                            const err177 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/analogReference", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/analogReference/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err177];
                            } else {
                              vErrors.push(err177);
                            }
                            errors++;
                          }
                        }
                        if (data60.materials !== void 0) {
                          if (typeof data60.materials !== "string") {
                            const err178 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/materials", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/materials/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err178];
                            } else {
                              vErrors.push(err178);
                            }
                            errors++;
                          }
                        }
                        if (data60.notes !== void 0) {
                          if (typeof data60.notes !== "string") {
                            const err179 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5 + "/notes", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/properties/notes/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err179];
                            } else {
                              vErrors.push(err179);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err180 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows/" + i5, schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err180];
                        } else {
                          vErrors.push(err180);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err181 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan/rows", schemaPath: "#/properties/submittedPlans/items/properties/plan/properties/rows/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err181];
                    } else {
                      vErrors.push(err181);
                    }
                    errors++;
                  }
                }
              } else {
                const err182 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/plan", schemaPath: "#/properties/submittedPlans/items/properties/plan/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err182];
                } else {
                  vErrors.push(err182);
                }
                errors++;
              }
            }
            if (data43.findings !== void 0) {
              let data72 = data43.findings;
              if (Array.isArray(data72)) {
                const len6 = data72.length;
                for (let i6 = 0; i6 < len6; i6++) {
                  let data73 = data72[i6];
                  if (data73 && typeof data73 == "object" && !Array.isArray(data73)) {
                    if (data73.severity === void 0) {
                      const err183 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6, schemaPath: "#/properties/submittedPlans/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "severity" }, message: "must have required property 'severity'" };
                      if (vErrors === null) {
                        vErrors = [err183];
                      } else {
                        vErrors.push(err183);
                      }
                      errors++;
                    }
                    if (data73.ruleId === void 0) {
                      const err184 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6, schemaPath: "#/properties/submittedPlans/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "ruleId" }, message: "must have required property 'ruleId'" };
                      if (vErrors === null) {
                        vErrors = [err184];
                      } else {
                        vErrors.push(err184);
                      }
                      errors++;
                    }
                    if (data73.message === void 0) {
                      const err185 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6, schemaPath: "#/properties/submittedPlans/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "message" }, message: "must have required property 'message'" };
                      if (vErrors === null) {
                        vErrors = [err185];
                      } else {
                        vErrors.push(err185);
                      }
                      errors++;
                    }
                    if (data73.rowIds === void 0) {
                      const err186 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6, schemaPath: "#/properties/submittedPlans/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "rowIds" }, message: "must have required property 'rowIds'" };
                      if (vErrors === null) {
                        vErrors = [err186];
                      } else {
                        vErrors.push(err186);
                      }
                      errors++;
                    }
                    if (data73.citation === void 0) {
                      const err187 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6, schemaPath: "#/properties/submittedPlans/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "citation" }, message: "must have required property 'citation'" };
                      if (vErrors === null) {
                        vErrors = [err187];
                      } else {
                        vErrors.push(err187);
                      }
                      errors++;
                    }
                    for (const key11 in data73) {
                      if (!(key11 === "severity" || key11 === "ruleId" || key11 === "message" || key11 === "rowIds" || key11 === "citation")) {
                        const err188 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6, schemaPath: "#/properties/submittedPlans/items/properties/findings/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key11 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err188];
                        } else {
                          vErrors.push(err188);
                        }
                        errors++;
                      }
                    }
                    if (data73.severity !== void 0) {
                      let data74 = data73.severity;
                      if (typeof data74 !== "string") {
                        const err189 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6 + "/severity", schemaPath: "#/properties/submittedPlans/items/properties/findings/items/properties/severity/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err189];
                        } else {
                          vErrors.push(err189);
                        }
                        errors++;
                      }
                      if (!(data74 === "warning" || data74 === "review")) {
                        const err190 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6 + "/severity", schemaPath: "#/properties/submittedPlans/items/properties/findings/items/properties/severity/enum", keyword: "enum", params: { allowedValues: schema20.properties.submittedPlans.items.properties.findings.items.properties.severity.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err190];
                        } else {
                          vErrors.push(err190);
                        }
                        errors++;
                      }
                    }
                    if (data73.ruleId !== void 0) {
                      if (typeof data73.ruleId !== "string") {
                        const err191 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6 + "/ruleId", schemaPath: "#/properties/submittedPlans/items/properties/findings/items/properties/ruleId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err191];
                        } else {
                          vErrors.push(err191);
                        }
                        errors++;
                      }
                    }
                    if (data73.message !== void 0) {
                      if (typeof data73.message !== "string") {
                        const err192 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6 + "/message", schemaPath: "#/properties/submittedPlans/items/properties/findings/items/properties/message/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err192];
                        } else {
                          vErrors.push(err192);
                        }
                        errors++;
                      }
                    }
                    if (data73.rowIds !== void 0) {
                      let data77 = data73.rowIds;
                      if (Array.isArray(data77)) {
                        const len7 = data77.length;
                        for (let i7 = 0; i7 < len7; i7++) {
                          if (typeof data77[i7] !== "string") {
                            const err193 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6 + "/rowIds/" + i7, schemaPath: "#/properties/submittedPlans/items/properties/findings/items/properties/rowIds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err193];
                            } else {
                              vErrors.push(err193);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err194 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6 + "/rowIds", schemaPath: "#/properties/submittedPlans/items/properties/findings/items/properties/rowIds/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                          vErrors = [err194];
                        } else {
                          vErrors.push(err194);
                        }
                        errors++;
                      }
                    }
                    if (data73.citation !== void 0) {
                      let data79 = data73.citation;
                      if (data79 && typeof data79 == "object" && !Array.isArray(data79)) {
                        if (data79.page === void 0) {
                          const err195 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6 + "/citation", schemaPath: "#/properties/submittedPlans/items/properties/findings/items/properties/citation/required", keyword: "required", params: { missingProperty: "page" }, message: "must have required property 'page'" };
                          if (vErrors === null) {
                            vErrors = [err195];
                          } else {
                            vErrors.push(err195);
                          }
                          errors++;
                        }
                        for (const key12 in data79) {
                          if (!(key12 === "page" || key12 === "section" || key12 === "lineText")) {
                            const err196 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6 + "/citation", schemaPath: "#/properties/submittedPlans/items/properties/findings/items/properties/citation/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key12 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err196];
                            } else {
                              vErrors.push(err196);
                            }
                            errors++;
                          }
                        }
                        if (data79.page !== void 0) {
                          let data80 = data79.page;
                          if (!(typeof data80 == "number" && isFinite(data80))) {
                            const err197 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6 + "/citation/page", schemaPath: "#/properties/submittedPlans/items/properties/findings/items/properties/citation/properties/page/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                            if (vErrors === null) {
                              vErrors = [err197];
                            } else {
                              vErrors.push(err197);
                            }
                            errors++;
                          }
                        }
                        if (data79.section !== void 0) {
                          if (typeof data79.section !== "string") {
                            const err198 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6 + "/citation/section", schemaPath: "#/properties/submittedPlans/items/properties/findings/items/properties/citation/properties/section/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err198];
                            } else {
                              vErrors.push(err198);
                            }
                            errors++;
                          }
                        }
                        if (data79.lineText !== void 0) {
                          if (typeof data79.lineText !== "string") {
                            const err199 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6 + "/citation/lineText", schemaPath: "#/properties/submittedPlans/items/properties/findings/items/properties/citation/properties/lineText/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err199];
                            } else {
                              vErrors.push(err199);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err200 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6 + "/citation", schemaPath: "#/properties/submittedPlans/items/properties/findings/items/properties/citation/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err200];
                        } else {
                          vErrors.push(err200);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err201 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings/" + i6, schemaPath: "#/properties/submittedPlans/items/properties/findings/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err201];
                    } else {
                      vErrors.push(err201);
                    }
                    errors++;
                  }
                }
              } else {
                const err202 = { instancePath: instancePath + "/submittedPlans/" + i4 + "/findings", schemaPath: "#/properties/submittedPlans/items/properties/findings/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err202];
                } else {
                  vErrors.push(err202);
                }
                errors++;
              }
            }
          } else {
            const err203 = { instancePath: instancePath + "/submittedPlans/" + i4, schemaPath: "#/properties/submittedPlans/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err203];
            } else {
              vErrors.push(err203);
            }
            errors++;
          }
        }
      } else {
        const err204 = { instancePath: instancePath + "/submittedPlans", schemaPath: "#/properties/submittedPlans/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err204];
        } else {
          vErrors.push(err204);
        }
        errors++;
      }
    }
    if (data.canContinue !== void 0) {
      if (typeof data.canContinue !== "boolean") {
        const err205 = { instancePath: instancePath + "/canContinue", schemaPath: "#/properties/canContinue/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err205];
        } else {
          vErrors.push(err205);
        }
        errors++;
      }
    }
  } else {
    const err206 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err206];
    } else {
      vErrors.push(err206);
    }
    errors++;
  }
  validate19.errors = vErrors;
  return errors === 0;
}
var validateInput5 = validate20;
function validate20(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      if (!(key0 === "query" || key0 === "numbers" || key0 === "limit" || key0 === "startingAfter")) {
        const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.query !== void 0) {
      let data0 = data.query;
      if (typeof data0 === "string") {
        if (func2(data0) > 200) {
          const err1 = { instancePath: instancePath + "/query", schemaPath: "#/properties/query/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
      } else {
        const err2 = { instancePath: instancePath + "/query", schemaPath: "#/properties/query/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.numbers !== void 0) {
      let data1 = data.numbers;
      if (typeof data1 === "string") {
        if (func2(data1) > 500) {
          const err3 = { instancePath: instancePath + "/numbers", schemaPath: "#/properties/numbers/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      } else {
        const err4 = { instancePath: instancePath + "/numbers", schemaPath: "#/properties/numbers/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.limit !== void 0) {
      let data2 = data.limit;
      if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)) && isFinite(data2))) {
        const err5 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if (typeof data2 == "number" && isFinite(data2)) {
        if (data2 > 100 || isNaN(data2)) {
          const err6 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 100 }, message: "must be <= 100" };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
        if (data2 < 1 || isNaN(data2)) {
          const err7 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      }
    }
    if (data.startingAfter !== void 0) {
      let data3 = data.startingAfter;
      if (typeof data3 === "string") {
        if (func2(data3) < 1) {
          const err8 = { instancePath: instancePath + "/startingAfter", schemaPath: "#/properties/startingAfter/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
      } else {
        const err9 = { instancePath: instancePath + "/startingAfter", schemaPath: "#/properties/startingAfter/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
  } else {
    const err10 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  validate20.errors = vErrors;
  return errors === 0;
}
var validateOutput5 = validate21;
var schema23 = { "type": "object", "properties": { "id": { "type": "string" }, "sourceId": { "type": "string", "const": "goz-2012" }, "number": { "type": "string" }, "section": { "type": "string" }, "sectionTitle": { "type": "string" }, "description": { "type": "string" }, "notes": { "type": "array", "items": { "type": "string" } }, "points": { "type": "number" }, "pointValueEur": { "type": "number" }, "constraints": { "type": "array", "items": { "type": "object", "properties": { "kind": { "type": "string", "enum": ["not_combinable", "once_per_case", "requires_justification", "material_separate", "custom"] }, "text": { "type": "string" }, "refs": { "type": "array", "items": { "type": "string" } } }, "required": ["kind", "text"], "additionalProperties": false } }, "citation": { "type": "object", "properties": { "page": { "type": "number" }, "section": { "type": "string" }, "lineText": { "type": "string" } }, "required": ["page"], "additionalProperties": false }, "object": { "type": "string", "const": "goz_position" }, "amounts": { "anyOf": [{ "type": "object", "properties": { "simple": { "type": "number" }, "threshold": { "type": "number" }, "max": { "type": "number" } }, "required": ["simple", "threshold", "max"], "additionalProperties": false }, { "type": "null" }], "description": "Euro amounts at the factors 1.0, 2.3 and 3.5; null without points." } }, "required": ["id", "sourceId", "number", "section", "sectionTitle", "description", "notes", "pointValueEur", "constraints", "citation", "object", "amounts"], "additionalProperties": false };
function validate21(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.data === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property 'data'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.has_more === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "has_more" }, message: "must have required property 'has_more'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.url === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.total === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "total" }, message: "must have required property 'total'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "data" || key0 === "has_more" || key0 === "url" || key0 === "total" || key0 === "missing")) {
        const err5 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err6 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if ("list" !== data0) {
        const err7 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "list" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.data !== void 0) {
      let data1 = data.data;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.id === void 0) {
              const err8 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (data2.sourceId === void 0) {
              const err9 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/required", keyword: "required", params: { missingProperty: "sourceId" }, message: "must have required property 'sourceId'" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            if (data2.number === void 0) {
              const err10 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/required", keyword: "required", params: { missingProperty: "number" }, message: "must have required property 'number'" };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if (data2.section === void 0) {
              const err11 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/required", keyword: "required", params: { missingProperty: "section" }, message: "must have required property 'section'" };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if (data2.sectionTitle === void 0) {
              const err12 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/required", keyword: "required", params: { missingProperty: "sectionTitle" }, message: "must have required property 'sectionTitle'" };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if (data2.description === void 0) {
              const err13 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property 'description'" };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
            }
            if (data2.notes === void 0) {
              const err14 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/required", keyword: "required", params: { missingProperty: "notes" }, message: "must have required property 'notes'" };
              if (vErrors === null) {
                vErrors = [err14];
              } else {
                vErrors.push(err14);
              }
              errors++;
            }
            if (data2.pointValueEur === void 0) {
              const err15 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/required", keyword: "required", params: { missingProperty: "pointValueEur" }, message: "must have required property 'pointValueEur'" };
              if (vErrors === null) {
                vErrors = [err15];
              } else {
                vErrors.push(err15);
              }
              errors++;
            }
            if (data2.constraints === void 0) {
              const err16 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/required", keyword: "required", params: { missingProperty: "constraints" }, message: "must have required property 'constraints'" };
              if (vErrors === null) {
                vErrors = [err16];
              } else {
                vErrors.push(err16);
              }
              errors++;
            }
            if (data2.citation === void 0) {
              const err17 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/required", keyword: "required", params: { missingProperty: "citation" }, message: "must have required property 'citation'" };
              if (vErrors === null) {
                vErrors = [err17];
              } else {
                vErrors.push(err17);
              }
              errors++;
            }
            if (data2.object === void 0) {
              const err18 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
              if (vErrors === null) {
                vErrors = [err18];
              } else {
                vErrors.push(err18);
              }
              errors++;
            }
            if (data2.amounts === void 0) {
              const err19 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/required", keyword: "required", params: { missingProperty: "amounts" }, message: "must have required property 'amounts'" };
              if (vErrors === null) {
                vErrors = [err19];
              } else {
                vErrors.push(err19);
              }
              errors++;
            }
            for (const key1 in data2) {
              if (!func4.call(schema23.properties, key1)) {
                const err20 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
            }
            if (data2.id !== void 0) {
              if (typeof data2.id !== "string") {
                const err21 = { instancePath: instancePath + "/data/" + i0 + "/id", schemaPath: "#/definitions/GozPosition/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err21];
                } else {
                  vErrors.push(err21);
                }
                errors++;
              }
            }
            if (data2.sourceId !== void 0) {
              let data4 = data2.sourceId;
              if (typeof data4 !== "string") {
                const err22 = { instancePath: instancePath + "/data/" + i0 + "/sourceId", schemaPath: "#/definitions/GozPosition/properties/sourceId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
              if ("goz-2012" !== data4) {
                const err23 = { instancePath: instancePath + "/data/" + i0 + "/sourceId", schemaPath: "#/definitions/GozPosition/properties/sourceId/const", keyword: "const", params: { allowedValue: "goz-2012" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
            if (data2.number !== void 0) {
              if (typeof data2.number !== "string") {
                const err24 = { instancePath: instancePath + "/data/" + i0 + "/number", schemaPath: "#/definitions/GozPosition/properties/number/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err24];
                } else {
                  vErrors.push(err24);
                }
                errors++;
              }
            }
            if (data2.section !== void 0) {
              if (typeof data2.section !== "string") {
                const err25 = { instancePath: instancePath + "/data/" + i0 + "/section", schemaPath: "#/definitions/GozPosition/properties/section/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err25];
                } else {
                  vErrors.push(err25);
                }
                errors++;
              }
            }
            if (data2.sectionTitle !== void 0) {
              if (typeof data2.sectionTitle !== "string") {
                const err26 = { instancePath: instancePath + "/data/" + i0 + "/sectionTitle", schemaPath: "#/definitions/GozPosition/properties/sectionTitle/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err26];
                } else {
                  vErrors.push(err26);
                }
                errors++;
              }
            }
            if (data2.description !== void 0) {
              if (typeof data2.description !== "string") {
                const err27 = { instancePath: instancePath + "/data/" + i0 + "/description", schemaPath: "#/definitions/GozPosition/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
            }
            if (data2.notes !== void 0) {
              let data9 = data2.notes;
              if (Array.isArray(data9)) {
                const len1 = data9.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  if (typeof data9[i1] !== "string") {
                    const err28 = { instancePath: instancePath + "/data/" + i0 + "/notes/" + i1, schemaPath: "#/definitions/GozPosition/properties/notes/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err28];
                    } else {
                      vErrors.push(err28);
                    }
                    errors++;
                  }
                }
              } else {
                const err29 = { instancePath: instancePath + "/data/" + i0 + "/notes", schemaPath: "#/definitions/GozPosition/properties/notes/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err29];
                } else {
                  vErrors.push(err29);
                }
                errors++;
              }
            }
            if (data2.points !== void 0) {
              let data11 = data2.points;
              if (!(typeof data11 == "number" && isFinite(data11))) {
                const err30 = { instancePath: instancePath + "/data/" + i0 + "/points", schemaPath: "#/definitions/GozPosition/properties/points/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                if (vErrors === null) {
                  vErrors = [err30];
                } else {
                  vErrors.push(err30);
                }
                errors++;
              }
            }
            if (data2.pointValueEur !== void 0) {
              let data12 = data2.pointValueEur;
              if (!(typeof data12 == "number" && isFinite(data12))) {
                const err31 = { instancePath: instancePath + "/data/" + i0 + "/pointValueEur", schemaPath: "#/definitions/GozPosition/properties/pointValueEur/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                if (vErrors === null) {
                  vErrors = [err31];
                } else {
                  vErrors.push(err31);
                }
                errors++;
              }
            }
            if (data2.constraints !== void 0) {
              let data13 = data2.constraints;
              if (Array.isArray(data13)) {
                const len2 = data13.length;
                for (let i2 = 0; i2 < len2; i2++) {
                  let data14 = data13[i2];
                  if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
                    if (data14.kind === void 0) {
                      const err32 = { instancePath: instancePath + "/data/" + i0 + "/constraints/" + i2, schemaPath: "#/definitions/GozPosition/properties/constraints/items/required", keyword: "required", params: { missingProperty: "kind" }, message: "must have required property 'kind'" };
                      if (vErrors === null) {
                        vErrors = [err32];
                      } else {
                        vErrors.push(err32);
                      }
                      errors++;
                    }
                    if (data14.text === void 0) {
                      const err33 = { instancePath: instancePath + "/data/" + i0 + "/constraints/" + i2, schemaPath: "#/definitions/GozPosition/properties/constraints/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                      if (vErrors === null) {
                        vErrors = [err33];
                      } else {
                        vErrors.push(err33);
                      }
                      errors++;
                    }
                    for (const key2 in data14) {
                      if (!(key2 === "kind" || key2 === "text" || key2 === "refs")) {
                        const err34 = { instancePath: instancePath + "/data/" + i0 + "/constraints/" + i2, schemaPath: "#/definitions/GozPosition/properties/constraints/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err34];
                        } else {
                          vErrors.push(err34);
                        }
                        errors++;
                      }
                    }
                    if (data14.kind !== void 0) {
                      let data15 = data14.kind;
                      if (typeof data15 !== "string") {
                        const err35 = { instancePath: instancePath + "/data/" + i0 + "/constraints/" + i2 + "/kind", schemaPath: "#/definitions/GozPosition/properties/constraints/items/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err35];
                        } else {
                          vErrors.push(err35);
                        }
                        errors++;
                      }
                      if (!(data15 === "not_combinable" || data15 === "once_per_case" || data15 === "requires_justification" || data15 === "material_separate" || data15 === "custom")) {
                        const err36 = { instancePath: instancePath + "/data/" + i0 + "/constraints/" + i2 + "/kind", schemaPath: "#/definitions/GozPosition/properties/constraints/items/properties/kind/enum", keyword: "enum", params: { allowedValues: schema23.properties.constraints.items.properties.kind.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err36];
                        } else {
                          vErrors.push(err36);
                        }
                        errors++;
                      }
                    }
                    if (data14.text !== void 0) {
                      if (typeof data14.text !== "string") {
                        const err37 = { instancePath: instancePath + "/data/" + i0 + "/constraints/" + i2 + "/text", schemaPath: "#/definitions/GozPosition/properties/constraints/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err37];
                        } else {
                          vErrors.push(err37);
                        }
                        errors++;
                      }
                    }
                    if (data14.refs !== void 0) {
                      let data17 = data14.refs;
                      if (Array.isArray(data17)) {
                        const len3 = data17.length;
                        for (let i3 = 0; i3 < len3; i3++) {
                          if (typeof data17[i3] !== "string") {
                            const err38 = { instancePath: instancePath + "/data/" + i0 + "/constraints/" + i2 + "/refs/" + i3, schemaPath: "#/definitions/GozPosition/properties/constraints/items/properties/refs/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err38];
                            } else {
                              vErrors.push(err38);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err39 = { instancePath: instancePath + "/data/" + i0 + "/constraints/" + i2 + "/refs", schemaPath: "#/definitions/GozPosition/properties/constraints/items/properties/refs/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                          vErrors = [err39];
                        } else {
                          vErrors.push(err39);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err40 = { instancePath: instancePath + "/data/" + i0 + "/constraints/" + i2, schemaPath: "#/definitions/GozPosition/properties/constraints/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err40];
                    } else {
                      vErrors.push(err40);
                    }
                    errors++;
                  }
                }
              } else {
                const err41 = { instancePath: instancePath + "/data/" + i0 + "/constraints", schemaPath: "#/definitions/GozPosition/properties/constraints/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err41];
                } else {
                  vErrors.push(err41);
                }
                errors++;
              }
            }
            if (data2.citation !== void 0) {
              let data19 = data2.citation;
              if (data19 && typeof data19 == "object" && !Array.isArray(data19)) {
                if (data19.page === void 0) {
                  const err42 = { instancePath: instancePath + "/data/" + i0 + "/citation", schemaPath: "#/definitions/GozPosition/properties/citation/required", keyword: "required", params: { missingProperty: "page" }, message: "must have required property 'page'" };
                  if (vErrors === null) {
                    vErrors = [err42];
                  } else {
                    vErrors.push(err42);
                  }
                  errors++;
                }
                for (const key3 in data19) {
                  if (!(key3 === "page" || key3 === "section" || key3 === "lineText")) {
                    const err43 = { instancePath: instancePath + "/data/" + i0 + "/citation", schemaPath: "#/definitions/GozPosition/properties/citation/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err43];
                    } else {
                      vErrors.push(err43);
                    }
                    errors++;
                  }
                }
                if (data19.page !== void 0) {
                  let data20 = data19.page;
                  if (!(typeof data20 == "number" && isFinite(data20))) {
                    const err44 = { instancePath: instancePath + "/data/" + i0 + "/citation/page", schemaPath: "#/definitions/GozPosition/properties/citation/properties/page/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                    if (vErrors === null) {
                      vErrors = [err44];
                    } else {
                      vErrors.push(err44);
                    }
                    errors++;
                  }
                }
                if (data19.section !== void 0) {
                  if (typeof data19.section !== "string") {
                    const err45 = { instancePath: instancePath + "/data/" + i0 + "/citation/section", schemaPath: "#/definitions/GozPosition/properties/citation/properties/section/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err45];
                    } else {
                      vErrors.push(err45);
                    }
                    errors++;
                  }
                }
                if (data19.lineText !== void 0) {
                  if (typeof data19.lineText !== "string") {
                    const err46 = { instancePath: instancePath + "/data/" + i0 + "/citation/lineText", schemaPath: "#/definitions/GozPosition/properties/citation/properties/lineText/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err46];
                    } else {
                      vErrors.push(err46);
                    }
                    errors++;
                  }
                }
              } else {
                const err47 = { instancePath: instancePath + "/data/" + i0 + "/citation", schemaPath: "#/definitions/GozPosition/properties/citation/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err47];
                } else {
                  vErrors.push(err47);
                }
                errors++;
              }
            }
            if (data2.object !== void 0) {
              let data23 = data2.object;
              if (typeof data23 !== "string") {
                const err48 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/definitions/GozPosition/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err48];
                } else {
                  vErrors.push(err48);
                }
                errors++;
              }
              if ("goz_position" !== data23) {
                const err49 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/definitions/GozPosition/properties/object/const", keyword: "const", params: { allowedValue: "goz_position" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err49];
                } else {
                  vErrors.push(err49);
                }
                errors++;
              }
            }
            if (data2.amounts !== void 0) {
              let data24 = data2.amounts;
              const _errs55 = errors;
              let valid13 = false;
              const _errs56 = errors;
              if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
                if (data24.simple === void 0) {
                  const err50 = { instancePath: instancePath + "/data/" + i0 + "/amounts", schemaPath: "#/definitions/GozPosition/properties/amounts/anyOf/0/required", keyword: "required", params: { missingProperty: "simple" }, message: "must have required property 'simple'" };
                  if (vErrors === null) {
                    vErrors = [err50];
                  } else {
                    vErrors.push(err50);
                  }
                  errors++;
                }
                if (data24.threshold === void 0) {
                  const err51 = { instancePath: instancePath + "/data/" + i0 + "/amounts", schemaPath: "#/definitions/GozPosition/properties/amounts/anyOf/0/required", keyword: "required", params: { missingProperty: "threshold" }, message: "must have required property 'threshold'" };
                  if (vErrors === null) {
                    vErrors = [err51];
                  } else {
                    vErrors.push(err51);
                  }
                  errors++;
                }
                if (data24.max === void 0) {
                  const err52 = { instancePath: instancePath + "/data/" + i0 + "/amounts", schemaPath: "#/definitions/GozPosition/properties/amounts/anyOf/0/required", keyword: "required", params: { missingProperty: "max" }, message: "must have required property 'max'" };
                  if (vErrors === null) {
                    vErrors = [err52];
                  } else {
                    vErrors.push(err52);
                  }
                  errors++;
                }
                for (const key4 in data24) {
                  if (!(key4 === "simple" || key4 === "threshold" || key4 === "max")) {
                    const err53 = { instancePath: instancePath + "/data/" + i0 + "/amounts", schemaPath: "#/definitions/GozPosition/properties/amounts/anyOf/0/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err53];
                    } else {
                      vErrors.push(err53);
                    }
                    errors++;
                  }
                }
                if (data24.simple !== void 0) {
                  let data25 = data24.simple;
                  if (!(typeof data25 == "number" && isFinite(data25))) {
                    const err54 = { instancePath: instancePath + "/data/" + i0 + "/amounts/simple", schemaPath: "#/definitions/GozPosition/properties/amounts/anyOf/0/properties/simple/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                    if (vErrors === null) {
                      vErrors = [err54];
                    } else {
                      vErrors.push(err54);
                    }
                    errors++;
                  }
                }
                if (data24.threshold !== void 0) {
                  let data26 = data24.threshold;
                  if (!(typeof data26 == "number" && isFinite(data26))) {
                    const err55 = { instancePath: instancePath + "/data/" + i0 + "/amounts/threshold", schemaPath: "#/definitions/GozPosition/properties/amounts/anyOf/0/properties/threshold/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                    if (vErrors === null) {
                      vErrors = [err55];
                    } else {
                      vErrors.push(err55);
                    }
                    errors++;
                  }
                }
                if (data24.max !== void 0) {
                  let data27 = data24.max;
                  if (!(typeof data27 == "number" && isFinite(data27))) {
                    const err56 = { instancePath: instancePath + "/data/" + i0 + "/amounts/max", schemaPath: "#/definitions/GozPosition/properties/amounts/anyOf/0/properties/max/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                    if (vErrors === null) {
                      vErrors = [err56];
                    } else {
                      vErrors.push(err56);
                    }
                    errors++;
                  }
                }
              } else {
                const err57 = { instancePath: instancePath + "/data/" + i0 + "/amounts", schemaPath: "#/definitions/GozPosition/properties/amounts/anyOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err57];
                } else {
                  vErrors.push(err57);
                }
                errors++;
              }
              var _valid0 = _errs56 === errors;
              valid13 = valid13 || _valid0;
              if (!valid13) {
                const _errs65 = errors;
                if (data24 !== null) {
                  const err58 = { instancePath: instancePath + "/data/" + i0 + "/amounts", schemaPath: "#/definitions/GozPosition/properties/amounts/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err58];
                  } else {
                    vErrors.push(err58);
                  }
                  errors++;
                }
                var _valid0 = _errs65 === errors;
                valid13 = valid13 || _valid0;
              }
              if (!valid13) {
                const err59 = { instancePath: instancePath + "/data/" + i0 + "/amounts", schemaPath: "#/definitions/GozPosition/properties/amounts/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err59];
                } else {
                  vErrors.push(err59);
                }
                errors++;
              } else {
                errors = _errs55;
                if (vErrors !== null) {
                  if (_errs55) {
                    vErrors.length = _errs55;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
          } else {
            const err60 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/GozPosition/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err60];
            } else {
              vErrors.push(err60);
            }
            errors++;
          }
        }
      } else {
        const err61 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err61];
        } else {
          vErrors.push(err61);
        }
        errors++;
      }
    }
    if (data.has_more !== void 0) {
      if (typeof data.has_more !== "boolean") {
        const err62 = { instancePath: instancePath + "/has_more", schemaPath: "#/properties/has_more/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err62];
        } else {
          vErrors.push(err62);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      if (typeof data.url !== "string") {
        const err63 = { instancePath: instancePath + "/url", schemaPath: "#/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err63];
        } else {
          vErrors.push(err63);
        }
        errors++;
      }
    }
    if (data.total !== void 0) {
      let data30 = data.total;
      if (!(typeof data30 == "number" && (!(data30 % 1) && !isNaN(data30)) && isFinite(data30))) {
        const err64 = { instancePath: instancePath + "/total", schemaPath: "#/properties/total/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err64];
        } else {
          vErrors.push(err64);
        }
        errors++;
      }
      if (typeof data30 == "number" && isFinite(data30)) {
        if (data30 > 9007199254740991 || isNaN(data30)) {
          const err65 = { instancePath: instancePath + "/total", schemaPath: "#/properties/total/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err65];
          } else {
            vErrors.push(err65);
          }
          errors++;
        }
        if (data30 < -9007199254740991 || isNaN(data30)) {
          const err66 = { instancePath: instancePath + "/total", schemaPath: "#/properties/total/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
          if (vErrors === null) {
            vErrors = [err66];
          } else {
            vErrors.push(err66);
          }
          errors++;
        }
      }
    }
    if (data.missing !== void 0) {
      let data31 = data.missing;
      if (Array.isArray(data31)) {
        const len4 = data31.length;
        for (let i4 = 0; i4 < len4; i4++) {
          if (typeof data31[i4] !== "string") {
            const err67 = { instancePath: instancePath + "/missing/" + i4, schemaPath: "#/properties/missing/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err67];
            } else {
              vErrors.push(err67);
            }
            errors++;
          }
        }
      } else {
        const err68 = { instancePath: instancePath + "/missing", schemaPath: "#/properties/missing/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err68];
        } else {
          vErrors.push(err68);
        }
        errors++;
      }
    }
  } else {
    const err69 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err69];
    } else {
      vErrors.push(err69);
    }
    errors++;
  }
  validate21.errors = vErrors;
  return errors === 0;
}
var validateInput6 = validate22;
function validate22(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      let data0 = data.id;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err2 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate22.errors = vErrors;
  return errors === 0;
}
var validateOutput6 = validate23;
function validate23(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/definitions/GozRule/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.sourceId === void 0) {
      const err1 = { instancePath, schemaPath: "#/definitions/GozRule/required", keyword: "required", params: { missingProperty: "sourceId" }, message: "must have required property 'sourceId'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.paragraph === void 0) {
      const err2 = { instancePath, schemaPath: "#/definitions/GozRule/required", keyword: "required", params: { missingProperty: "paragraph" }, message: "must have required property 'paragraph'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.title === void 0) {
      const err3 = { instancePath, schemaPath: "#/definitions/GozRule/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.text === void 0) {
      const err4 = { instancePath, schemaPath: "#/definitions/GozRule/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.normalizedFacts === void 0) {
      const err5 = { instancePath, schemaPath: "#/definitions/GozRule/required", keyword: "required", params: { missingProperty: "normalizedFacts" }, message: "must have required property 'normalizedFacts'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.citation === void 0) {
      const err6 = { instancePath, schemaPath: "#/definitions/GozRule/required", keyword: "required", params: { missingProperty: "citation" }, message: "must have required property 'citation'" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.object === void 0) {
      const err7 = { instancePath, schemaPath: "#/definitions/GozRule/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id" || key0 === "sourceId" || key0 === "paragraph" || key0 === "title" || key0 === "text" || key0 === "normalizedFacts" || key0 === "citation" || key0 === "object")) {
        const err8 = { instancePath, schemaPath: "#/definitions/GozRule/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err9 = { instancePath: instancePath + "/id", schemaPath: "#/definitions/GozRule/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.sourceId !== void 0) {
      let data1 = data.sourceId;
      if (typeof data1 !== "string") {
        const err10 = { instancePath: instancePath + "/sourceId", schemaPath: "#/definitions/GozRule/properties/sourceId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if ("goz-2012" !== data1) {
        const err11 = { instancePath: instancePath + "/sourceId", schemaPath: "#/definitions/GozRule/properties/sourceId/const", keyword: "const", params: { allowedValue: "goz-2012" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.paragraph !== void 0) {
      if (typeof data.paragraph !== "string") {
        const err12 = { instancePath: instancePath + "/paragraph", schemaPath: "#/definitions/GozRule/properties/paragraph/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.title !== void 0) {
      if (typeof data.title !== "string") {
        const err13 = { instancePath: instancePath + "/title", schemaPath: "#/definitions/GozRule/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.text !== void 0) {
      if (typeof data.text !== "string") {
        const err14 = { instancePath: instancePath + "/text", schemaPath: "#/definitions/GozRule/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.normalizedFacts !== void 0) {
      let data5 = data.normalizedFacts;
      if (Array.isArray(data5)) {
        const len0 = data5.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data5[i0] !== "string") {
            const err15 = { instancePath: instancePath + "/normalizedFacts/" + i0, schemaPath: "#/definitions/GozRule/properties/normalizedFacts/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
      } else {
        const err16 = { instancePath: instancePath + "/normalizedFacts", schemaPath: "#/definitions/GozRule/properties/normalizedFacts/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.citation !== void 0) {
      let data7 = data.citation;
      if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
        if (data7.page === void 0) {
          const err17 = { instancePath: instancePath + "/citation", schemaPath: "#/definitions/GozRule/properties/citation/required", keyword: "required", params: { missingProperty: "page" }, message: "must have required property 'page'" };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
        for (const key1 in data7) {
          if (!(key1 === "page" || key1 === "section" || key1 === "lineText")) {
            const err18 = { instancePath: instancePath + "/citation", schemaPath: "#/definitions/GozRule/properties/citation/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err18];
            } else {
              vErrors.push(err18);
            }
            errors++;
          }
        }
        if (data7.page !== void 0) {
          let data8 = data7.page;
          if (!(typeof data8 == "number" && isFinite(data8))) {
            const err19 = { instancePath: instancePath + "/citation/page", schemaPath: "#/definitions/GozRule/properties/citation/properties/page/type", keyword: "type", params: { type: "number" }, message: "must be number" };
            if (vErrors === null) {
              vErrors = [err19];
            } else {
              vErrors.push(err19);
            }
            errors++;
          }
        }
        if (data7.section !== void 0) {
          if (typeof data7.section !== "string") {
            const err20 = { instancePath: instancePath + "/citation/section", schemaPath: "#/definitions/GozRule/properties/citation/properties/section/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          }
        }
        if (data7.lineText !== void 0) {
          if (typeof data7.lineText !== "string") {
            const err21 = { instancePath: instancePath + "/citation/lineText", schemaPath: "#/definitions/GozRule/properties/citation/properties/lineText/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
        }
      } else {
        const err22 = { instancePath: instancePath + "/citation", schemaPath: "#/definitions/GozRule/properties/citation/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err22];
        } else {
          vErrors.push(err22);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data11 = data.object;
      if (typeof data11 !== "string") {
        const err23 = { instancePath: instancePath + "/object", schemaPath: "#/definitions/GozRule/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err23];
        } else {
          vErrors.push(err23);
        }
        errors++;
      }
      if ("goz_rule" !== data11) {
        const err24 = { instancePath: instancePath + "/object", schemaPath: "#/definitions/GozRule/properties/object/const", keyword: "const", params: { allowedValue: "goz_rule" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      }
    }
  } else {
    const err25 = { instancePath, schemaPath: "#/definitions/GozRule/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err25];
    } else {
      vErrors.push(err25);
    }
    errors++;
  }
  validate23.errors = vErrors;
  return errors === 0;
}
var validateInput7 = validate24;
function validate24(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      if (!(key0 === "prefix" || key0 === "limit" || key0 === "startingAfter")) {
        const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.prefix !== void 0) {
      if (typeof data.prefix !== "string") {
        const err1 = { instancePath: instancePath + "/prefix", schemaPath: "#/properties/prefix/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.limit !== void 0) {
      let data1 = data.limit;
      if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)) && isFinite(data1))) {
        const err2 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (typeof data1 == "number" && isFinite(data1)) {
        if (data1 > 100 || isNaN(data1)) {
          const err3 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 100 }, message: "must be <= 100" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
        if (data1 < 1 || isNaN(data1)) {
          const err4 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
      }
    }
    if (data.startingAfter !== void 0) {
      let data2 = data.startingAfter;
      if (typeof data2 === "string") {
        if (func2(data2) < 1) {
          const err5 = { instancePath: instancePath + "/startingAfter", schemaPath: "#/properties/startingAfter/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
      } else {
        const err6 = { instancePath: instancePath + "/startingAfter", schemaPath: "#/properties/startingAfter/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
  } else {
    const err7 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err7];
    } else {
      vErrors.push(err7);
    }
    errors++;
  }
  validate24.errors = vErrors;
  return errors === 0;
}
var validateOutput7 = validate25;
var schema29 = { "type": "object", "properties": { "object": { "type": "string", "const": "file" }, "path": { "type": "string" }, "mimeType": { "type": "string" }, "size": { "type": "integer", "minimum": 0, "maximum": 9007199254740991 }, "contentHash": { "type": "string", "description": "SHA-256 of the content." }, "revision": { "type": "integer", "exclusiveMinimum": 0, "maximum": 9007199254740991 }, "metadata": { "type": "object", "propertyNames": { "type": "string" }, "additionalProperties": { "anyOf": [{ "type": "string" }, { "type": "number" }, { "type": "boolean" }, { "type": "null" }] } }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "updatedAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" } }, "required": ["object", "path", "mimeType", "size", "contentHash", "revision", "metadata", "createdAt", "updatedAt"], "additionalProperties": false };
function validate25(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.data === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property 'data'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.has_more === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "has_more" }, message: "must have required property 'has_more'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.url === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "data" || key0 === "has_more" || key0 === "url")) {
        const err4 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if ("list" !== data0) {
        const err6 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "list" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.data !== void 0) {
      let data1 = data.data;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.object === void 0) {
              const err7 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            if (data2.path === void 0) {
              const err8 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (data2.mimeType === void 0) {
              const err9 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "mimeType" }, message: "must have required property 'mimeType'" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            if (data2.size === void 0) {
              const err10 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "size" }, message: "must have required property 'size'" };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if (data2.contentHash === void 0) {
              const err11 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "contentHash" }, message: "must have required property 'contentHash'" };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if (data2.revision === void 0) {
              const err12 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property 'revision'" };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if (data2.metadata === void 0) {
              const err13 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "metadata" }, message: "must have required property 'metadata'" };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
            }
            if (data2.createdAt === void 0) {
              const err14 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
              if (vErrors === null) {
                vErrors = [err14];
              } else {
                vErrors.push(err14);
              }
              errors++;
            }
            if (data2.updatedAt === void 0) {
              const err15 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "updatedAt" }, message: "must have required property 'updatedAt'" };
              if (vErrors === null) {
                vErrors = [err15];
              } else {
                vErrors.push(err15);
              }
              errors++;
            }
            for (const key1 in data2) {
              if (!func4.call(schema29.properties, key1)) {
                const err16 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
            }
            if (data2.object !== void 0) {
              let data3 = data2.object;
              if (typeof data3 !== "string") {
                const err17 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/definitions/File/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
              if ("file" !== data3) {
                const err18 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/definitions/File/properties/object/const", keyword: "const", params: { allowedValue: "file" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
            }
            if (data2.path !== void 0) {
              if (typeof data2.path !== "string") {
                const err19 = { instancePath: instancePath + "/data/" + i0 + "/path", schemaPath: "#/definitions/File/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
            }
            if (data2.mimeType !== void 0) {
              if (typeof data2.mimeType !== "string") {
                const err20 = { instancePath: instancePath + "/data/" + i0 + "/mimeType", schemaPath: "#/definitions/File/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
            }
            if (data2.size !== void 0) {
              let data6 = data2.size;
              if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)) && isFinite(data6))) {
                const err21 = { instancePath: instancePath + "/data/" + i0 + "/size", schemaPath: "#/definitions/File/properties/size/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err21];
                } else {
                  vErrors.push(err21);
                }
                errors++;
              }
              if (typeof data6 == "number" && isFinite(data6)) {
                if (data6 > 9007199254740991 || isNaN(data6)) {
                  const err22 = { instancePath: instancePath + "/data/" + i0 + "/size", schemaPath: "#/definitions/File/properties/size/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err22];
                  } else {
                    vErrors.push(err22);
                  }
                  errors++;
                }
                if (data6 < 0 || isNaN(data6)) {
                  const err23 = { instancePath: instancePath + "/data/" + i0 + "/size", schemaPath: "#/definitions/File/properties/size/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                  if (vErrors === null) {
                    vErrors = [err23];
                  } else {
                    vErrors.push(err23);
                  }
                  errors++;
                }
              }
            }
            if (data2.contentHash !== void 0) {
              if (typeof data2.contentHash !== "string") {
                const err24 = { instancePath: instancePath + "/data/" + i0 + "/contentHash", schemaPath: "#/definitions/File/properties/contentHash/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err24];
                } else {
                  vErrors.push(err24);
                }
                errors++;
              }
            }
            if (data2.revision !== void 0) {
              let data8 = data2.revision;
              if (!(typeof data8 == "number" && (!(data8 % 1) && !isNaN(data8)) && isFinite(data8))) {
                const err25 = { instancePath: instancePath + "/data/" + i0 + "/revision", schemaPath: "#/definitions/File/properties/revision/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err25];
                } else {
                  vErrors.push(err25);
                }
                errors++;
              }
              if (typeof data8 == "number" && isFinite(data8)) {
                if (data8 > 9007199254740991 || isNaN(data8)) {
                  const err26 = { instancePath: instancePath + "/data/" + i0 + "/revision", schemaPath: "#/definitions/File/properties/revision/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err26];
                  } else {
                    vErrors.push(err26);
                  }
                  errors++;
                }
                if (data8 <= 0 || isNaN(data8)) {
                  const err27 = { instancePath: instancePath + "/data/" + i0 + "/revision", schemaPath: "#/definitions/File/properties/revision/exclusiveMinimum", keyword: "exclusiveMinimum", params: { comparison: ">", limit: 0 }, message: "must be > 0" };
                  if (vErrors === null) {
                    vErrors = [err27];
                  } else {
                    vErrors.push(err27);
                  }
                  errors++;
                }
              }
            }
            if (data2.metadata !== void 0) {
              let data9 = data2.metadata;
              if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
                for (const key2 in data9) {
                  const _errs24 = errors;
                  if (typeof key2 !== "string") {
                    const err28 = { instancePath: instancePath + "/data/" + i0 + "/metadata", schemaPath: "#/definitions/File/properties/metadata/propertyNames/type", keyword: "type", params: { type: "string" }, message: "must be string", propertyName: key2 };
                    if (vErrors === null) {
                      vErrors = [err28];
                    } else {
                      vErrors.push(err28);
                    }
                    errors++;
                  }
                  var valid5 = _errs24 === errors;
                  if (!valid5) {
                    const err29 = { instancePath: instancePath + "/data/" + i0 + "/metadata", schemaPath: "#/definitions/File/properties/metadata/propertyNames", keyword: "propertyNames", params: { propertyName: key2 }, message: "property name must be valid" };
                    if (vErrors === null) {
                      vErrors = [err29];
                    } else {
                      vErrors.push(err29);
                    }
                    errors++;
                  }
                }
                for (const key3 in data9) {
                  let data10 = data9[key3];
                  const _errs28 = errors;
                  let valid7 = false;
                  const _errs29 = errors;
                  if (typeof data10 !== "string") {
                    const err30 = { instancePath: instancePath + "/data/" + i0 + "/metadata/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/definitions/File/properties/metadata/additionalProperties/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err30];
                    } else {
                      vErrors.push(err30);
                    }
                    errors++;
                  }
                  var _valid0 = _errs29 === errors;
                  valid7 = valid7 || _valid0;
                  if (!valid7) {
                    const _errs31 = errors;
                    if (!(typeof data10 == "number" && isFinite(data10))) {
                      const err31 = { instancePath: instancePath + "/data/" + i0 + "/metadata/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/definitions/File/properties/metadata/additionalProperties/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                      if (vErrors === null) {
                        vErrors = [err31];
                      } else {
                        vErrors.push(err31);
                      }
                      errors++;
                    }
                    var _valid0 = _errs31 === errors;
                    valid7 = valid7 || _valid0;
                    if (!valid7) {
                      const _errs33 = errors;
                      if (typeof data10 !== "boolean") {
                        const err32 = { instancePath: instancePath + "/data/" + i0 + "/metadata/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/definitions/File/properties/metadata/additionalProperties/anyOf/2/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                        if (vErrors === null) {
                          vErrors = [err32];
                        } else {
                          vErrors.push(err32);
                        }
                        errors++;
                      }
                      var _valid0 = _errs33 === errors;
                      valid7 = valid7 || _valid0;
                      if (!valid7) {
                        const _errs35 = errors;
                        if (data10 !== null) {
                          const err33 = { instancePath: instancePath + "/data/" + i0 + "/metadata/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/definitions/File/properties/metadata/additionalProperties/anyOf/3/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                          if (vErrors === null) {
                            vErrors = [err33];
                          } else {
                            vErrors.push(err33);
                          }
                          errors++;
                        }
                        var _valid0 = _errs35 === errors;
                        valid7 = valid7 || _valid0;
                      }
                    }
                  }
                  if (!valid7) {
                    const err34 = { instancePath: instancePath + "/data/" + i0 + "/metadata/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/definitions/File/properties/metadata/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err34];
                    } else {
                      vErrors.push(err34);
                    }
                    errors++;
                  } else {
                    errors = _errs28;
                    if (vErrors !== null) {
                      if (_errs28) {
                        vErrors.length = _errs28;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                }
              } else {
                const err35 = { instancePath: instancePath + "/data/" + i0 + "/metadata", schemaPath: "#/definitions/File/properties/metadata/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err35];
                } else {
                  vErrors.push(err35);
                }
                errors++;
              }
            }
            if (data2.createdAt !== void 0) {
              let data11 = data2.createdAt;
              if (typeof data11 === "string") {
                if (!pattern0.test(data11)) {
                  const err36 = { instancePath: instancePath + "/data/" + i0 + "/createdAt", schemaPath: "#/definitions/File/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err36];
                  } else {
                    vErrors.push(err36);
                  }
                  errors++;
                }
                if (!formats0.validate(data11)) {
                  const err37 = { instancePath: instancePath + "/data/" + i0 + "/createdAt", schemaPath: "#/definitions/File/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err37];
                  } else {
                    vErrors.push(err37);
                  }
                  errors++;
                }
              } else {
                const err38 = { instancePath: instancePath + "/data/" + i0 + "/createdAt", schemaPath: "#/definitions/File/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err38];
                } else {
                  vErrors.push(err38);
                }
                errors++;
              }
            }
            if (data2.updatedAt !== void 0) {
              let data12 = data2.updatedAt;
              if (typeof data12 === "string") {
                if (!pattern0.test(data12)) {
                  const err39 = { instancePath: instancePath + "/data/" + i0 + "/updatedAt", schemaPath: "#/definitions/File/properties/updatedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err39];
                  } else {
                    vErrors.push(err39);
                  }
                  errors++;
                }
                if (!formats0.validate(data12)) {
                  const err40 = { instancePath: instancePath + "/data/" + i0 + "/updatedAt", schemaPath: "#/definitions/File/properties/updatedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err40];
                  } else {
                    vErrors.push(err40);
                  }
                  errors++;
                }
              } else {
                const err41 = { instancePath: instancePath + "/data/" + i0 + "/updatedAt", schemaPath: "#/definitions/File/properties/updatedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err41];
                } else {
                  vErrors.push(err41);
                }
                errors++;
              }
            }
          } else {
            const err42 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err42];
            } else {
              vErrors.push(err42);
            }
            errors++;
          }
        }
      } else {
        const err43 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err43];
        } else {
          vErrors.push(err43);
        }
        errors++;
      }
    }
    if (data.has_more !== void 0) {
      if (typeof data.has_more !== "boolean") {
        const err44 = { instancePath: instancePath + "/has_more", schemaPath: "#/properties/has_more/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err44];
        } else {
          vErrors.push(err44);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      if (typeof data.url !== "string") {
        const err45 = { instancePath: instancePath + "/url", schemaPath: "#/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err45];
        } else {
          vErrors.push(err45);
        }
        errors++;
      }
    }
  } else {
    const err46 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err46];
    } else {
      vErrors.push(err46);
    }
    errors++;
  }
  validate25.errors = vErrors;
  return errors === 0;
}
var validateInput8 = validate26;
function validate26(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.path === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "path")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.path !== void 0) {
      let data0 = data.path;
      if (typeof data0 === "string") {
        if (func2(data0) > 1024) {
          const err2 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/maxLength", keyword: "maxLength", params: { limit: 1024 }, message: "must NOT have more than 1024 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (func2(data0) < 1) {
          const err3 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      } else {
        const err4 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate26.errors = vErrors;
  return errors === 0;
}
var validateOutput8 = validate27;
var schema31 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "object": { "type": "string", "const": "file" }, "path": { "type": "string" }, "mimeType": { "type": "string" }, "size": { "type": "integer", "minimum": 0, "maximum": 9007199254740991 }, "contentHash": { "type": "string", "description": "SHA-256 of the content." }, "revision": { "type": "integer", "exclusiveMinimum": 0, "maximum": 9007199254740991 }, "metadata": { "type": "object", "propertyNames": { "type": "string" }, "additionalProperties": { "anyOf": [{ "type": "string" }, { "type": "number" }, { "type": "boolean" }, { "type": "null" }] } }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "updatedAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "content": { "description": "The text, for a text or JSON file up to 64 KiB.", "type": "string" }, "url": { "description": "Otherwise a download URL, valid five minutes.", "type": "string", "format": "uri" } }, "required": ["object", "path", "mimeType", "size", "contentHash", "revision", "metadata", "createdAt", "updatedAt"], "additionalProperties": false };
var formats28 = require_formats().fullFormats.uri;
function validate27(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.path === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.mimeType === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "mimeType" }, message: "must have required property 'mimeType'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.size === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "size" }, message: "must have required property 'size'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.contentHash === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "contentHash" }, message: "must have required property 'contentHash'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.revision === void 0) {
      const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property 'revision'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.metadata === void 0) {
      const err6 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "metadata" }, message: "must have required property 'metadata'" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.createdAt === void 0) {
      const err7 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.updatedAt === void 0) {
      const err8 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "updatedAt" }, message: "must have required property 'updatedAt'" };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!func4.call(schema31.properties, key0)) {
        const err9 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err10 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if ("file" !== data0) {
        const err11 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "file" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.path !== void 0) {
      if (typeof data.path !== "string") {
        const err12 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.mimeType !== void 0) {
      if (typeof data.mimeType !== "string") {
        const err13 = { instancePath: instancePath + "/mimeType", schemaPath: "#/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.size !== void 0) {
      let data3 = data.size;
      if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)) && isFinite(data3))) {
        const err14 = { instancePath: instancePath + "/size", schemaPath: "#/properties/size/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
      if (typeof data3 == "number" && isFinite(data3)) {
        if (data3 > 9007199254740991 || isNaN(data3)) {
          const err15 = { instancePath: instancePath + "/size", schemaPath: "#/properties/size/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (data3 < 0 || isNaN(data3)) {
          const err16 = { instancePath: instancePath + "/size", schemaPath: "#/properties/size/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
      }
    }
    if (data.contentHash !== void 0) {
      if (typeof data.contentHash !== "string") {
        const err17 = { instancePath: instancePath + "/contentHash", schemaPath: "#/properties/contentHash/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.revision !== void 0) {
      let data5 = data.revision;
      if (!(typeof data5 == "number" && (!(data5 % 1) && !isNaN(data5)) && isFinite(data5))) {
        const err18 = { instancePath: instancePath + "/revision", schemaPath: "#/properties/revision/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
      if (typeof data5 == "number" && isFinite(data5)) {
        if (data5 > 9007199254740991 || isNaN(data5)) {
          const err19 = { instancePath: instancePath + "/revision", schemaPath: "#/properties/revision/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (data5 <= 0 || isNaN(data5)) {
          const err20 = { instancePath: instancePath + "/revision", schemaPath: "#/properties/revision/exclusiveMinimum", keyword: "exclusiveMinimum", params: { comparison: ">", limit: 0 }, message: "must be > 0" };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
      }
    }
    if (data.metadata !== void 0) {
      let data6 = data.metadata;
      if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
        for (const key1 in data6) {
          const _errs16 = errors;
          if (typeof key1 !== "string") {
            const err21 = { instancePath: instancePath + "/metadata", schemaPath: "#/properties/metadata/propertyNames/type", keyword: "type", params: { type: "string" }, message: "must be string", propertyName: key1 };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
          var valid1 = _errs16 === errors;
          if (!valid1) {
            const err22 = { instancePath: instancePath + "/metadata", schemaPath: "#/properties/metadata/propertyNames", keyword: "propertyNames", params: { propertyName: key1 }, message: "property name must be valid" };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
        }
        for (const key2 in data6) {
          let data7 = data6[key2];
          const _errs20 = errors;
          let valid3 = false;
          const _errs21 = errors;
          if (typeof data7 !== "string") {
            const err23 = { instancePath: instancePath + "/metadata/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/metadata/additionalProperties/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
          var _valid0 = _errs21 === errors;
          valid3 = valid3 || _valid0;
          if (!valid3) {
            const _errs23 = errors;
            if (!(typeof data7 == "number" && isFinite(data7))) {
              const err24 = { instancePath: instancePath + "/metadata/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/metadata/additionalProperties/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
              if (vErrors === null) {
                vErrors = [err24];
              } else {
                vErrors.push(err24);
              }
              errors++;
            }
            var _valid0 = _errs23 === errors;
            valid3 = valid3 || _valid0;
            if (!valid3) {
              const _errs25 = errors;
              if (typeof data7 !== "boolean") {
                const err25 = { instancePath: instancePath + "/metadata/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/metadata/additionalProperties/anyOf/2/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                if (vErrors === null) {
                  vErrors = [err25];
                } else {
                  vErrors.push(err25);
                }
                errors++;
              }
              var _valid0 = _errs25 === errors;
              valid3 = valid3 || _valid0;
              if (!valid3) {
                const _errs27 = errors;
                if (data7 !== null) {
                  const err26 = { instancePath: instancePath + "/metadata/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/metadata/additionalProperties/anyOf/3/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err26];
                  } else {
                    vErrors.push(err26);
                  }
                  errors++;
                }
                var _valid0 = _errs27 === errors;
                valid3 = valid3 || _valid0;
              }
            }
          }
          if (!valid3) {
            const err27 = { instancePath: instancePath + "/metadata/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/metadata/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          } else {
            errors = _errs20;
            if (vErrors !== null) {
              if (_errs20) {
                vErrors.length = _errs20;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err28 = { instancePath: instancePath + "/metadata", schemaPath: "#/properties/metadata/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
    }
    if (data.createdAt !== void 0) {
      let data8 = data.createdAt;
      if (typeof data8 === "string") {
        if (!pattern0.test(data8)) {
          const err29 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err29];
          } else {
            vErrors.push(err29);
          }
          errors++;
        }
        if (!formats0.validate(data8)) {
          const err30 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err30];
          } else {
            vErrors.push(err30);
          }
          errors++;
        }
      } else {
        const err31 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err31];
        } else {
          vErrors.push(err31);
        }
        errors++;
      }
    }
    if (data.updatedAt !== void 0) {
      let data9 = data.updatedAt;
      if (typeof data9 === "string") {
        if (!pattern0.test(data9)) {
          const err32 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err32];
          } else {
            vErrors.push(err32);
          }
          errors++;
        }
        if (!formats0.validate(data9)) {
          const err33 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err33];
          } else {
            vErrors.push(err33);
          }
          errors++;
        }
      } else {
        const err34 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err34];
        } else {
          vErrors.push(err34);
        }
        errors++;
      }
    }
    if (data.content !== void 0) {
      if (typeof data.content !== "string") {
        const err35 = { instancePath: instancePath + "/content", schemaPath: "#/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err35];
        } else {
          vErrors.push(err35);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      let data11 = data.url;
      if (typeof data11 === "string") {
        if (!formats28(data11)) {
          const err36 = { instancePath: instancePath + "/url", schemaPath: "#/properties/url/format", keyword: "format", params: { format: "uri" }, message: 'must match format "uri"' };
          if (vErrors === null) {
            vErrors = [err36];
          } else {
            vErrors.push(err36);
          }
          errors++;
        }
      } else {
        const err37 = { instancePath: instancePath + "/url", schemaPath: "#/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err37];
        } else {
          vErrors.push(err37);
        }
        errors++;
      }
    }
  } else {
    const err38 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err38];
    } else {
      vErrors.push(err38);
    }
    errors++;
  }
  validate27.errors = vErrors;
  return errors === 0;
}
var validateInput9 = validate28;
function validate28(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate28.errors = vErrors;
  return errors === 0;
}
var validateOutput9 = validate29;
var formats30 = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
var pattern14 = new RegExp("^(?!\\.)(?!.*\\.\\.)([A-Za-z0-9_'+\\-\\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}$", "u");
function validate29(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.object === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.email === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "email" }, message: "must have required property 'email'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.name === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property 'name'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.image === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "image" }, message: "must have required property 'image'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id" || key0 === "object" || key0 === "email" || key0 === "name" || key0 === "image")) {
        const err5 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err6 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data1 = data.object;
      if (typeof data1 !== "string") {
        const err7 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if ("user" !== data1) {
        const err8 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "user" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.email !== void 0) {
      let data2 = data.email;
      if (typeof data2 === "string") {
        if (!pattern14.test(data2)) {
          const err9 = { instancePath: instancePath + "/email", schemaPath: "#/properties/email/pattern", keyword: "pattern", params: { pattern: "^(?!\\.)(?!.*\\.\\.)([A-Za-z0-9_'+\\-\\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}$" }, message: `must match pattern "^(?!\\.)(?!.*\\.\\.)([A-Za-z0-9_'+\\-\\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}$"` };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
        if (!formats30.test(data2)) {
          const err10 = { instancePath: instancePath + "/email", schemaPath: "#/properties/email/format", keyword: "format", params: { format: "email" }, message: 'must match format "email"' };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
      } else {
        const err11 = { instancePath: instancePath + "/email", schemaPath: "#/properties/email/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err12 = { instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.image !== void 0) {
      let data4 = data.image;
      const _errs11 = errors;
      let valid1 = false;
      const _errs12 = errors;
      if (typeof data4 === "string") {
        if (!formats28(data4)) {
          const err13 = { instancePath: instancePath + "/image", schemaPath: "#/properties/image/anyOf/0/format", keyword: "format", params: { format: "uri" }, message: 'must match format "uri"' };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
      } else {
        const err14 = { instancePath: instancePath + "/image", schemaPath: "#/properties/image/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
      var _valid0 = _errs12 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs14 = errors;
        if (data4 !== null) {
          const err15 = { instancePath: instancePath + "/image", schemaPath: "#/properties/image/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        var _valid0 = _errs14 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err16 = { instancePath: instancePath + "/image", schemaPath: "#/properties/image/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      } else {
        errors = _errs11;
        if (vErrors !== null) {
          if (_errs11) {
            vErrors.length = _errs11;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err17 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err17];
    } else {
      vErrors.push(err17);
    }
    errors++;
  }
  validate29.errors = vErrors;
  return errors === 0;
}
var validateInput10 = validate30;
function validate30(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.prompt === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "prompt")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.prompt !== void 0) {
      let data0 = data.prompt;
      if (typeof data0 === "string") {
        if (func2(data0) > 1e4) {
          const err2 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (func2(data0) < 1) {
          const err3 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      } else {
        const err4 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate30.errors = vErrors;
  return errors === 0;
}
var validateOutput10 = validate31;
var schema35 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "agent_run" }, "userId": { "type": "string" }, "prompt": { "type": "string" }, "status": { "type": "string", "enum": ["queued", "running", "completed", "failed", "cancelled"] }, "output": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "error": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "completedAt": { "anyOf": [{ "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, { "type": "null" }] } }, "required": ["id", "object", "userId", "prompt", "status", "output", "error", "createdAt", "completedAt"], "additionalProperties": false };
function validate31(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.object === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.userId === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.prompt === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.status === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.output === void 0) {
      const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "output" }, message: "must have required property 'output'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.error === void 0) {
      const err6 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "error" }, message: "must have required property 'error'" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.createdAt === void 0) {
      const err7 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.completedAt === void 0) {
      const err8 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "completedAt" }, message: "must have required property 'completedAt'" };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!func4.call(schema35.properties, key0)) {
        const err9 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err10 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data1 = data.object;
      if (typeof data1 !== "string") {
        const err11 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if ("agent_run" !== data1) {
        const err12 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "agent_run" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err13 = { instancePath: instancePath + "/userId", schemaPath: "#/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.prompt !== void 0) {
      if (typeof data.prompt !== "string") {
        const err14 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.status !== void 0) {
      let data4 = data.status;
      if (typeof data4 !== "string") {
        const err15 = { instancePath: instancePath + "/status", schemaPath: "#/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
      if (!(data4 === "queued" || data4 === "running" || data4 === "completed" || data4 === "failed" || data4 === "cancelled")) {
        const err16 = { instancePath: instancePath + "/status", schemaPath: "#/properties/status/enum", keyword: "enum", params: { allowedValues: schema35.properties.status.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.output !== void 0) {
      let data5 = data.output;
      const _errs13 = errors;
      let valid1 = false;
      const _errs14 = errors;
      if (typeof data5 !== "string") {
        const err17 = { instancePath: instancePath + "/output", schemaPath: "#/properties/output/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
      var _valid0 = _errs14 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs16 = errors;
        if (data5 !== null) {
          const err18 = { instancePath: instancePath + "/output", schemaPath: "#/properties/output/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        var _valid0 = _errs16 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err19 = { instancePath: instancePath + "/output", schemaPath: "#/properties/output/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      } else {
        errors = _errs13;
        if (vErrors !== null) {
          if (_errs13) {
            vErrors.length = _errs13;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.error !== void 0) {
      let data6 = data.error;
      const _errs19 = errors;
      let valid2 = false;
      const _errs20 = errors;
      if (typeof data6 !== "string") {
        const err20 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
      var _valid1 = _errs20 === errors;
      valid2 = valid2 || _valid1;
      if (!valid2) {
        const _errs22 = errors;
        if (data6 !== null) {
          const err21 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        var _valid1 = _errs22 === errors;
        valid2 = valid2 || _valid1;
      }
      if (!valid2) {
        const err22 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err22];
        } else {
          vErrors.push(err22);
        }
        errors++;
      } else {
        errors = _errs19;
        if (vErrors !== null) {
          if (_errs19) {
            vErrors.length = _errs19;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.createdAt !== void 0) {
      let data7 = data.createdAt;
      if (typeof data7 === "string") {
        if (!pattern0.test(data7)) {
          const err23 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err23];
          } else {
            vErrors.push(err23);
          }
          errors++;
        }
        if (!formats0.validate(data7)) {
          const err24 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err24];
          } else {
            vErrors.push(err24);
          }
          errors++;
        }
      } else {
        const err25 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
    }
    if (data.completedAt !== void 0) {
      let data8 = data.completedAt;
      const _errs27 = errors;
      let valid3 = false;
      const _errs28 = errors;
      if (typeof data8 === "string") {
        if (!pattern0.test(data8)) {
          const err26 = { instancePath: instancePath + "/completedAt", schemaPath: "#/properties/completedAt/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err26];
          } else {
            vErrors.push(err26);
          }
          errors++;
        }
        if (!formats0.validate(data8)) {
          const err27 = { instancePath: instancePath + "/completedAt", schemaPath: "#/properties/completedAt/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err27];
          } else {
            vErrors.push(err27);
          }
          errors++;
        }
      } else {
        const err28 = { instancePath: instancePath + "/completedAt", schemaPath: "#/properties/completedAt/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
      var _valid2 = _errs28 === errors;
      valid3 = valid3 || _valid2;
      if (!valid3) {
        const _errs30 = errors;
        if (data8 !== null) {
          const err29 = { instancePath: instancePath + "/completedAt", schemaPath: "#/properties/completedAt/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err29];
          } else {
            vErrors.push(err29);
          }
          errors++;
        }
        var _valid2 = _errs30 === errors;
        valid3 = valid3 || _valid2;
      }
      if (!valid3) {
        const err30 = { instancePath: instancePath + "/completedAt", schemaPath: "#/properties/completedAt/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err30];
        } else {
          vErrors.push(err30);
        }
        errors++;
      } else {
        errors = _errs27;
        if (vErrors !== null) {
          if (_errs27) {
            vErrors.length = _errs27;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err31 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err31];
    } else {
      vErrors.push(err31);
    }
    errors++;
  }
  validate31.errors = vErrors;
  return errors === 0;
}
var validateInput11 = validate32;
function validate32(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.prompt === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "prompt")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.prompt !== void 0) {
      let data0 = data.prompt;
      if (typeof data0 === "string") {
        if (func2(data0) > 2e4) {
          const err2 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/maxLength", keyword: "maxLength", params: { limit: 2e4 }, message: "must NOT have more than 20000 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (func2(data0) < 1) {
          const err3 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      } else {
        const err4 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate32.errors = vErrors;
  return errors === 0;
}
var validateOutput11 = validate33;
var schema37 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "conversation" }, "userId": { "type": "string" }, "title": { "type": "string" }, "configuration": { "type": "string" }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "updatedAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "run": { "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "agent_run" }, "userId": { "type": "string" }, "prompt": { "type": "string" }, "status": { "type": "string", "enum": ["queued", "running", "completed", "failed", "cancelled"] }, "output": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "error": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "completedAt": { "anyOf": [{ "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, { "type": "null" }] } }, "required": ["id", "object", "userId", "prompt", "status", "output", "error", "createdAt", "completedAt"], "additionalProperties": false } }, "required": ["id", "object", "userId", "title", "configuration", "createdAt", "updatedAt", "run"], "additionalProperties": false };
function validate33(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.object === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.userId === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.title === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.configuration === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "configuration" }, message: "must have required property 'configuration'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.createdAt === void 0) {
      const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.updatedAt === void 0) {
      const err6 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "updatedAt" }, message: "must have required property 'updatedAt'" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.run === void 0) {
      const err7 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "run" }, message: "must have required property 'run'" };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id" || key0 === "object" || key0 === "userId" || key0 === "title" || key0 === "configuration" || key0 === "createdAt" || key0 === "updatedAt" || key0 === "run")) {
        const err8 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err9 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data1 = data.object;
      if (typeof data1 !== "string") {
        const err10 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if ("conversation" !== data1) {
        const err11 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "conversation" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err12 = { instancePath: instancePath + "/userId", schemaPath: "#/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.title !== void 0) {
      if (typeof data.title !== "string") {
        const err13 = { instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.configuration !== void 0) {
      if (typeof data.configuration !== "string") {
        const err14 = { instancePath: instancePath + "/configuration", schemaPath: "#/properties/configuration/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.createdAt !== void 0) {
      let data5 = data.createdAt;
      if (typeof data5 === "string") {
        if (!pattern0.test(data5)) {
          const err15 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (!formats0.validate(data5)) {
          const err16 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
      } else {
        const err17 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.updatedAt !== void 0) {
      let data6 = data.updatedAt;
      if (typeof data6 === "string") {
        if (!pattern0.test(data6)) {
          const err18 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        if (!formats0.validate(data6)) {
          const err19 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
      } else {
        const err20 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
    if (data.run !== void 0) {
      let data7 = data.run;
      if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
        if (data7.id === void 0) {
          const err21 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        if (data7.object === void 0) {
          const err22 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
        if (data7.userId === void 0) {
          const err23 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
          if (vErrors === null) {
            vErrors = [err23];
          } else {
            vErrors.push(err23);
          }
          errors++;
        }
        if (data7.prompt === void 0) {
          const err24 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
          if (vErrors === null) {
            vErrors = [err24];
          } else {
            vErrors.push(err24);
          }
          errors++;
        }
        if (data7.status === void 0) {
          const err25 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
          if (vErrors === null) {
            vErrors = [err25];
          } else {
            vErrors.push(err25);
          }
          errors++;
        }
        if (data7.output === void 0) {
          const err26 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "output" }, message: "must have required property 'output'" };
          if (vErrors === null) {
            vErrors = [err26];
          } else {
            vErrors.push(err26);
          }
          errors++;
        }
        if (data7.error === void 0) {
          const err27 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "error" }, message: "must have required property 'error'" };
          if (vErrors === null) {
            vErrors = [err27];
          } else {
            vErrors.push(err27);
          }
          errors++;
        }
        if (data7.createdAt === void 0) {
          const err28 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
          if (vErrors === null) {
            vErrors = [err28];
          } else {
            vErrors.push(err28);
          }
          errors++;
        }
        if (data7.completedAt === void 0) {
          const err29 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "completedAt" }, message: "must have required property 'completedAt'" };
          if (vErrors === null) {
            vErrors = [err29];
          } else {
            vErrors.push(err29);
          }
          errors++;
        }
        for (const key1 in data7) {
          if (!func4.call(schema37.properties.run.properties, key1)) {
            const err30 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err30];
            } else {
              vErrors.push(err30);
            }
            errors++;
          }
        }
        if (data7.id !== void 0) {
          if (typeof data7.id !== "string") {
            const err31 = { instancePath: instancePath + "/run/id", schemaPath: "#/properties/run/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
        }
        if (data7.object !== void 0) {
          let data9 = data7.object;
          if (typeof data9 !== "string") {
            const err32 = { instancePath: instancePath + "/run/object", schemaPath: "#/properties/run/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err32];
            } else {
              vErrors.push(err32);
            }
            errors++;
          }
          if ("agent_run" !== data9) {
            const err33 = { instancePath: instancePath + "/run/object", schemaPath: "#/properties/run/properties/object/const", keyword: "const", params: { allowedValue: "agent_run" }, message: "must be equal to constant" };
            if (vErrors === null) {
              vErrors = [err33];
            } else {
              vErrors.push(err33);
            }
            errors++;
          }
        }
        if (data7.userId !== void 0) {
          if (typeof data7.userId !== "string") {
            const err34 = { instancePath: instancePath + "/run/userId", schemaPath: "#/properties/run/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err34];
            } else {
              vErrors.push(err34);
            }
            errors++;
          }
        }
        if (data7.prompt !== void 0) {
          if (typeof data7.prompt !== "string") {
            const err35 = { instancePath: instancePath + "/run/prompt", schemaPath: "#/properties/run/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err35];
            } else {
              vErrors.push(err35);
            }
            errors++;
          }
        }
        if (data7.status !== void 0) {
          let data12 = data7.status;
          if (typeof data12 !== "string") {
            const err36 = { instancePath: instancePath + "/run/status", schemaPath: "#/properties/run/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err36];
            } else {
              vErrors.push(err36);
            }
            errors++;
          }
          if (!(data12 === "queued" || data12 === "running" || data12 === "completed" || data12 === "failed" || data12 === "cancelled")) {
            const err37 = { instancePath: instancePath + "/run/status", schemaPath: "#/properties/run/properties/status/enum", keyword: "enum", params: { allowedValues: schema37.properties.run.properties.status.enum }, message: "must be equal to one of the allowed values" };
            if (vErrors === null) {
              vErrors = [err37];
            } else {
              vErrors.push(err37);
            }
            errors++;
          }
        }
        if (data7.output !== void 0) {
          let data13 = data7.output;
          const _errs30 = errors;
          let valid2 = false;
          const _errs31 = errors;
          if (typeof data13 !== "string") {
            const err38 = { instancePath: instancePath + "/run/output", schemaPath: "#/properties/run/properties/output/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err38];
            } else {
              vErrors.push(err38);
            }
            errors++;
          }
          var _valid0 = _errs31 === errors;
          valid2 = valid2 || _valid0;
          if (!valid2) {
            const _errs33 = errors;
            if (data13 !== null) {
              const err39 = { instancePath: instancePath + "/run/output", schemaPath: "#/properties/run/properties/output/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err39];
              } else {
                vErrors.push(err39);
              }
              errors++;
            }
            var _valid0 = _errs33 === errors;
            valid2 = valid2 || _valid0;
          }
          if (!valid2) {
            const err40 = { instancePath: instancePath + "/run/output", schemaPath: "#/properties/run/properties/output/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err40];
            } else {
              vErrors.push(err40);
            }
            errors++;
          } else {
            errors = _errs30;
            if (vErrors !== null) {
              if (_errs30) {
                vErrors.length = _errs30;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data7.error !== void 0) {
          let data14 = data7.error;
          const _errs36 = errors;
          let valid3 = false;
          const _errs37 = errors;
          if (typeof data14 !== "string") {
            const err41 = { instancePath: instancePath + "/run/error", schemaPath: "#/properties/run/properties/error/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err41];
            } else {
              vErrors.push(err41);
            }
            errors++;
          }
          var _valid1 = _errs37 === errors;
          valid3 = valid3 || _valid1;
          if (!valid3) {
            const _errs39 = errors;
            if (data14 !== null) {
              const err42 = { instancePath: instancePath + "/run/error", schemaPath: "#/properties/run/properties/error/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err42];
              } else {
                vErrors.push(err42);
              }
              errors++;
            }
            var _valid1 = _errs39 === errors;
            valid3 = valid3 || _valid1;
          }
          if (!valid3) {
            const err43 = { instancePath: instancePath + "/run/error", schemaPath: "#/properties/run/properties/error/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err43];
            } else {
              vErrors.push(err43);
            }
            errors++;
          } else {
            errors = _errs36;
            if (vErrors !== null) {
              if (_errs36) {
                vErrors.length = _errs36;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data7.createdAt !== void 0) {
          let data15 = data7.createdAt;
          if (typeof data15 === "string") {
            if (!pattern0.test(data15)) {
              const err44 = { instancePath: instancePath + "/run/createdAt", schemaPath: "#/properties/run/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
              if (vErrors === null) {
                vErrors = [err44];
              } else {
                vErrors.push(err44);
              }
              errors++;
            }
            if (!formats0.validate(data15)) {
              const err45 = { instancePath: instancePath + "/run/createdAt", schemaPath: "#/properties/run/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
              if (vErrors === null) {
                vErrors = [err45];
              } else {
                vErrors.push(err45);
              }
              errors++;
            }
          } else {
            const err46 = { instancePath: instancePath + "/run/createdAt", schemaPath: "#/properties/run/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err46];
            } else {
              vErrors.push(err46);
            }
            errors++;
          }
        }
        if (data7.completedAt !== void 0) {
          let data16 = data7.completedAt;
          const _errs44 = errors;
          let valid4 = false;
          const _errs45 = errors;
          if (typeof data16 === "string") {
            if (!pattern0.test(data16)) {
              const err47 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
              if (vErrors === null) {
                vErrors = [err47];
              } else {
                vErrors.push(err47);
              }
              errors++;
            }
            if (!formats0.validate(data16)) {
              const err48 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
              if (vErrors === null) {
                vErrors = [err48];
              } else {
                vErrors.push(err48);
              }
              errors++;
            }
          } else {
            const err49 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err49];
            } else {
              vErrors.push(err49);
            }
            errors++;
          }
          var _valid2 = _errs45 === errors;
          valid4 = valid4 || _valid2;
          if (!valid4) {
            const _errs47 = errors;
            if (data16 !== null) {
              const err50 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err50];
              } else {
                vErrors.push(err50);
              }
              errors++;
            }
            var _valid2 = _errs47 === errors;
            valid4 = valid4 || _valid2;
          }
          if (!valid4) {
            const err51 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err51];
            } else {
              vErrors.push(err51);
            }
            errors++;
          } else {
            errors = _errs44;
            if (vErrors !== null) {
              if (_errs44) {
                vErrors.length = _errs44;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err52 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err52];
        } else {
          vErrors.push(err52);
        }
        errors++;
      }
    }
  } else {
    const err53 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err53];
    } else {
      vErrors.push(err53);
    }
    errors++;
  }
  validate33.errors = vErrors;
  return errors === 0;
}
var validateInput12 = validate34;
function validate34(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.prompt === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id" || key0 === "prompt")) {
        const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      let data0 = data.id;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err3 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      } else {
        const err4 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.prompt !== void 0) {
      let data1 = data.prompt;
      if (typeof data1 === "string") {
        if (func2(data1) > 2e4) {
          const err5 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/maxLength", keyword: "maxLength", params: { limit: 2e4 }, message: "must NOT have more than 20000 characters" };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
        if (func2(data1) < 1) {
          const err6 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      } else {
        const err7 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
  } else {
    const err8 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
  }
  validate34.errors = vErrors;
  return errors === 0;
}
var validateOutput12 = validate35;
var schema39 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "object": { "type": "string", "const": "message" }, "conversationId": { "type": "string" }, "role": { "type": "string", "const": "user" }, "content": { "type": "string" }, "run": { "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "agent_run" }, "userId": { "type": "string" }, "prompt": { "type": "string" }, "status": { "type": "string", "enum": ["queued", "running", "completed", "failed", "cancelled"] }, "output": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "error": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "completedAt": { "anyOf": [{ "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, { "type": "null" }] } }, "required": ["id", "object", "userId", "prompt", "status", "output", "error", "createdAt", "completedAt"], "additionalProperties": false } }, "required": ["object", "conversationId", "role", "content", "run"], "additionalProperties": false };
function validate35(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.conversationId === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.role === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "role" }, message: "must have required property 'role'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.content === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "content" }, message: "must have required property 'content'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.run === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "run" }, message: "must have required property 'run'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "conversationId" || key0 === "role" || key0 === "content" || key0 === "run")) {
        const err5 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err6 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if ("message" !== data0) {
        const err7 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "message" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.conversationId !== void 0) {
      if (typeof data.conversationId !== "string") {
        const err8 = { instancePath: instancePath + "/conversationId", schemaPath: "#/properties/conversationId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.role !== void 0) {
      let data2 = data.role;
      if (typeof data2 !== "string") {
        const err9 = { instancePath: instancePath + "/role", schemaPath: "#/properties/role/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if ("user" !== data2) {
        const err10 = { instancePath: instancePath + "/role", schemaPath: "#/properties/role/const", keyword: "const", params: { allowedValue: "user" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.content !== void 0) {
      if (typeof data.content !== "string") {
        const err11 = { instancePath: instancePath + "/content", schemaPath: "#/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.run !== void 0) {
      let data4 = data.run;
      if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
        if (data4.id === void 0) {
          const err12 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        }
        if (data4.object === void 0) {
          const err13 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        if (data4.userId === void 0) {
          const err14 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        if (data4.prompt === void 0) {
          const err15 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (data4.status === void 0) {
          const err16 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
        if (data4.output === void 0) {
          const err17 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "output" }, message: "must have required property 'output'" };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
        if (data4.error === void 0) {
          const err18 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "error" }, message: "must have required property 'error'" };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        if (data4.createdAt === void 0) {
          const err19 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (data4.completedAt === void 0) {
          const err20 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "completedAt" }, message: "must have required property 'completedAt'" };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
        for (const key1 in data4) {
          if (!func4.call(schema39.properties.run.properties, key1)) {
            const err21 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
        }
        if (data4.id !== void 0) {
          if (typeof data4.id !== "string") {
            const err22 = { instancePath: instancePath + "/run/id", schemaPath: "#/properties/run/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
        }
        if (data4.object !== void 0) {
          let data6 = data4.object;
          if (typeof data6 !== "string") {
            const err23 = { instancePath: instancePath + "/run/object", schemaPath: "#/properties/run/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
          if ("agent_run" !== data6) {
            const err24 = { instancePath: instancePath + "/run/object", schemaPath: "#/properties/run/properties/object/const", keyword: "const", params: { allowedValue: "agent_run" }, message: "must be equal to constant" };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
        }
        if (data4.userId !== void 0) {
          if (typeof data4.userId !== "string") {
            const err25 = { instancePath: instancePath + "/run/userId", schemaPath: "#/properties/run/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err25];
            } else {
              vErrors.push(err25);
            }
            errors++;
          }
        }
        if (data4.prompt !== void 0) {
          if (typeof data4.prompt !== "string") {
            const err26 = { instancePath: instancePath + "/run/prompt", schemaPath: "#/properties/run/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err26];
            } else {
              vErrors.push(err26);
            }
            errors++;
          }
        }
        if (data4.status !== void 0) {
          let data9 = data4.status;
          if (typeof data9 !== "string") {
            const err27 = { instancePath: instancePath + "/run/status", schemaPath: "#/properties/run/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          }
          if (!(data9 === "queued" || data9 === "running" || data9 === "completed" || data9 === "failed" || data9 === "cancelled")) {
            const err28 = { instancePath: instancePath + "/run/status", schemaPath: "#/properties/run/properties/status/enum", keyword: "enum", params: { allowedValues: schema39.properties.run.properties.status.enum }, message: "must be equal to one of the allowed values" };
            if (vErrors === null) {
              vErrors = [err28];
            } else {
              vErrors.push(err28);
            }
            errors++;
          }
        }
        if (data4.output !== void 0) {
          let data10 = data4.output;
          const _errs24 = errors;
          let valid2 = false;
          const _errs25 = errors;
          if (typeof data10 !== "string") {
            const err29 = { instancePath: instancePath + "/run/output", schemaPath: "#/properties/run/properties/output/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err29];
            } else {
              vErrors.push(err29);
            }
            errors++;
          }
          var _valid0 = _errs25 === errors;
          valid2 = valid2 || _valid0;
          if (!valid2) {
            const _errs27 = errors;
            if (data10 !== null) {
              const err30 = { instancePath: instancePath + "/run/output", schemaPath: "#/properties/run/properties/output/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err30];
              } else {
                vErrors.push(err30);
              }
              errors++;
            }
            var _valid0 = _errs27 === errors;
            valid2 = valid2 || _valid0;
          }
          if (!valid2) {
            const err31 = { instancePath: instancePath + "/run/output", schemaPath: "#/properties/run/properties/output/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          } else {
            errors = _errs24;
            if (vErrors !== null) {
              if (_errs24) {
                vErrors.length = _errs24;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data4.error !== void 0) {
          let data11 = data4.error;
          const _errs30 = errors;
          let valid3 = false;
          const _errs31 = errors;
          if (typeof data11 !== "string") {
            const err32 = { instancePath: instancePath + "/run/error", schemaPath: "#/properties/run/properties/error/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err32];
            } else {
              vErrors.push(err32);
            }
            errors++;
          }
          var _valid1 = _errs31 === errors;
          valid3 = valid3 || _valid1;
          if (!valid3) {
            const _errs33 = errors;
            if (data11 !== null) {
              const err33 = { instancePath: instancePath + "/run/error", schemaPath: "#/properties/run/properties/error/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err33];
              } else {
                vErrors.push(err33);
              }
              errors++;
            }
            var _valid1 = _errs33 === errors;
            valid3 = valid3 || _valid1;
          }
          if (!valid3) {
            const err34 = { instancePath: instancePath + "/run/error", schemaPath: "#/properties/run/properties/error/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err34];
            } else {
              vErrors.push(err34);
            }
            errors++;
          } else {
            errors = _errs30;
            if (vErrors !== null) {
              if (_errs30) {
                vErrors.length = _errs30;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data4.createdAt !== void 0) {
          let data12 = data4.createdAt;
          if (typeof data12 === "string") {
            if (!pattern0.test(data12)) {
              const err35 = { instancePath: instancePath + "/run/createdAt", schemaPath: "#/properties/run/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
              if (vErrors === null) {
                vErrors = [err35];
              } else {
                vErrors.push(err35);
              }
              errors++;
            }
            if (!formats0.validate(data12)) {
              const err36 = { instancePath: instancePath + "/run/createdAt", schemaPath: "#/properties/run/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
              if (vErrors === null) {
                vErrors = [err36];
              } else {
                vErrors.push(err36);
              }
              errors++;
            }
          } else {
            const err37 = { instancePath: instancePath + "/run/createdAt", schemaPath: "#/properties/run/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err37];
            } else {
              vErrors.push(err37);
            }
            errors++;
          }
        }
        if (data4.completedAt !== void 0) {
          let data13 = data4.completedAt;
          const _errs38 = errors;
          let valid4 = false;
          const _errs39 = errors;
          if (typeof data13 === "string") {
            if (!pattern0.test(data13)) {
              const err38 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
              if (vErrors === null) {
                vErrors = [err38];
              } else {
                vErrors.push(err38);
              }
              errors++;
            }
            if (!formats0.validate(data13)) {
              const err39 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
              if (vErrors === null) {
                vErrors = [err39];
              } else {
                vErrors.push(err39);
              }
              errors++;
            }
          } else {
            const err40 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err40];
            } else {
              vErrors.push(err40);
            }
            errors++;
          }
          var _valid2 = _errs39 === errors;
          valid4 = valid4 || _valid2;
          if (!valid4) {
            const _errs41 = errors;
            if (data13 !== null) {
              const err41 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err41];
              } else {
                vErrors.push(err41);
              }
              errors++;
            }
            var _valid2 = _errs41 === errors;
            valid4 = valid4 || _valid2;
          }
          if (!valid4) {
            const err42 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err42];
            } else {
              vErrors.push(err42);
            }
            errors++;
          } else {
            errors = _errs38;
            if (vErrors !== null) {
              if (_errs38) {
                vErrors.length = _errs38;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err43 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err43];
        } else {
          vErrors.push(err43);
        }
        errors++;
      }
    }
  } else {
    const err44 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err44];
    } else {
      vErrors.push(err44);
    }
    errors++;
  }
  validate35.errors = vErrors;
  return errors === 0;
}
var validateInput13 = validate36;
var schema41 = { "type": "object", "properties": { "id": { "type": "string", "minLength": 1 }, "kind": { "type": "string", "const": "treatment-plan" }, "draft": { "type": "boolean" }, "title": { "type": "string" }, "planDate": { "type": "string" }, "status": { "type": "string", "enum": ["draft", "reviewed", "final"] }, "patientName": { "type": "string" }, "patientBirthDate": { "type": "string" }, "planNumber": { "type": "string" }, "patientAddress": { "type": "string" }, "consumablesEstimate": { "type": "number", "minimum": 0 }, "labCostsEstimate": { "type": "number", "minimum": 0 }, "rows": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string", "minLength": 1 }, "gozNumber": { "type": "string", "description": "The four-digit GOZ number." }, "description": { "type": "string" }, "toothOrRegion": { "type": "string", "description": "The teeth the row covers, comma-separated (14,13,12), or a region such as OK." }, "quantity": { "type": "number", "exclusiveMinimum": 0, "description": "Billable units, as a number: one per tooth, jaw or session billed." }, "factor": { "type": "number", "description": "The GOZ factor; 2.3 is the threshold, and above it needs a justification." }, "amount": { "description": "Leave out: the API prices the row from the GOZ at `factor` and `quantity`. Required for an analog position.", "type": "number", "minimum": 0 }, "justification": { "type": "string" }, "analogReference": { "type": "string" }, "materials": { "type": "string" }, "notes": { "type": "string" } }, "required": ["id", "gozNumber", "description", "toothOrRegion", "quantity", "factor"], "additionalProperties": false } } }, "required": ["id", "kind", "title", "planDate", "status", "rows"], "additionalProperties": false };
function validate36(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.plan === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "plan" }, message: "must have required property 'plan'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "plan")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.plan !== void 0) {
      let data0 = data.plan;
      if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
        if (data0.id === void 0) {
          const err2 = { instancePath: instancePath + "/plan", schemaPath: "#/definitions/TreatmentPlan/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (data0.kind === void 0) {
          const err3 = { instancePath: instancePath + "/plan", schemaPath: "#/definitions/TreatmentPlan/required", keyword: "required", params: { missingProperty: "kind" }, message: "must have required property 'kind'" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
        if (data0.title === void 0) {
          const err4 = { instancePath: instancePath + "/plan", schemaPath: "#/definitions/TreatmentPlan/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
        if (data0.planDate === void 0) {
          const err5 = { instancePath: instancePath + "/plan", schemaPath: "#/definitions/TreatmentPlan/required", keyword: "required", params: { missingProperty: "planDate" }, message: "must have required property 'planDate'" };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
        if (data0.status === void 0) {
          const err6 = { instancePath: instancePath + "/plan", schemaPath: "#/definitions/TreatmentPlan/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
        if (data0.rows === void 0) {
          const err7 = { instancePath: instancePath + "/plan", schemaPath: "#/definitions/TreatmentPlan/required", keyword: "required", params: { missingProperty: "rows" }, message: "must have required property 'rows'" };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
        for (const key1 in data0) {
          if (!func4.call(schema41.properties, key1)) {
            const err8 = { instancePath: instancePath + "/plan", schemaPath: "#/definitions/TreatmentPlan/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err8];
            } else {
              vErrors.push(err8);
            }
            errors++;
          }
        }
        if (data0.id !== void 0) {
          let data1 = data0.id;
          if (typeof data1 === "string") {
            if (func2(data1) < 1) {
              const err9 = { instancePath: instancePath + "/plan/id", schemaPath: "#/definitions/TreatmentPlan/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
          } else {
            const err10 = { instancePath: instancePath + "/plan/id", schemaPath: "#/definitions/TreatmentPlan/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          }
        }
        if (data0.kind !== void 0) {
          let data2 = data0.kind;
          if (typeof data2 !== "string") {
            const err11 = { instancePath: instancePath + "/plan/kind", schemaPath: "#/definitions/TreatmentPlan/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
          }
          if ("treatment-plan" !== data2) {
            const err12 = { instancePath: instancePath + "/plan/kind", schemaPath: "#/definitions/TreatmentPlan/properties/kind/const", keyword: "const", params: { allowedValue: "treatment-plan" }, message: "must be equal to constant" };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
        if (data0.draft !== void 0) {
          if (typeof data0.draft !== "boolean") {
            const err13 = { instancePath: instancePath + "/plan/draft", schemaPath: "#/definitions/TreatmentPlan/properties/draft/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
        }
        if (data0.title !== void 0) {
          if (typeof data0.title !== "string") {
            const err14 = { instancePath: instancePath + "/plan/title", schemaPath: "#/definitions/TreatmentPlan/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          }
        }
        if (data0.planDate !== void 0) {
          if (typeof data0.planDate !== "string") {
            const err15 = { instancePath: instancePath + "/plan/planDate", schemaPath: "#/definitions/TreatmentPlan/properties/planDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data0.status !== void 0) {
          let data6 = data0.status;
          if (typeof data6 !== "string") {
            const err16 = { instancePath: instancePath + "/plan/status", schemaPath: "#/definitions/TreatmentPlan/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
          if (!(data6 === "draft" || data6 === "reviewed" || data6 === "final")) {
            const err17 = { instancePath: instancePath + "/plan/status", schemaPath: "#/definitions/TreatmentPlan/properties/status/enum", keyword: "enum", params: { allowedValues: schema41.properties.status.enum }, message: "must be equal to one of the allowed values" };
            if (vErrors === null) {
              vErrors = [err17];
            } else {
              vErrors.push(err17);
            }
            errors++;
          }
        }
        if (data0.patientName !== void 0) {
          if (typeof data0.patientName !== "string") {
            const err18 = { instancePath: instancePath + "/plan/patientName", schemaPath: "#/definitions/TreatmentPlan/properties/patientName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err18];
            } else {
              vErrors.push(err18);
            }
            errors++;
          }
        }
        if (data0.patientBirthDate !== void 0) {
          if (typeof data0.patientBirthDate !== "string") {
            const err19 = { instancePath: instancePath + "/plan/patientBirthDate", schemaPath: "#/definitions/TreatmentPlan/properties/patientBirthDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err19];
            } else {
              vErrors.push(err19);
            }
            errors++;
          }
        }
        if (data0.planNumber !== void 0) {
          if (typeof data0.planNumber !== "string") {
            const err20 = { instancePath: instancePath + "/plan/planNumber", schemaPath: "#/definitions/TreatmentPlan/properties/planNumber/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          }
        }
        if (data0.patientAddress !== void 0) {
          if (typeof data0.patientAddress !== "string") {
            const err21 = { instancePath: instancePath + "/plan/patientAddress", schemaPath: "#/definitions/TreatmentPlan/properties/patientAddress/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
        }
        if (data0.consumablesEstimate !== void 0) {
          let data11 = data0.consumablesEstimate;
          if (typeof data11 == "number" && isFinite(data11)) {
            if (data11 < 0 || isNaN(data11)) {
              const err22 = { instancePath: instancePath + "/plan/consumablesEstimate", schemaPath: "#/definitions/TreatmentPlan/properties/consumablesEstimate/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
              if (vErrors === null) {
                vErrors = [err22];
              } else {
                vErrors.push(err22);
              }
              errors++;
            }
          } else {
            const err23 = { instancePath: instancePath + "/plan/consumablesEstimate", schemaPath: "#/definitions/TreatmentPlan/properties/consumablesEstimate/type", keyword: "type", params: { type: "number" }, message: "must be number" };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
        }
        if (data0.labCostsEstimate !== void 0) {
          let data12 = data0.labCostsEstimate;
          if (typeof data12 == "number" && isFinite(data12)) {
            if (data12 < 0 || isNaN(data12)) {
              const err24 = { instancePath: instancePath + "/plan/labCostsEstimate", schemaPath: "#/definitions/TreatmentPlan/properties/labCostsEstimate/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
              if (vErrors === null) {
                vErrors = [err24];
              } else {
                vErrors.push(err24);
              }
              errors++;
            }
          } else {
            const err25 = { instancePath: instancePath + "/plan/labCostsEstimate", schemaPath: "#/definitions/TreatmentPlan/properties/labCostsEstimate/type", keyword: "type", params: { type: "number" }, message: "must be number" };
            if (vErrors === null) {
              vErrors = [err25];
            } else {
              vErrors.push(err25);
            }
            errors++;
          }
        }
        if (data0.rows !== void 0) {
          let data13 = data0.rows;
          if (Array.isArray(data13)) {
            const len0 = data13.length;
            for (let i0 = 0; i0 < len0; i0++) {
              let data14 = data13[i0];
              if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
                if (data14.id === void 0) {
                  const err26 = { instancePath: instancePath + "/plan/rows/" + i0, schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                  if (vErrors === null) {
                    vErrors = [err26];
                  } else {
                    vErrors.push(err26);
                  }
                  errors++;
                }
                if (data14.gozNumber === void 0) {
                  const err27 = { instancePath: instancePath + "/plan/rows/" + i0, schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/required", keyword: "required", params: { missingProperty: "gozNumber" }, message: "must have required property 'gozNumber'" };
                  if (vErrors === null) {
                    vErrors = [err27];
                  } else {
                    vErrors.push(err27);
                  }
                  errors++;
                }
                if (data14.description === void 0) {
                  const err28 = { instancePath: instancePath + "/plan/rows/" + i0, schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property 'description'" };
                  if (vErrors === null) {
                    vErrors = [err28];
                  } else {
                    vErrors.push(err28);
                  }
                  errors++;
                }
                if (data14.toothOrRegion === void 0) {
                  const err29 = { instancePath: instancePath + "/plan/rows/" + i0, schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/required", keyword: "required", params: { missingProperty: "toothOrRegion" }, message: "must have required property 'toothOrRegion'" };
                  if (vErrors === null) {
                    vErrors = [err29];
                  } else {
                    vErrors.push(err29);
                  }
                  errors++;
                }
                if (data14.quantity === void 0) {
                  const err30 = { instancePath: instancePath + "/plan/rows/" + i0, schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                  if (vErrors === null) {
                    vErrors = [err30];
                  } else {
                    vErrors.push(err30);
                  }
                  errors++;
                }
                if (data14.factor === void 0) {
                  const err31 = { instancePath: instancePath + "/plan/rows/" + i0, schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/required", keyword: "required", params: { missingProperty: "factor" }, message: "must have required property 'factor'" };
                  if (vErrors === null) {
                    vErrors = [err31];
                  } else {
                    vErrors.push(err31);
                  }
                  errors++;
                }
                for (const key2 in data14) {
                  if (!func4.call(schema41.properties.rows.items.properties, key2)) {
                    const err32 = { instancePath: instancePath + "/plan/rows/" + i0, schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err32];
                    } else {
                      vErrors.push(err32);
                    }
                    errors++;
                  }
                }
                if (data14.id !== void 0) {
                  let data15 = data14.id;
                  if (typeof data15 === "string") {
                    if (func2(data15) < 1) {
                      const err33 = { instancePath: instancePath + "/plan/rows/" + i0 + "/id", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                      if (vErrors === null) {
                        vErrors = [err33];
                      } else {
                        vErrors.push(err33);
                      }
                      errors++;
                    }
                  } else {
                    const err34 = { instancePath: instancePath + "/plan/rows/" + i0 + "/id", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err34];
                    } else {
                      vErrors.push(err34);
                    }
                    errors++;
                  }
                }
                if (data14.gozNumber !== void 0) {
                  if (typeof data14.gozNumber !== "string") {
                    const err35 = { instancePath: instancePath + "/plan/rows/" + i0 + "/gozNumber", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/gozNumber/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err35];
                    } else {
                      vErrors.push(err35);
                    }
                    errors++;
                  }
                }
                if (data14.description !== void 0) {
                  if (typeof data14.description !== "string") {
                    const err36 = { instancePath: instancePath + "/plan/rows/" + i0 + "/description", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err36];
                    } else {
                      vErrors.push(err36);
                    }
                    errors++;
                  }
                }
                if (data14.toothOrRegion !== void 0) {
                  if (typeof data14.toothOrRegion !== "string") {
                    const err37 = { instancePath: instancePath + "/plan/rows/" + i0 + "/toothOrRegion", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/toothOrRegion/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err37];
                    } else {
                      vErrors.push(err37);
                    }
                    errors++;
                  }
                }
                if (data14.quantity !== void 0) {
                  let data19 = data14.quantity;
                  if (typeof data19 == "number" && isFinite(data19)) {
                    if (data19 <= 0 || isNaN(data19)) {
                      const err38 = { instancePath: instancePath + "/plan/rows/" + i0 + "/quantity", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/quantity/exclusiveMinimum", keyword: "exclusiveMinimum", params: { comparison: ">", limit: 0 }, message: "must be > 0" };
                      if (vErrors === null) {
                        vErrors = [err38];
                      } else {
                        vErrors.push(err38);
                      }
                      errors++;
                    }
                  } else {
                    const err39 = { instancePath: instancePath + "/plan/rows/" + i0 + "/quantity", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/quantity/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                    if (vErrors === null) {
                      vErrors = [err39];
                    } else {
                      vErrors.push(err39);
                    }
                    errors++;
                  }
                }
                if (data14.factor !== void 0) {
                  let data20 = data14.factor;
                  if (!(typeof data20 == "number" && isFinite(data20))) {
                    const err40 = { instancePath: instancePath + "/plan/rows/" + i0 + "/factor", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/factor/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                    if (vErrors === null) {
                      vErrors = [err40];
                    } else {
                      vErrors.push(err40);
                    }
                    errors++;
                  }
                }
                if (data14.amount !== void 0) {
                  let data21 = data14.amount;
                  if (typeof data21 == "number" && isFinite(data21)) {
                    if (data21 < 0 || isNaN(data21)) {
                      const err41 = { instancePath: instancePath + "/plan/rows/" + i0 + "/amount", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/amount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                      if (vErrors === null) {
                        vErrors = [err41];
                      } else {
                        vErrors.push(err41);
                      }
                      errors++;
                    }
                  } else {
                    const err42 = { instancePath: instancePath + "/plan/rows/" + i0 + "/amount", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/amount/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                    if (vErrors === null) {
                      vErrors = [err42];
                    } else {
                      vErrors.push(err42);
                    }
                    errors++;
                  }
                }
                if (data14.justification !== void 0) {
                  if (typeof data14.justification !== "string") {
                    const err43 = { instancePath: instancePath + "/plan/rows/" + i0 + "/justification", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/justification/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err43];
                    } else {
                      vErrors.push(err43);
                    }
                    errors++;
                  }
                }
                if (data14.analogReference !== void 0) {
                  if (typeof data14.analogReference !== "string") {
                    const err44 = { instancePath: instancePath + "/plan/rows/" + i0 + "/analogReference", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/analogReference/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err44];
                    } else {
                      vErrors.push(err44);
                    }
                    errors++;
                  }
                }
                if (data14.materials !== void 0) {
                  if (typeof data14.materials !== "string") {
                    const err45 = { instancePath: instancePath + "/plan/rows/" + i0 + "/materials", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/materials/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err45];
                    } else {
                      vErrors.push(err45);
                    }
                    errors++;
                  }
                }
                if (data14.notes !== void 0) {
                  if (typeof data14.notes !== "string") {
                    const err46 = { instancePath: instancePath + "/plan/rows/" + i0 + "/notes", schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/properties/notes/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err46];
                    } else {
                      vErrors.push(err46);
                    }
                    errors++;
                  }
                }
              } else {
                const err47 = { instancePath: instancePath + "/plan/rows/" + i0, schemaPath: "#/definitions/TreatmentPlan/properties/rows/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err47];
                } else {
                  vErrors.push(err47);
                }
                errors++;
              }
            }
          } else {
            const err48 = { instancePath: instancePath + "/plan/rows", schemaPath: "#/definitions/TreatmentPlan/properties/rows/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err48];
            } else {
              vErrors.push(err48);
            }
            errors++;
          }
        }
      } else {
        const err49 = { instancePath: instancePath + "/plan", schemaPath: "#/definitions/TreatmentPlan/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err49];
        } else {
          vErrors.push(err49);
        }
        errors++;
      }
    }
  } else {
    const err50 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err50];
    } else {
      vErrors.push(err50);
    }
    errors++;
  }
  validate36.errors = vErrors;
  return errors === 0;
}
var validateOutput13 = validate37;
var schema43 = { "type": "object", "properties": { "severity": { "type": "string", "enum": ["warning", "review"] }, "ruleId": { "type": "string", "description": "`goz:rule:paragraph-<n>` or `goz:rule:section-<letter>-general`. The finding's ruleTitle and citation usually suffice; retrieve the rule only for its legal text." }, "message": { "type": "string" }, "rowIds": { "type": "array", "items": { "type": "string" } }, "citation": { "type": "object", "properties": { "page": { "type": "number" }, "section": { "type": "string" }, "lineText": { "type": "string" } }, "required": ["page"], "additionalProperties": false }, "ruleTitle": { "description": "The cited rule's title; retrieve the rule by ruleId for its legal text.", "type": "string" } }, "required": ["severity", "ruleId", "message", "rowIds", "citation"], "additionalProperties": false };
function validate37(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.findings === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "findings" }, message: "must have required property 'findings'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.warnings === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "warnings" }, message: "must have required property 'warnings'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.reviews === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "reviews" }, message: "must have required property 'reviews'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.object === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.totalEur === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "totalEur" }, message: "must have required property 'totalEur'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.pdf === void 0) {
      const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pdf" }, message: "must have required property 'pdf'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err6 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "findings" || key0 === "warnings" || key0 === "reviews" || key0 === "object" || key0 === "totalEur" || key0 === "pdf" || key0 === "json")) {
        const err7 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.findings !== void 0) {
      let data0 = data.findings;
      if (Array.isArray(data0)) {
        const len0 = data0.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data1 = data0[i0];
          if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
            if (data1.severity === void 0) {
              const err8 = { instancePath: instancePath + "/findings/" + i0, schemaPath: "#/definitions/PlanFinding/required", keyword: "required", params: { missingProperty: "severity" }, message: "must have required property 'severity'" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (data1.ruleId === void 0) {
              const err9 = { instancePath: instancePath + "/findings/" + i0, schemaPath: "#/definitions/PlanFinding/required", keyword: "required", params: { missingProperty: "ruleId" }, message: "must have required property 'ruleId'" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            if (data1.message === void 0) {
              const err10 = { instancePath: instancePath + "/findings/" + i0, schemaPath: "#/definitions/PlanFinding/required", keyword: "required", params: { missingProperty: "message" }, message: "must have required property 'message'" };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if (data1.rowIds === void 0) {
              const err11 = { instancePath: instancePath + "/findings/" + i0, schemaPath: "#/definitions/PlanFinding/required", keyword: "required", params: { missingProperty: "rowIds" }, message: "must have required property 'rowIds'" };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if (data1.citation === void 0) {
              const err12 = { instancePath: instancePath + "/findings/" + i0, schemaPath: "#/definitions/PlanFinding/required", keyword: "required", params: { missingProperty: "citation" }, message: "must have required property 'citation'" };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            for (const key1 in data1) {
              if (!(key1 === "severity" || key1 === "ruleId" || key1 === "message" || key1 === "rowIds" || key1 === "citation" || key1 === "ruleTitle")) {
                const err13 = { instancePath: instancePath + "/findings/" + i0, schemaPath: "#/definitions/PlanFinding/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
            }
            if (data1.severity !== void 0) {
              let data2 = data1.severity;
              if (typeof data2 !== "string") {
                const err14 = { instancePath: instancePath + "/findings/" + i0 + "/severity", schemaPath: "#/definitions/PlanFinding/properties/severity/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
              if (!(data2 === "warning" || data2 === "review")) {
                const err15 = { instancePath: instancePath + "/findings/" + i0 + "/severity", schemaPath: "#/definitions/PlanFinding/properties/severity/enum", keyword: "enum", params: { allowedValues: schema43.properties.severity.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
            }
            if (data1.ruleId !== void 0) {
              if (typeof data1.ruleId !== "string") {
                const err16 = { instancePath: instancePath + "/findings/" + i0 + "/ruleId", schemaPath: "#/definitions/PlanFinding/properties/ruleId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
            }
            if (data1.message !== void 0) {
              if (typeof data1.message !== "string") {
                const err17 = { instancePath: instancePath + "/findings/" + i0 + "/message", schemaPath: "#/definitions/PlanFinding/properties/message/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
            }
            if (data1.rowIds !== void 0) {
              let data5 = data1.rowIds;
              if (Array.isArray(data5)) {
                const len1 = data5.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  if (typeof data5[i1] !== "string") {
                    const err18 = { instancePath: instancePath + "/findings/" + i0 + "/rowIds/" + i1, schemaPath: "#/definitions/PlanFinding/properties/rowIds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err18];
                    } else {
                      vErrors.push(err18);
                    }
                    errors++;
                  }
                }
              } else {
                const err19 = { instancePath: instancePath + "/findings/" + i0 + "/rowIds", schemaPath: "#/definitions/PlanFinding/properties/rowIds/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
            }
            if (data1.citation !== void 0) {
              let data7 = data1.citation;
              if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                if (data7.page === void 0) {
                  const err20 = { instancePath: instancePath + "/findings/" + i0 + "/citation", schemaPath: "#/definitions/PlanFinding/properties/citation/required", keyword: "required", params: { missingProperty: "page" }, message: "must have required property 'page'" };
                  if (vErrors === null) {
                    vErrors = [err20];
                  } else {
                    vErrors.push(err20);
                  }
                  errors++;
                }
                for (const key2 in data7) {
                  if (!(key2 === "page" || key2 === "section" || key2 === "lineText")) {
                    const err21 = { instancePath: instancePath + "/findings/" + i0 + "/citation", schemaPath: "#/definitions/PlanFinding/properties/citation/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err21];
                    } else {
                      vErrors.push(err21);
                    }
                    errors++;
                  }
                }
                if (data7.page !== void 0) {
                  let data8 = data7.page;
                  if (!(typeof data8 == "number" && isFinite(data8))) {
                    const err22 = { instancePath: instancePath + "/findings/" + i0 + "/citation/page", schemaPath: "#/definitions/PlanFinding/properties/citation/properties/page/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                    if (vErrors === null) {
                      vErrors = [err22];
                    } else {
                      vErrors.push(err22);
                    }
                    errors++;
                  }
                }
                if (data7.section !== void 0) {
                  if (typeof data7.section !== "string") {
                    const err23 = { instancePath: instancePath + "/findings/" + i0 + "/citation/section", schemaPath: "#/definitions/PlanFinding/properties/citation/properties/section/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err23];
                    } else {
                      vErrors.push(err23);
                    }
                    errors++;
                  }
                }
                if (data7.lineText !== void 0) {
                  if (typeof data7.lineText !== "string") {
                    const err24 = { instancePath: instancePath + "/findings/" + i0 + "/citation/lineText", schemaPath: "#/definitions/PlanFinding/properties/citation/properties/lineText/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err24];
                    } else {
                      vErrors.push(err24);
                    }
                    errors++;
                  }
                }
              } else {
                const err25 = { instancePath: instancePath + "/findings/" + i0 + "/citation", schemaPath: "#/definitions/PlanFinding/properties/citation/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err25];
                } else {
                  vErrors.push(err25);
                }
                errors++;
              }
            }
            if (data1.ruleTitle !== void 0) {
              if (typeof data1.ruleTitle !== "string") {
                const err26 = { instancePath: instancePath + "/findings/" + i0 + "/ruleTitle", schemaPath: "#/definitions/PlanFinding/properties/ruleTitle/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err26];
                } else {
                  vErrors.push(err26);
                }
                errors++;
              }
            }
          } else {
            const err27 = { instancePath: instancePath + "/findings/" + i0, schemaPath: "#/definitions/PlanFinding/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          }
        }
      } else {
        const err28 = { instancePath: instancePath + "/findings", schemaPath: "#/properties/findings/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
    }
    if (data.warnings !== void 0) {
      let data12 = data.warnings;
      if (!(typeof data12 == "number" && (!(data12 % 1) && !isNaN(data12)) && isFinite(data12))) {
        const err29 = { instancePath: instancePath + "/warnings", schemaPath: "#/properties/warnings/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err29];
        } else {
          vErrors.push(err29);
        }
        errors++;
      }
      if (typeof data12 == "number" && isFinite(data12)) {
        if (data12 > 9007199254740991 || isNaN(data12)) {
          const err30 = { instancePath: instancePath + "/warnings", schemaPath: "#/properties/warnings/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err30];
          } else {
            vErrors.push(err30);
          }
          errors++;
        }
        if (data12 < 0 || isNaN(data12)) {
          const err31 = { instancePath: instancePath + "/warnings", schemaPath: "#/properties/warnings/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
          if (vErrors === null) {
            vErrors = [err31];
          } else {
            vErrors.push(err31);
          }
          errors++;
        }
      }
    }
    if (data.reviews !== void 0) {
      let data13 = data.reviews;
      if (!(typeof data13 == "number" && (!(data13 % 1) && !isNaN(data13)) && isFinite(data13))) {
        const err32 = { instancePath: instancePath + "/reviews", schemaPath: "#/properties/reviews/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err32];
        } else {
          vErrors.push(err32);
        }
        errors++;
      }
      if (typeof data13 == "number" && isFinite(data13)) {
        if (data13 > 9007199254740991 || isNaN(data13)) {
          const err33 = { instancePath: instancePath + "/reviews", schemaPath: "#/properties/reviews/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err33];
          } else {
            vErrors.push(err33);
          }
          errors++;
        }
        if (data13 < 0 || isNaN(data13)) {
          const err34 = { instancePath: instancePath + "/reviews", schemaPath: "#/properties/reviews/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
          if (vErrors === null) {
            vErrors = [err34];
          } else {
            vErrors.push(err34);
          }
          errors++;
        }
      }
    }
    if (data.object !== void 0) {
      let data14 = data.object;
      if (typeof data14 !== "string") {
        const err35 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err35];
        } else {
          vErrors.push(err35);
        }
        errors++;
      }
      if ("plan_export" !== data14) {
        const err36 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "plan_export" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err36];
        } else {
          vErrors.push(err36);
        }
        errors++;
      }
    }
    if (data.totalEur !== void 0) {
      let data15 = data.totalEur;
      if (!(typeof data15 == "number" && isFinite(data15))) {
        const err37 = { instancePath: instancePath + "/totalEur", schemaPath: "#/properties/totalEur/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err37];
        } else {
          vErrors.push(err37);
        }
        errors++;
      }
    }
    if (data.pdf !== void 0) {
      let data16 = data.pdf;
      if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
        if (data16.object === void 0) {
          const err38 = { instancePath: instancePath + "/pdf", schemaPath: "#/definitions/FileReference/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
          if (vErrors === null) {
            vErrors = [err38];
          } else {
            vErrors.push(err38);
          }
          errors++;
        }
        if (data16.path === void 0) {
          const err39 = { instancePath: instancePath + "/pdf", schemaPath: "#/definitions/FileReference/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
          if (vErrors === null) {
            vErrors = [err39];
          } else {
            vErrors.push(err39);
          }
          errors++;
        }
        for (const key3 in data16) {
          if (!(key3 === "object" || key3 === "path")) {
            const err40 = { instancePath: instancePath + "/pdf", schemaPath: "#/definitions/FileReference/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err40];
            } else {
              vErrors.push(err40);
            }
            errors++;
          }
        }
        if (data16.object !== void 0) {
          let data17 = data16.object;
          if (typeof data17 !== "string") {
            const err41 = { instancePath: instancePath + "/pdf/object", schemaPath: "#/definitions/FileReference/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err41];
            } else {
              vErrors.push(err41);
            }
            errors++;
          }
          if ("file" !== data17) {
            const err42 = { instancePath: instancePath + "/pdf/object", schemaPath: "#/definitions/FileReference/properties/object/const", keyword: "const", params: { allowedValue: "file" }, message: "must be equal to constant" };
            if (vErrors === null) {
              vErrors = [err42];
            } else {
              vErrors.push(err42);
            }
            errors++;
          }
        }
        if (data16.path !== void 0) {
          if (typeof data16.path !== "string") {
            const err43 = { instancePath: instancePath + "/pdf/path", schemaPath: "#/definitions/FileReference/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err43];
            } else {
              vErrors.push(err43);
            }
            errors++;
          }
        }
      } else {
        const err44 = { instancePath: instancePath + "/pdf", schemaPath: "#/definitions/FileReference/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err44];
        } else {
          vErrors.push(err44);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      let data19 = data.json;
      if (data19 && typeof data19 == "object" && !Array.isArray(data19)) {
        if (data19.object === void 0) {
          const err45 = { instancePath: instancePath + "/json", schemaPath: "#/definitions/FileReference/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
          if (vErrors === null) {
            vErrors = [err45];
          } else {
            vErrors.push(err45);
          }
          errors++;
        }
        if (data19.path === void 0) {
          const err46 = { instancePath: instancePath + "/json", schemaPath: "#/definitions/FileReference/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
          if (vErrors === null) {
            vErrors = [err46];
          } else {
            vErrors.push(err46);
          }
          errors++;
        }
        for (const key4 in data19) {
          if (!(key4 === "object" || key4 === "path")) {
            const err47 = { instancePath: instancePath + "/json", schemaPath: "#/definitions/FileReference/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err47];
            } else {
              vErrors.push(err47);
            }
            errors++;
          }
        }
        if (data19.object !== void 0) {
          let data20 = data19.object;
          if (typeof data20 !== "string") {
            const err48 = { instancePath: instancePath + "/json/object", schemaPath: "#/definitions/FileReference/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err48];
            } else {
              vErrors.push(err48);
            }
            errors++;
          }
          if ("file" !== data20) {
            const err49 = { instancePath: instancePath + "/json/object", schemaPath: "#/definitions/FileReference/properties/object/const", keyword: "const", params: { allowedValue: "file" }, message: "must be equal to constant" };
            if (vErrors === null) {
              vErrors = [err49];
            } else {
              vErrors.push(err49);
            }
            errors++;
          }
        }
        if (data19.path !== void 0) {
          if (typeof data19.path !== "string") {
            const err50 = { instancePath: instancePath + "/json/path", schemaPath: "#/definitions/FileReference/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err50];
            } else {
              vErrors.push(err50);
            }
            errors++;
          }
        }
      } else {
        const err51 = { instancePath: instancePath + "/json", schemaPath: "#/definitions/FileReference/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err51];
        } else {
          vErrors.push(err51);
        }
        errors++;
      }
    }
  } else {
    const err52 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err52];
    } else {
      vErrors.push(err52);
    }
    errors++;
  }
  validate37.errors = vErrors;
  return errors === 0;
}
var validateInput14 = validate38;
function validate38(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.path === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.content === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "content" }, message: "must have required property 'content'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "path" || key0 === "content" || key0 === "mimeType" || key0 === "ifRevision")) {
        const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.path !== void 0) {
      let data0 = data.path;
      if (typeof data0 === "string") {
        if (func2(data0) > 1024) {
          const err3 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/maxLength", keyword: "maxLength", params: { limit: 1024 }, message: "must NOT have more than 1024 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
        if (func2(data0) < 1) {
          const err4 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
      } else {
        const err5 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.content !== void 0) {
      if (typeof data.content !== "string") {
        const err6 = { instancePath: instancePath + "/content", schemaPath: "#/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.mimeType !== void 0) {
      let data2 = data.mimeType;
      if (typeof data2 === "string") {
        if (func2(data2) < 1) {
          const err7 = { instancePath: instancePath + "/mimeType", schemaPath: "#/properties/mimeType/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      } else {
        const err8 = { instancePath: instancePath + "/mimeType", schemaPath: "#/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.ifRevision !== void 0) {
      let data3 = data.ifRevision;
      if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)) && isFinite(data3))) {
        const err9 = { instancePath: instancePath + "/ifRevision", schemaPath: "#/properties/ifRevision/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if (typeof data3 == "number" && isFinite(data3)) {
        if (data3 > 9007199254740991 || isNaN(data3)) {
          const err10 = { instancePath: instancePath + "/ifRevision", schemaPath: "#/properties/ifRevision/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
        if (data3 <= 0 || isNaN(data3)) {
          const err11 = { instancePath: instancePath + "/ifRevision", schemaPath: "#/properties/ifRevision/exclusiveMinimum", keyword: "exclusiveMinimum", params: { comparison: ">", limit: 0 }, message: "must be > 0" };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
      }
    }
  } else {
    const err12 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err12];
    } else {
      vErrors.push(err12);
    }
    errors++;
  }
  validate38.errors = vErrors;
  return errors === 0;
}
var validateOutput14 = validate39;
var schema48 = { "type": "object", "properties": { "object": { "type": "string", "const": "file" }, "path": { "type": "string" }, "mimeType": { "type": "string" }, "size": { "type": "integer", "minimum": 0, "maximum": 9007199254740991 }, "contentHash": { "type": "string", "description": "SHA-256 of the content." }, "revision": { "type": "integer", "exclusiveMinimum": 0, "maximum": 9007199254740991 }, "metadata": { "type": "object", "propertyNames": { "type": "string" }, "additionalProperties": { "anyOf": [{ "type": "string" }, { "type": "number" }, { "type": "boolean" }, { "type": "null" }] } }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "updatedAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" } }, "required": ["object", "path", "mimeType", "size", "contentHash", "revision", "metadata", "createdAt", "updatedAt"], "additionalProperties": false };
function validate39(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.path === void 0) {
      const err1 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.mimeType === void 0) {
      const err2 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "mimeType" }, message: "must have required property 'mimeType'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.size === void 0) {
      const err3 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "size" }, message: "must have required property 'size'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.contentHash === void 0) {
      const err4 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "contentHash" }, message: "must have required property 'contentHash'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.revision === void 0) {
      const err5 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property 'revision'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.metadata === void 0) {
      const err6 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "metadata" }, message: "must have required property 'metadata'" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.createdAt === void 0) {
      const err7 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.updatedAt === void 0) {
      const err8 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "updatedAt" }, message: "must have required property 'updatedAt'" };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!func4.call(schema48.properties, key0)) {
        const err9 = { instancePath, schemaPath: "#/definitions/File/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err10 = { instancePath: instancePath + "/object", schemaPath: "#/definitions/File/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if ("file" !== data0) {
        const err11 = { instancePath: instancePath + "/object", schemaPath: "#/definitions/File/properties/object/const", keyword: "const", params: { allowedValue: "file" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.path !== void 0) {
      if (typeof data.path !== "string") {
        const err12 = { instancePath: instancePath + "/path", schemaPath: "#/definitions/File/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.mimeType !== void 0) {
      if (typeof data.mimeType !== "string") {
        const err13 = { instancePath: instancePath + "/mimeType", schemaPath: "#/definitions/File/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.size !== void 0) {
      let data3 = data.size;
      if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)) && isFinite(data3))) {
        const err14 = { instancePath: instancePath + "/size", schemaPath: "#/definitions/File/properties/size/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
      if (typeof data3 == "number" && isFinite(data3)) {
        if (data3 > 9007199254740991 || isNaN(data3)) {
          const err15 = { instancePath: instancePath + "/size", schemaPath: "#/definitions/File/properties/size/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (data3 < 0 || isNaN(data3)) {
          const err16 = { instancePath: instancePath + "/size", schemaPath: "#/definitions/File/properties/size/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
      }
    }
    if (data.contentHash !== void 0) {
      if (typeof data.contentHash !== "string") {
        const err17 = { instancePath: instancePath + "/contentHash", schemaPath: "#/definitions/File/properties/contentHash/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.revision !== void 0) {
      let data5 = data.revision;
      if (!(typeof data5 == "number" && (!(data5 % 1) && !isNaN(data5)) && isFinite(data5))) {
        const err18 = { instancePath: instancePath + "/revision", schemaPath: "#/definitions/File/properties/revision/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
      if (typeof data5 == "number" && isFinite(data5)) {
        if (data5 > 9007199254740991 || isNaN(data5)) {
          const err19 = { instancePath: instancePath + "/revision", schemaPath: "#/definitions/File/properties/revision/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (data5 <= 0 || isNaN(data5)) {
          const err20 = { instancePath: instancePath + "/revision", schemaPath: "#/definitions/File/properties/revision/exclusiveMinimum", keyword: "exclusiveMinimum", params: { comparison: ">", limit: 0 }, message: "must be > 0" };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
      }
    }
    if (data.metadata !== void 0) {
      let data6 = data.metadata;
      if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
        for (const key1 in data6) {
          const _errs17 = errors;
          if (typeof key1 !== "string") {
            const err21 = { instancePath: instancePath + "/metadata", schemaPath: "#/definitions/File/properties/metadata/propertyNames/type", keyword: "type", params: { type: "string" }, message: "must be string", propertyName: key1 };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
          var valid2 = _errs17 === errors;
          if (!valid2) {
            const err22 = { instancePath: instancePath + "/metadata", schemaPath: "#/definitions/File/properties/metadata/propertyNames", keyword: "propertyNames", params: { propertyName: key1 }, message: "property name must be valid" };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
        }
        for (const key2 in data6) {
          let data7 = data6[key2];
          const _errs21 = errors;
          let valid4 = false;
          const _errs22 = errors;
          if (typeof data7 !== "string") {
            const err23 = { instancePath: instancePath + "/metadata/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/definitions/File/properties/metadata/additionalProperties/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
          var _valid0 = _errs22 === errors;
          valid4 = valid4 || _valid0;
          if (!valid4) {
            const _errs24 = errors;
            if (!(typeof data7 == "number" && isFinite(data7))) {
              const err24 = { instancePath: instancePath + "/metadata/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/definitions/File/properties/metadata/additionalProperties/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
              if (vErrors === null) {
                vErrors = [err24];
              } else {
                vErrors.push(err24);
              }
              errors++;
            }
            var _valid0 = _errs24 === errors;
            valid4 = valid4 || _valid0;
            if (!valid4) {
              const _errs26 = errors;
              if (typeof data7 !== "boolean") {
                const err25 = { instancePath: instancePath + "/metadata/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/definitions/File/properties/metadata/additionalProperties/anyOf/2/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                if (vErrors === null) {
                  vErrors = [err25];
                } else {
                  vErrors.push(err25);
                }
                errors++;
              }
              var _valid0 = _errs26 === errors;
              valid4 = valid4 || _valid0;
              if (!valid4) {
                const _errs28 = errors;
                if (data7 !== null) {
                  const err26 = { instancePath: instancePath + "/metadata/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/definitions/File/properties/metadata/additionalProperties/anyOf/3/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err26];
                  } else {
                    vErrors.push(err26);
                  }
                  errors++;
                }
                var _valid0 = _errs28 === errors;
                valid4 = valid4 || _valid0;
              }
            }
          }
          if (!valid4) {
            const err27 = { instancePath: instancePath + "/metadata/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/definitions/File/properties/metadata/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          } else {
            errors = _errs21;
            if (vErrors !== null) {
              if (_errs21) {
                vErrors.length = _errs21;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err28 = { instancePath: instancePath + "/metadata", schemaPath: "#/definitions/File/properties/metadata/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
    }
    if (data.createdAt !== void 0) {
      let data8 = data.createdAt;
      if (typeof data8 === "string") {
        if (!pattern0.test(data8)) {
          const err29 = { instancePath: instancePath + "/createdAt", schemaPath: "#/definitions/File/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err29];
          } else {
            vErrors.push(err29);
          }
          errors++;
        }
        if (!formats0.validate(data8)) {
          const err30 = { instancePath: instancePath + "/createdAt", schemaPath: "#/definitions/File/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err30];
          } else {
            vErrors.push(err30);
          }
          errors++;
        }
      } else {
        const err31 = { instancePath: instancePath + "/createdAt", schemaPath: "#/definitions/File/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err31];
        } else {
          vErrors.push(err31);
        }
        errors++;
      }
    }
    if (data.updatedAt !== void 0) {
      let data9 = data.updatedAt;
      if (typeof data9 === "string") {
        if (!pattern0.test(data9)) {
          const err32 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/definitions/File/properties/updatedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err32];
          } else {
            vErrors.push(err32);
          }
          errors++;
        }
        if (!formats0.validate(data9)) {
          const err33 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/definitions/File/properties/updatedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err33];
          } else {
            vErrors.push(err33);
          }
          errors++;
        }
      } else {
        const err34 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/definitions/File/properties/updatedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err34];
        } else {
          vErrors.push(err34);
        }
        errors++;
      }
    }
  } else {
    const err35 = { instancePath, schemaPath: "#/definitions/File/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err35];
    } else {
      vErrors.push(err35);
    }
    errors++;
  }
  validate39.errors = vErrors;
  return errors === 0;
}
export {
  validateInput0,
  validateInput1,
  validateInput10,
  validateInput11,
  validateInput12,
  validateInput13,
  validateInput14,
  validateInput2,
  validateInput3,
  validateInput4,
  validateInput5,
  validateInput6,
  validateInput7,
  validateInput8,
  validateInput9,
  validateOutput0,
  validateOutput1,
  validateOutput10,
  validateOutput11,
  validateOutput12,
  validateOutput13,
  validateOutput14,
  validateOutput2,
  validateOutput3,
  validateOutput4,
  validateOutput5,
  validateOutput6,
  validateOutput7,
  validateOutput8,
  validateOutput9
};
